var n = 1,
    selectedImgID,
    editing,
    objId,
    canvas,
    num,
    objNum,
    fabric,
    action,
    Objects,
    activeOb,
    object,
    type,
    line,
    oText,
    sCAle,
    txt,
    font,
    fontSize,
    txtA,
    leftT,
    topT,
    scaleXt,
    scaleYt,
    alignment,
    effect,
    radiusT,
    spacingT,
    reverseT,
    angleT,
    colorBox,
    imgSrc,
    newImg,
    updImg,
    colorRing,
    ringURL,
    ringColor,
    ringAt = 0,
    newRounder = 'ring-0',
    lastModified,
    added = false,
    newlyAd = true,
    base = jQuery('input[name="pro_color"]:checked').attr('data-color'),
    color2 = '#ffea00',
    color3 = '#ffffff',
    objectArray = new Array(),
    cSize = 300,
    padding = 10,
    chipName = jQuery('input[name="chips"]:checked').val(),
    chipURL = jQuery('[for="'+chipName+'"]>span').html(),
    chipURL = chipURL.replaceAll('class','id'),
    undoBtn = document.getElementById('undo'),
    redoBtn = document.getElementById('redo'),
    firstC,
    pageLoader = document.getElementById('pageLoader'),
    underline = document.getElementById('underline'),
    bold = document.getElementById('bold'),
    italic = document.getElementById('italic'),
    curved = document.getElementById('curveRange'),
    curOut = document.getElementById('curveVal'),
    spaced = document.getElementById('spaceRange'),
    spaOut = document.getElementById('spaceVal'),
    cropBtn = jQuery('.cropNow'),
    cropper,
    watermark = jQuery('#waterMark').html(),
    colors_quantity = jQuery('#colorSet_1+.quantityChipColor').html();

/**
 * 
 * fabric.Textbox.prototype._renderText
 * 
 * Extended to reverse order of stroke and filling, to allow for more pleasing
 * stroke.
 * 
 * @see    http://stackoverflow.com/questions/26639132/canvas-fabricjs-separate-stroke-from-text-edge
 * @access private
 * @return void
 */
fabric.Text.prototype._renderText = function(ctx) {
  this._renderTextFill(ctx);
  this._renderTextStroke(ctx);
  this._renderTextFill(ctx);
};

window.addEventListener('load',function onLoad(){
  fabric.Object.prototype.objectCaching = false;
  jQuery('.background-canvas canvas').each(function(){
    canvas = jQuery(this).attr('id');
    num = canvas.replace('canvas_','');
    
    id = 'obj_1';
    window['textImage'+num+'_'+id]	= [];
    window['curvedTxt'+num+'_'+id]	= [];
    window['chipRing'+num]	= [];
    
    //--RedoArrys
    window['re_universal'+num]	= [];
    window['re_cColor'+num]		= [];
    window['re_overlayBg'+num]	= [];
    window['re_canvasBgd'+num]	= [];
    window['re_chipRing'+num]	= [];
    window['re_curvedTxt'+num+'_'+id]	= [];
    window['re_textImage'+num+'_'+id]	= [];

    
    window['canv_'+num] = window._canvas = new fabric.Canvas('canvas_'+num,{
      width: cSize,
      height: cSize,
      backgroundColor: '#FFFFFF',
      preserveObjectStacking: true,
      selection: true,
      allowTouchScrolling: false,
      controlsAboveOverlay:true,
      isTouchSupported: false
    });
    window['canv_'+num].selection = false;
    base = '#000000';
    addShape(num,base);
    addModify(num);
    canvasBlock(num);
    window['universal'+num]	= ['type: bckgrnd'+num];
    window['overlayBg'+num]	= ['spot_8'];
    window['canvasBgd'+num]	= ['#FFFFFF'];
    window['cColor'+num]	= ['#000000'];
    window['ring_'+num]		= fabric.util.groupSVGElements();
    window['canv_'+num].add(window['ring_'+num]);
    window['canv_'+num].remove(window['ring_'+num]);
    window['ring_'+num]		= fabric.util.groupSVGElements();
  });
  jQuery('.lower-canvas').each(function(){
    var its   = jQuery(this),
        itsID = its.attr('id');
    its.parent('.canvas-container').addClass(itsID);
  });
  jQuery('.canvas-container.canvas_2').addClass('active');
  jQuery('.customColors').each(function(){
    colorBox = jQuery(this).attr('id');
    loadColorPicker(colorBox);
  });
  checkChipColor(chipName);
  setTimeout(function(){
    if(jQuery('.non-custom').length > 0){
      jQuery('#spot_12').prop('checked',true).change();
      jQuery('#spot_8').prop('checked',true).change();
    }
    jQuery('input[name="flip"]#front').trigger('click');
    jQuery('.galleryOuter .overloaded').attr('style','z-index:-1;opacity:0');
    pageLoader.style.display = 'none';
    tooltip();
  },500);
});

jQuery(function(){
  jQuery(window).scroll(sticktothetop);
  sticktothetop();
});

jQuery(window).resize(function(num){
  jQuery('.background-canvas .lower-canvas').each(function(){
    canvas = jQuery(this).attr('id');
    num = canvas.replace('canvas_','');
    canvasBlock(num);
  });
});

jQuery(document).on('click','.galleryOuter .overloaded',function(){
  jQuery(this).attr('style','z-index:-1;opacity:0');
  setTimeout(function(){
    jQuery('input[name="flip"]#front').trigger('click');
  },10);
});

jQuery(document).on('change','input[name="flip"]',function(){
  var itsVal = jQuery(this).val();
  jQuery('.loading').show();
  jQuery('#lineColor').parent().addClass('hide');
  jQuery('#ringColor').parent().addClass('hide');
  jQuery('#qrMaker').parent().addClass('hide');
  jQuery('#qrMakerB').parent().addClass('hide');
  jQuery('#bgColor').parent().removeClass('hide');
  canvas = jQuery('.background-canvas .active .lower-canvas').attr('id');
  num = canvas.replace('canvas_','');
  window['canv_'+num].discardActiveObject().renderAll();
  jQuery('.canvas-container').removeClass('active');
  objectArray.splice(0, objectArray.length);
  jQuery('.lyersBlock').html('');
  if(itsVal === 'front'){
    jQuery('.canvas-container.canvas_1').addClass('active');
    if(jQuery('.canvas-container.canvas_1').hasClass('doQR')){
      jQuery('#qrMaker').parent().removeClass('hide');
    }
    if(jQuery('.canvas-container.canvas_1').hasClass('doQRB')){
      jQuery('#qrMakerB').parent().removeClass('hide');
    }
    if(jQuery('.canvas-container.canvas_1').hasClass('hideBackG')){
      jQuery('#bgColor').parent().addClass('hide');
    }
    if(jQuery('.canvas-container.canvas_1').hasClass('hideRingS')){
      jQuery('#ringColor').parent().addClass('hide');
    }
    if(jQuery('.canvas-container.canvas_1').hasClass('showLineC')){
      jQuery('#lineColor').parent().removeClass('hide');
    }
  }else{
    jQuery('.canvas-container.canvas_2').addClass('active');
    if(jQuery('.canvas-container.canvas_2').hasClass('doQR')){
      jQuery('#qrMaker').parent().removeClass('hide');
    }
    if(jQuery('.canvas-container.canvas_2').hasClass('doQRB')){
      jQuery('#qrMakerB').parent().removeClass('hide');
    }
    if(jQuery('.canvas-container.canvas_2').hasClass('hideBackG')){
      jQuery('#bgColor').parent().addClass('hide');
    }
    if(jQuery('.canvas-container.canvas_2').hasClass('hideRingS')){
      jQuery('#ringColor').parent().addClass('hide');
    }
    if(jQuery('.canvas-container.canvas_2').hasClass('showLineC')){
      jQuery('#lineColor').parent().removeClass('hide');
    }
  }
  setTimeout(function(){
    canvas = jQuery('.background-canvas .active .lower-canvas').attr('id');
    num = canvas.replace('canvas_','');
    
    //setTimeout(function(){
      Objects = window['canv_'+num].getObjects();
      Objects.forEach(function(object){
        type = object.type;
        if(type === 'curvedText' || type === 'text'){
          txt = object.text;
          object.setText('1234');
          object.setCoords();
          window['canv_'+num].renderAll();
          object.setText(txt);
          object.setCoords();
          window['canv_'+num].renderAll();
        }
      });
    //},100);
    
    reArrangeLayers(num);
    
    base = window['canv_'+num].backgroundColor;
    colorBox = jQuery('#bgColor .currentColor').val();
    if(colorBox != base){
      jQuery('#bgColor .currentColor').val(base);
      jQuery('#bgColor .currentColor+.colorBox').css('backgroundColor',base);
    }
    jQuery('#ring_3').prop('checked',true);
    if(window['ring_'+num].paths.length){
      //jQuery('.radio_rounder').removeClass('hide');
      jQuery('#ring_1').prop('checked',true);
      jQuery('#ringColor').parent().removeClass('hide');
      ringColor = window['ring_'+num].paths[0].fill;
      colorRing = jQuery('#ringColor .currentColor').val();
      if(ringColor != colorRing){
        jQuery('#ringColor .currentColor').val(ringColor);
        jQuery('#ringColor .currentColor+.colorBox').css('backgroundColor',ringColor);
      }
      if(window['ring_'+num].paths[1]){
        jQuery('#ring_2').prop('checked',true);
      }
      if(jQuery('.canvas-container.canvas_'+num).hasClass('hideRingS')){
        jQuery('#ringColor').parent().addClass('hide');
      }
    }
  },50);
  setTimeout(function(){
    checkLock();
    if(window['universal'+num].length < 2){
      jQuery('#undo').prop('disabled', true);
    }else{
      jQuery('#undo').prop('disabled', false);
    }
    jQuery('.loading').hide();
  },100);
});

jQuery(document).on('change','input[name="chips"]',function(){
  chipName = jQuery(this).val();
  var chipType = jQuery(this).attr('data-variant');
  checkChipColor(chipName);
  updatePopQue();
  pricingMain(chipType);
  jQuery('input[name="pro_color"]#black').prop('checked',true);
  base = jQuery('input[name="pro_color"]#black').attr('data-color');
  if(jQuery('.non-custom').length > 0){
    jQuery('.slick-current .product-single__thumbnail-image').each(function(){
      var colorTag = jQuery(this).attr('data-tag'),
          colorTag = colorTag.split(', ').pop(),
          colorName = colorTag.replace('color-','');
      jQuery('input[name="pro_color"]#'+colorName).prop('checked',true);
      base = jQuery('input[name="pro_color"]#'+colorName).attr('data-color');
    });
  }
  jQuery('.loading').show();
  jQuery('.background-canvas .lower-canvas').each(function(){
    canvas = jQuery(this).attr('id');
    num = canvas.replace('canvas_','');
    activeOb = window['canv_'+num].getActiveObject();
    if(activeOb){
      window['canv_'+num].discardActiveObject();
      window['canv_'+num].renderAll();
    }
    window['canv_'+num].renderAll();
    addShape(num,base);
    object = 'overlayImage';
    undoBtn.setAttribute('data-first','');
    onObjectModified(num,object);
    if(activeOb){
      window['canv_'+num].setActiveObject(activeOb);
      window['canv_'+num].renderAll();
    }
  });
  undoBtn.removeAttribute('data-overlay');
  jQuery('#undo').prop('disabled', false);
  jQuery('.loading').hide();
  if(jQuery('.non-custom').length > 0){
    jQuery('.ncQueBox').each(function(){
      jQuery(this).val('0').change();
    });
  }
});

jQuery(document).on('change','input[name="pro_color"]',function(){
  var colorName = jQuery(this).attr('id');
  base = jQuery(this).attr('data-color');
  jQuery('.loading').show();
  updateChipColor(base);
  jQuery('.background-canvas .lower-canvas').each(function(){
    canvas = jQuery(this).attr('id');
    num = canvas.replace('canvas_','');
    activeOb = 'overlayChipColor';
    undoBtn.setAttribute('data-first','');
    onObjectModified(num,activeOb);
    if(jQuery('.custom-Set').length > 0){
      if(window['ring_'+num].paths.length){
        window['ring_'+num].paths[0].set({
          fill: base
        });
        window['canv_'+num].renderAll();
      }
    }
  });
  undoBtn.removeAttribute('data-chip');
  jQuery('#undo').prop('disabled', false);
  jQuery('#colorSet_1').css('background-color',base);
  jQuery('.quantityChipColor').each(function(){
    jQuery(this).find('.color_BAX').each(function(){
      jQuery(this).removeClass('active');
    });
    jQuery(this).find('input[data-color="'+base+'"]').parent('.color_BAX').addClass('active');
  });
  if(jQuery('.non-custom').length > 0){
    imgSrc  = jQuery('.non-custom .product-single__thumbnail-image[data-tag="color-'+colorName+'"]').attr('src');
    Objects = window['canv_1'].getObjects();
    Objects.forEach(function(obj){
      activeOb = obj.type;
      if(activeOb === 'image'){
        var left = obj.left;
        obj.setSrc(imgSrc);
        obj.setLeft(5);
        obj.setCoords();
        window['canv_1'].renderAll();
        setTimeout(function(){
          obj.setLeft(left);
          obj.setCoords();
          window['canv_1'].renderAll();
        },100);
      }
      window['canv_1'].renderAll();
    });
    jQuery('.non-custom .product-single__thumbnail-image[data-tag="color-'+colorName+'"]').trigger('click');
  }
  jQuery('.loading').hide();
});

jQuery(document).on('change','.quantityBlock input[type="radio"]',function(){
  base = jQuery(this).attr('data-color');
  jQuery('.quantityBlocks .quantityBlock>td.active>.colorBox').css('background-color',base);
});

jQuery(document).on('change','input[name="rounders"]',function(){
  newRounder = jQuery(this).val();
  ringURL = jQuery(this).next('label').find('span').html();
  ringAt = 0;
  jQuery('.loading').show();
  jQuery('.background-canvas .active .lower-canvas').each(function(){
    canvas = jQuery(this).attr('id');
    num = canvas.replace('canvas_','');
    Objects = window['canv_'+num].getObjects();
    activeOb = window['canv_'+num].getActiveObject();
    ringColor = '#a01c34';
    jQuery('#ringColor').parent().css('display','none');
    if(window['ring_'+num].paths.length){
      ringColor = window['ring_'+num].paths[0].fill;
      var i = 0;
    }
    Objects.forEach(function(obj,i){
      object = obj.type;
      if(object === 'image'){
        ringAt = 1;
      }
      i++;
    });
    window['canv_'+num].remove(window['ring_'+num]);
    window['ring_'+num] = fabric.util.groupSVGElements();
    if(activeOb){
      window['canv_'+num].discardActiveObject();
      window['canv_'+num].renderAll();
    }
    if(newRounder != 'ring-0'){
      addRing(num,ringColor);
      jQuery('#ringColor .currentColor').val(ringColor);
      jQuery('#ringColor .currentColor+.colorBox').css('backgroundColor',ringColor);
      jQuery('#ringColor').parent().css('display','inline-block');
    }else if(newRounder == 'ring-0'){
      added = true;
      object = window['ring_'+num];
      onObjectModified(num,object);
    }
    undoBtn.setAttribute('data-first','');
    if(activeOb){
      window['canv_'+num].setActiveObject(activeOb);
      window['canv_'+num].renderAll();
    }
  });
  undoBtn.removeAttribute('data-overlay');
  jQuery('#undo').prop('disabled', false);
  jQuery('.loading').hide();
});

jQuery(document).on('click','#addNewText',function(){
  canvas = jQuery('.background-canvas .active .lower-canvas').attr('id');
  num = canvas.replace('canvas_','');
  txt = 'Hello';
  font = "'Arial',sans-serif";
  fontSize = '36';
  txtA = 'left';
  oText = new fabric.Text(txt,{
    id: 'obj_'+n,
    originX: 'center',
    originY: 'center',
    left: cSize/2,
    top: cSize/2,
    fontFamily: font,
    fontSize: fontSize,
    textAlign: txtA
  });
  window['canv_'+num].add(oText);
  objectArray.push(oText);
  n++;
  window['canv_'+num].setActiveObject(oText);
  oText.setCoords();
  object = oText;
  objNum = window['canv_'+num].getObjects().length - 1;
  setTimeout(function(){
    updateLayers(object,num,objNum);
  },50);
  window['canv_'+num].renderAll();
});

jQuery(document).on('keyup','.text_box',function(){
  txt = jQuery(this).val();
  canvas = jQuery('.background-canvas .active .lower-canvas').attr('id');
  num = canvas.replace('canvas_','');
  activeOb = window['canv_'+num].getActiveObject();
  if(activeOb){
    sCAle = activeOb.scaleX;
    type = activeOb.get('type');
    if(type === 'text' || type === 'curvedText'){
      activeOb.setText(txt);
    }
    if(txt.length > 9){
      txt = txt.substr(0,9) + '...';
    }
    jQuery('.layerObject.active>div>span').text(txt);
    activeOb.scaleX = .5;
    activeOb.setCoords();
    window['canv_'+num].renderAll();
    activeOb.scaleX = sCAle;
    activeOb.setCoords();
    window['canv_'+num].renderAll();
    undoBtn.setAttribute('data-first','');
    onObjectModified(num,activeOb);
  }
});

jQuery(document).on('change','#fSize',function(){
  fontSize = jQuery(this).val();
  canvas = jQuery('.background-canvas .active .lower-canvas').attr('id');
  num = canvas.replace('canvas_','');
  activeOb = window['canv_'+num].getActiveObject();
  if(activeOb){
    sCAle = activeOb.scaleX;
    type = activeOb.get('type');
    if(type === 'text' || type === 'curvedText'){
      activeOb.set('fontSize',fontSize);
    }
    activeOb.scaleX = .5;
    activeOb.setCoords();
    window['canv_'+num].renderAll();
    activeOb.scaleX = sCAle;
    activeOb.setCoords();
    window['canv_'+num].renderAll();
    undoBtn.setAttribute('data-first','');
    onObjectModified(num,activeOb);
  }
});

jQuery(document).on('change','#fontFamily',function(){
  font = jQuery(this).val();
  canvas = jQuery('.background-canvas .active .lower-canvas').attr('id');
  num = canvas.replace('canvas_','');
  activeOb = window['canv_'+num].getActiveObject();
  if(activeOb){
    sCAle = activeOb.scaleX;
    type = activeOb.get('type');
    if(type === 'text' || type === 'curvedText'){
      activeOb.set('fontFamily',font);
    }
    activeOb.scaleX = .5;
    activeOb.setCoords();
    window['canv_'+num].renderAll();
    activeOb.scaleX = sCAle;
    activeOb.setCoords();
    window['canv_'+num].renderAll();
    object = activeOb;
    undoBtn.setAttribute('data-first','');
    onObjectModified(num,object);
  }
});

jQuery(document).on('change','#effect',function(e){
  e.preventDefault();
  effect 	= jQuery(this).val();
  canvas 	= jQuery('.background-canvas .active .lower-canvas').attr('id');
  num 		= canvas.replace('canvas_','');
  Objects 	= window['canv_'+num].getObjects();
  object 	= window['canv_'+num].getActiveObject();
  objId  	= object.id;
  txt 	  	= object.text;
  base 	  	= object.fill;
  font 	  	= object.fontFamily;
  fontSize  = object.fontSize;
  bold 	  	= object.fontWeight;
  italic 	= object.fontStyle;
  underline = object.textDecoration;
  leftT 	= object.left;
  topT 	  	= object.top;
  scaleXt   = object.scaleX;
  scaleYt   = object.scaleY;
  angleT	= object.angle;
  var updateLayers = jQuery('.lyersBlock.ui-sortable').html(),
      index = objectArray.findIndex((el) => el.id === objId);
  oText = '';
  if(effect === 'curved'){
    jQuery('.curveRegistered').show();
    jQuery('#tAlignments').hide();
    oText = new fabric.CurvedText(txt,{
      id: objId,
      originX: 'center',
      originY: 'center',
      textAlign: 'center',
      effect: 'curved',
      top:topT,
      left:leftT,
      fontFamily: font,
      fontSize: fontSize,
      fill: base,
      scaleX: scaleXt,
      scaleY: scaleYt,
      angle: angleT,
      radius: 106,
      spacing: 6
    });
  }else{
    jQuery('.curveRegistered').hide();
    jQuery('#tAlignments').show();
    oText = new fabric.Text(txt,{
      id:objId,
      originX: 'center',
      originY: 'center',
      top:topT,
      left:leftT,
      fontFamily: font,
      fontSize: fontSize,
      fill: base,
      scaleX: scaleXt,
      scaleY: scaleYt,
      angle: angleT
    });
  }
  var i = 0;
  Objects.forEach(function(obj,i){
    activeOb = obj.id;
    if(activeOb === objId){
      window['canv_'+num].insertAt(oText, i, true).renderAll();
    }
    i++;
  });
  objectArray[index] = oText;
  jQuery('.lyersBlock.ui-sortable').html('');
  if(jQuery('.loadedTemp').length){
    setTimeout(function(){
      loadedTemp(num);
    },20);
  }
  setTimeout(function(){
    window['canv_'+num].setActiveObject(oText);
    oText.setCoords();
    window['canv_'+num].renderAll();
  },30);
  setTimeout(function(){
    jQuery('.lyersBlock.ui-sortable').html(updateLayers);
  },60);
});

jQuery(document).on('change','input[name="text-align"]',function(){
  alignment = jQuery(this).val();
  canvas = jQuery('.background-canvas .active .lower-canvas').attr('id');
  num = canvas.replace('canvas_','');
  activeOb = window['canv_'+num].getActiveObject();
  if(activeOb){
    type = activeOb.get('type');
    if(type === 'text' || type === 'curvedText'){
      activeOb.set('textAlign',alignment);
    }
    activeOb.setCoords();
    window['canv_'+num].renderAll();
    object = activeOb;
    undoBtn.setAttribute('data-first','');
    onObjectModified(num,object);
  }
});

jQuery(document).on('change','#curveMind',function(){
  var reversed = jQuery(this).is(':checked'),
      rangeVal = jQuery(curved).val(),
      preVal,
      minVal,
      maxVal,
      dir;
  canvas = jQuery('.background-canvas .active .lower-canvas').attr('id');
  num = canvas.replace('canvas_','');
  activeOb = window['canv_'+num].getActiveObject();
  if(reversed){
    preVal = '-';
    minVal = '250';
    maxVal = '0';
    dir = 'rtl';
  }else{
    preVal = '';
    minVal = '0';
    maxVal = '250';
    dir = '';
  }
  jQuery(curved).attr('min',preVal+minVal);
  jQuery(curved).attr('max',maxVal);
  jQuery(curved).attr('dir',dir);
  rangeVal = preVal+Math.abs(rangeVal);
  jQuery(curved).val(rangeVal);
  curOut.innerHTML = curved.value;
  activeOb.set('reverse',reversed);
  activeOb.setCoords();
  window['canv_'+num].renderAll();
  object = activeOb;
  undoBtn.setAttribute('data-first','');
  onObjectModified(num,object);
});

jQuery(document).on('click','.actionBtns>a',function(){
  if(jQuery(this).parent().hasClass('disabled')){
    return false
  }
  action = jQuery(this).attr('data-obj');
  canvas = jQuery('.background-canvas .active .lower-canvas').attr('id');
  num = canvas.replace('canvas_','');
  activeOb = window['canv_'+num].getActiveObject();
  if(activeOb){
    if(action === 'flip'){
      activeOb.toggle('flipX');
    }if(action === 'alignH'){
      activeOb.left = cSize/2;
    }if(action === 'alignV'){
      activeOb.top = cSize/2;
    }if(action === 'moveL'){
      activeOb.left -= 2;
    }if(action === 'moveR'){
      activeOb.left += 2;
    }if(action === 'moveT'){
      activeOb.top -= 2;
    }if(action === 'moveB'){
      activeOb.top += 2;
    }if(action === 'trash'){
      jQuery('.layerObject.active').remove();
      window['canv_'+num].remove(activeOb);
      objectArray.splice(objectArray.indexOf(activeOb), 1);
    }if(action === 'copy'){
      object = fabric.util.object.clone(activeOb);
      window['canv_'+num].discardActiveObject().renderAll();
      object.set('top', object.top+5);
      object.set('left', object.left+5);
      object.set('id','obj_'+n);
      window['canv_'+num].add(object);
      objectArray.push(object);
      window['canv_'+num].setActiveObject(object);
      n++;
      objNum = window['canv_'+num].getObjects().length - 1;
      updateLayers(object,num,objNum);
    }
    activeOb.setCoords();
    object = activeOb;
    undoBtn.setAttribute('data-first','');
    onObjectModified(num,object);
  }
  window['canv_'+num].renderAll();
});

jQuery(document).on('click','#addImg',function(){
  jQuery('.thePop').each(function(){
    jQuery(this).removeClass('active').hide();
  });
  jQuery('#imagePop').addClass('active').show();
  jQuery('.accordians').addClass('popOpen');
});

jQuery(document).on('change','#up_terms',function(){
  if(jQuery(this).prop('checked')){
    jQuery('#updateNow').removeAttr('disabled');
  }else{
    jQuery('#updateNow').attr('disabled','disabled');
  }
});

jQuery(document).on('click','#editImg',function(){
  canvas = jQuery('.background-canvas .active .lower-canvas').attr('id');
  num = canvas.replace('canvas_','');
  Objects = window['canv_'+num].getObjects();
  Objects.forEach(function(object){
    if(object.type === 'image' && object.selectable === true){
      var selectedId = object.id;
      if(selectedId.indexOf('qrc') === 0){
        //jQuery('#qrMaker').trigger('click');
      }else{
        imgSrc = object._originalElement.currentSrc;
        window['canv_'+num].setActiveObject(object);
      }
    }
  });
  var activatied = window['canv_'+num].getActiveObject();
  if(activatied){
    jQuery('.upload_list_update').html('<li data-for=""><span class="active" for-crop="'+imgSrc+'"><img src="'+imgSrc+'" alt=""></span></li>');
    //cropBtn.show();
    jQuery('#cImagePop').show();
  }
});

jQuery(document).on('click','.upload_list span',function(){
  var thisImg = jQuery(this);
  jQuery('.upload_list li span').each(function(){
    jQuery(this).removeClass('active');
    jQuery(this).find('img').attr('id','');
  });
  thisImg.addClass('active');
  thisImg.find('img').attr('id','exectiveImg');
  var exectiveImg = document.querySelector("#exectiveImg"),
      realWidth = exectiveImg.naturalWidth,
      realHeight = exectiveImg.naturalHeight;
  /*if(realWidth === realHeight){
    cropBtn.hide();
  }else{
    cropBtn.show();
  }*/
  cropBtn.show();
});

jQuery(document).on('click','.cropNow>.btn',function(){
  pageLoader.style.display = 'flex';
  var cropSrc = jQuery(this).parent().prev().find('span.active').attr('for-crop');
  jQuery('#cropImg').attr('src',cropSrc);
  var cropImg = document.getElementById('cropImg');
  jQuery('#cropperModel').show();
  setTimeout(function(){
    cropper = new Cropper(cropImg,{
      aspectRatio: 1 / 1,
      maxContainerWidth: 928,
      maxContainerHeight: 522,
      minCanvasHeight: 330,
      minCanvasWidth: 330,
    });
    pageLoader.style.display = 'none';
  },200);
});

jQuery(document).on('click','.modal_foot>.clear',function(e){
  e.preventDefault();
  jQuery('.cropBox').html('<img id="cropImg" src="" alt="">');
  jQuery('#cropperModel').hide();
});

jQuery(document).on('click','.modal_foot>.apply',function(e){
  e.preventDefault();
  canvas = jQuery('.background-canvas .active .lower-canvas').attr('id');
  num = canvas.replace('canvas_','');
  Objects = window['canv_'+num].getObjects();
  Objects.forEach(function(object){
    var itsId = object.id;
    if(itsId === selectedImgID){
      window['canv_'+num].setActiveObject(object);
    }
  });
  pageLoader.style.display = 'flex';
  var imgSrc = cropper.getCroppedCanvas().toDataURL();
  jQuery('.cropBox').html('<img id="cropImg" src="" alt="">');
  jQuery('.upload_list_update .active>img,.upload_list .active>img').attr('src',imgSrc);
  jQuery('#cropperModel').hide();
  pageLoader.style.display = 'none';
});

jQuery(document).on('click','#uploadNow',function(){
  imgSrc = jQuery('.upload_list li span.active>img').attr('src');
  canvas = jQuery('.background-canvas .active .lower-canvas').attr('id');
  num = canvas.replace('canvas_','');
  if(imgSrc){
    newImg  = new Image();
    newImg.onload = function(){
      var obj = new fabric.Image(newImg,{
        id: 'obj_'+n,
        left: cSize/2,
        top: cSize/2,
        originX: 'center',
        originY: 'center',
        scaleX: 1,
        scaleY: 1
      });
      obj.scaleToWidth(cSize/1.4);
      window['canv_'+num].add(obj);
      obj.setCoords();
      objectArray.push(obj);
      window['canv_'+num].renderAll();
      object = obj;
      objNum = window['canv_'+num].getObjects().length - 1;
      setTimeout(function(){
        updateLayers(object,num,objNum);
        window['canv_'+num].setActiveObject(obj);
        obj.setCoords();
        var preDataFor = jQuery('.upload_list li>span.active').parent().attr('data-for'),
            dataFor = obj.id;
        if(preDataFor != ''){
          dataFor = preDataFor+' '+obj.id;
        }
        jQuery('.upload_list li>span.active').parent().attr('data-for',dataFor);
        n++;
      },50);
    };
    newImg.src = imgSrc;
    window['canv_'+num].renderAll();
    jQuery('.updateImage').show();
  }
});

jQuery(document).on('click','#updateNow',function(){
  if(!jQuery(this).attr('disabled')){
    imgSrc = jQuery('.upload_list_update li span.active>img').attr('src');
    canvas = jQuery('.background-canvas .active .lower-canvas').attr('id');
    num = canvas.replace('canvas_','');
    activeOb = window['canv_'+num].getActiveObject();
    if(activeOb){
      var left = activeOb.left,
          width = activeOb.width;
      activeOb.setSrc(imgSrc);
      activeOb.setLeft(5);
      activeOb.setCoords();
      window['canv_'+num].renderAll();
      setTimeout(function(){
        activeOb.setLeft(left);
        activeOb.setCoords();
        activeOb.setWidth(width);
        activeOb.setHeight(width);
        window['canv_'+num].renderAll();
        activeOb.setCoords();
        window['canv_'+num].renderAll();
        object = activeOb;
        onObjectModified(num,object);
        undoBtn.setAttribute('data-first','');
      },10);
      jQuery('.layerObject.active>div>img').attr('src',imgSrc);
    }
  }
});

jQuery(document).on('click','.dletObj',function(){
  var objectID = jQuery(this).parent().parent().attr('data-for');
  canvas = jQuery('.background-canvas .active .lower-canvas').attr('id');
  num = canvas.replace('canvas_','');
  Objects = window['canv_'+num].getObjects();
  Objects.forEach(function(object){
    var itsId = object.id;
    if(objectID == itsId){
      window['canv_'+num].remove(object).renderAll();
      objectArray.splice(objectArray.indexOf(object), 1);
      jQuery('.lyersBlock .layerObject[data-for="'+objectID+'"]').remove();
    }
  });
  setTimeout(function(){
    activeOb = window['canv_'+num].getActiveObject();
    if(activeOb){
      var actvId = activeOb.id;
      jQuery('.lyersBlock .layerObject[data-for="'+actvId+'"]').addClass('active');
    }
  },50);
});

jQuery(document).on('click','.layerObject',function(){
  var thisObj = jQuery(this);
  objId = thisObj.attr('data-for');
  jQuery('.layerObject').each(function(){
    jQuery(this).removeClass('active');
  });
  thisObj.addClass('active');
  canvas = jQuery('.background-canvas .active .lower-canvas').attr('id');
  num = canvas.replace('canvas_','');
  Objects = window['canv_'+num].getObjects();
  Objects.forEach(function(object){
    var itsId = object.id;
    if(itsId === objId){
      window['canv_'+num].setActiveObject(object);
    }
  });
});

jQuery(document).on('click','#changeText',function(){
  if(!jQuery('.custom-Set').length > 0){}
    canvas = jQuery('.background-canvas .active .lower-canvas').attr('id');
    num = canvas.replace('canvas_','');
    Objects = window['canv_'+num].getObjects();
    Objects.forEach(function(object){
      type = object.type;
      if(type === 'text' || type === 'curvedText'){
        itsId = object.id;
        window['canv_'+num].setActiveObject(object);
        jQuery('.layerObject[data-for="'+itsId+'"]').addClass('active');
        return false
      }
    });
});

jQuery(document).mouseup(function(e){
  var container = jQuery('.workPlace'),
      colorPicker = jQuery('.colorpicker-element'),
      quaColor = jQuery('.quantityBlock.active>td:first-child'),
      quOpen = jQuery('.selectionBOX'),
      quPop = jQuery('#quantityMain');
  canvas = jQuery('.background-canvas .active .lower-canvas').attr('id');
  num = canvas.replace('canvas_','');
  if(container.is(e.target) && container.has(e.target).length === 0){
    activeOb = window['canv_'+num].getActiveObject();
    window['canv_'+num].discardActiveObject().renderAll();
  };
  if(!colorPicker.is(e.target) && colorPicker.has(e.target).length === 0){
    colorPicker.removeClass('active');
    colorPicker.find('.colorpicker').hide();
  }
  if(!quaColor.is(e.target) && quaColor.has(e.target).length === 0){
    quaColor.removeClass('active');
  }
  if(!quOpen.is(e.target) && quOpen.has(e.target).length === 0){
    quOpen.removeClass('opened');
  }
  if(!quPop.is(e.target) && quPop.has(e.target).length === 0){
    quPop.removeClass('focused');
  }
});

jQuery(document).on('click','.previewBtn',function(){
  jQuery('.loading').show();
  var view,rect,flip;
  jQuery('.background-canvas .lower-canvas').each(function(){
    canvas = jQuery(this).attr('id');
    num = canvas.replace('canvas_','');
    activeOb = window['canv_'+num].toSVG();
    if(num === '1'){
      view = jQuery('#previewModel .frnt_view');
      rect = 'frnt';
      flip = 'Front';
    }
    if(num === '2'){
      view = jQuery('#previewModel .back_view');
      rect = 'back';
      flip = 'Back';
    }
    activeOb = activeOb.replaceAll(' id="',' class="');
    activeOb = activeOb.replaceAll('</svg>','');
    activeOb = activeOb + watermark + '</svg>';
    view.html(activeOb);
    view.find('svg').removeAttr('width');
    view.find('svg').removeAttr('height');
    //view.find('svg').append(watermark);
    view.find('desc').remove();
    view.find('defs').remove();
    view.append('<h5>'+flip+' View</h5>');
    jQuery('#previewModel .'+rect+'_view svg rect').attr('x','2');
    jQuery('#previewModel .'+rect+'_view svg rect').attr('y','2');
    jQuery('#previewModel .'+rect+'_view svg rect').attr('width','296');
    jQuery('#previewModel .'+rect+'_view svg rect').attr('height','296');
    jQuery('#previewModel .'+rect+'_view svg g>text:first-child').each(function(){
      var reqText = jQuery(this),
          setStroke = reqText.parent().html(),
          setCode = setStroke + reqText.parent().html();
      reqText.parent().html(setCode);
    });
    jQuery('#previewModel .'+rect+'_view svg g>text:last-child').each(function(){
      var reqText = jQuery(this);
      reqText.css('stroke-width','0');
      reqText.css('stroke','none');
    });
    Objects = window['canv_'+num].getObjects();
    Objects.forEach(function(object){
      type = object.type;
      if(type === 'curvedText' || type === 'text'){
        spacingT = object.charSpacing;
        if(spacingT != 0){
          objId = object.id;
          spacingT = spacingT/11.5;
          jQuery('.previewBox svg .'+objId).find('text').css('letter-spacing',spacingT+'px');
        }
      }
    });
  });
  jQuery('#previewModel').show();
  jQuery('.loading').hide();
});

jQuery(document).on('click','.closeBtn',function(){
  jQuery('.modal_foot>.clear').trigger('click');
  jQuery('.crop_modal').hide();
});

jQuery(document).on('click','.closeTpop',function(){
  canvas = jQuery('.background-canvas .active .lower-canvas').attr('id');
  num = canvas.replace('canvas_','');
  window['canv_'+num].discardActiveObject().renderAll();
  jQuery(this).parent().hide().removeClass('active');
});

jQuery(document).on('change','input[name="quantity"]',function(){
  var quantity = jQuery(this).val(),
      quantSel = jQuery(this).attr('id'),
      quantSel = quantSel.replace('Mob','');
  jQuery('#'+quantSel).val(quantity);
  jQuery('#Mob'+quantSel).val(quantity);
});

curOut.innerHTML = curved.value;

curved.oninput = function(){
  canvas = jQuery('.background-canvas .active .lower-canvas').attr('id');
  num = canvas.replace('canvas_','');
  activeOb = window['canv_'+num].getActiveObject();
  curOut.innerHTML = this.value;
  var raDIus = this.value,
      raDIus = raDIus.replace('-','');
  activeOb.set('radius',raDIus);
  activeOb.setCoords();
  window['canv_'+num].renderAll();
  undoBtn.setAttribute('data-first','');
  onObjectModified(num,activeOb);
};

spaOut.innerHTML = spaced.value;

spaced.oninput = function(){
  canvas = jQuery('.background-canvas .active .lower-canvas').attr('id');
  num = canvas.replace('canvas_','');
  activeOb = window['canv_'+num].getActiveObject();
  spaOut.innerHTML = this.value;
  sCAle = activeOb.scaleX;
  activeOb.set('spacing',this.value);
  activeOb.set('scaleX','.5');
  activeOb.setCoords();
  window['canv_'+num].renderAll();
  activeOb.set('scaleX',sCAle);
  activeOb.setCoords();
  window['canv_'+num].renderAll();
  undoBtn.setAttribute('data-first','');
  onObjectModified(num,activeOb);
};

underline.addEventListener('change',function(){
  dtEditText('underline');
});

bold.addEventListener('change',function(){
  dtEditText('bold');
});

italic.addEventListener('change',function(){
  dtEditText('italic');
});

undoBtn.addEventListener('click',function(){
  canvas = jQuery('.background-canvas .active .lower-canvas').attr('id');
  num = canvas.replace('canvas_','');
  jQuery('#undo').prop('disabled', true);
  jQuery('#redo').prop('disabled', true);
  firstC = undoBtn.getAttribute('data-first');
  undo(num);
});

redoBtn.addEventListener('click',function(){
  canvas = jQuery('.background-canvas .active .lower-canvas').attr('id');
  num = canvas.replace('canvas_','');
  jQuery('#undo').prop('disabled', true);
  jQuery('#redo').prop('disabled', true);
  firstC = undoBtn.getAttribute('data-first');
  redo(num);
});

if(jQuery('#cImagePop').length != 0){
  document.getElementById("uploadCfile").addEventListener("change", updateFile);
}

if(jQuery('#imagePop').length != 0){
  document.getElementById("uploadFile").addEventListener("change", readFile);
}

function dtEditText(action){
  canvas = jQuery('.background-canvas .active .lower-canvas').attr('id');
  num = canvas.replace('canvas_','');
  var o,
      t,
      a = action;
  o = window['canv_'+num].getActiveObject();
  sCAle = o.scaleX;
  if(o){
    t = o.get('type');
  }if(o && t === 'text' || t === 'text-curved' || type === 'curvedText'){
    switch(a){
      case 'bold':				
        var isBold = dtGetStyle(o, 'fontWeight') === 'bold';
        dtSetStyle(o, 'fontWeight', isBold ? '' : 'bold');
        break;

      case 'italic':
        var isItalic = dtGetStyle(o, 'fontStyle') === 'italic';
        dtSetStyle(o, 'fontStyle', isItalic ? '' : 'italic');
        break;

      case 'underline':
        var isUnderline = dtGetStyle(o, 'textDecoration') === 'underline';
        dtSetStyle(o, 'textDecoration', isUnderline ? '' : 'underline');
        break;
    }
  }
  o.scaleX = .5;
  o.setCoords();
  window['canv_'+num].renderAll();
  o.scaleX = sCAle;
  o.setCoords();
  window['canv_'+num].renderAll();
  undoBtn.setAttribute('data-first','');
  onObjectModified(num,o);
}

function dtGetStyle(object,styleName){
  return object[styleName];
}

function dtSetStyle(object,styleName,value){
  object.set(styleName,value);
}

function canvasBlock(num){
  var screenWide = jQuery(window).innerWidth(),
      screenHigh = jQuery(window).innerHeight(),
      newZoomLevel,
      zoom,
      zoom1 = jQuery('.workPlace').innerWidth();
  if(screenWide > screenHigh){
    zoom = screenHigh - 170;
    if(zoom1 < screenHigh){
      zoom = zoom1 - 170;
    }
    if(jQuery('.non-custom').length > 0){
      zoom = zoom1 * .78;
    }
  }else{
    zoom = zoom1 - 40;
  }
  newZoomLevel = zoom / cSize;
  
  setZoomMask(newZoomLevel,num);
}

function setZoomMask(newZoomLevel,num){
  var zoomLevel = newZoomLevel;
  window['canv_'+num].setZoom(zoomLevel);
  window['canv_'+num].setDimensions({
    width: cSize * zoomLevel,
    height: cSize * zoomLevel
  });
  window['canv_'+num].renderAll();
}

function sticktothetop(){
  var window_top = jQuery(window).scrollTop(),
      top = jQuery('#stick-here').offset().top;
  if(window_top > top){
    jQuery('.galleryOuter').addClass('stick').css({'position':'sticky','top':'10px'});
    jQuery('.page-container').css({'overflow':'visible'});
    jQuery('#stick-here').height(1);
  }else{
    jQuery('.galleryOuter').removeClass('stick').attr('style','');
    jQuery('.page-container').attr('style','');
    jQuery('#stick-here').height(8);
  }
}

function updateChipColor(base){
  color2 = '#ffea00';
  color3 = '#ffffff';
  jQuery('.background-canvas .lower-canvas').each(function(){
    canvas = jQuery(this).attr('id');
    num = canvas.replace('canvas_','');
    if(base === '#ffea00'){
      color2 = '#0054a5';
      color3 = '#ffffff';
    }
    if(base === '#fffafa'){
      color2 = '#e30405';
      color3 = '#000000';
    }
    for(var i = 0; i < window['shape_'+num].paths.length; i++){
      var abs = window['shape_'+num].paths[i].id;
      if(abs === 'colored'){
        window['shape_'+num].paths[i].set({
          fill: base
        });
      }
      if(abs === 'second'){
        window['shape_'+num].paths[i].set({
          fill: color2
        });
      }
      if(abs === 'third'){
        window['shape_'+num].paths[i].set({
          fill: color3
        });
      }
      if(abs === 'ring-1'){
        window['shape_'+num].paths[i].set({
          fill: 'rgba(0,0,0,0)'
        });
      }
    }
    window['canv_'+num].renderAll();
  });
}

function addShape(num,base){
  color2 = '#ffea00';
  color3 = '#ffffff';
  var baseChip = jQuery('label[for="'+chipName+'"]').find('span').html();
  jQuery('label[for="'+chipName+'"] span .loadedInBack').remove();
  chipURL = jQuery('label[for="'+chipName+'"]').find('span').html();
  chipURL = chipURL.replaceAll('class','id');
  chipURL = chipURL.replace('viewBox="-5 -5 140 140"','viewBox="0 0 130 130"');
  fabric.loadSVGFromString(chipURL, function(objects,options){
    window['shape_'+num] = fabric.util.groupSVGElements(objects, options);
    for(var i = 0; i < window['shape_'+num].paths.length; i++){
      var afs = window['shape_'+num].paths[i].id;
      if(afs === 'colored'){
        window['shape_'+num].paths[i].set({
          fill: base
        });
      }if(afs === 'second'){
        window['shape_'+num].paths[i].set({
          fill: color2
        });
      }if(afs === 'third'){
        window['shape_'+num].paths[i].set({
          fill: color3
        });
      }if(afs === 'ring-1'){
        window['shape_'+num].paths[i].set({
          fill: 'rgba(0,0,0,0)'
        });
      }if(afs === 'white'){
        window['shape_'+num].paths[i].set({
          fill: 'rgba(0,0,0,0)'
        });
      }
    }
    window['shape_'+num].set({
      left: cSize/2,
      top: cSize/2,
      originX: 'center',
      originY: 'center',
      scaleX: 1,
      scaleY: 1,
      selectable: false,
      evented: false,
      hoverCursor: 'default'
    });
    window['shape_'+num].scaleToWidth(cSize);
    window['canv_'+num].setOverlayImage(window['shape_'+num]);
    window['canv_'+num].renderAll();
  });
  jQuery('label[for="'+chipName+'"]').find('span').html(baseChip);
}

function addRing(num,ringColor){
  fabric.loadSVGFromString(ringURL, function(objects,options){
    window['ring_'+num] = fabric.util.groupSVGElements(objects, options);
    for(var i = 0; i < window['ring_'+num].paths.length; i++){
      var whiteCheck = window['ring_'+num].paths[i].id;
      if(whiteCheck === 'white'){
        window['ring_'+num].paths[i].set({
          fill: window['canv_'+num].backgroundColor
        });
      }else{
        window['ring_'+num].paths[i].set({
          fill: ringColor
        });
      }
    }
    window['ring_'+num].set({
      left: cSize/2,
      top: cSize/2,
      originX: 'center',
      originY: 'center',
      scaleX: 1,
      scaleY: 1,
      selectable: false,
      evented: false,
      hoverCursor: 'default'
    });
    window['ring_'+num].scaleToWidth(cSize);
    window['canv_'+num].insertAt(window['ring_'+num], ringAt).renderAll();
  });
}

function addControls(object){
  var moveIcon 	 = "//sincitychips-com.myshopify.com/cdn/shop/t/3/assets/icon-move.svg?v=81446438627354945921674221055";
  var rotateIcon = "//sincitychips-com.myshopify.com/cdn/shop/t/3/assets/icon-rotate.svg?v=71192169205534407181674221055";
  var trashIcon  = "//sincitychips-com.myshopify.com/cdn/shop/t/3/assets/icon-trash.svg?v=99502090877034413591674221055";
  var resizeIcon = "//sincitychips-com.myshopify.com/cdn/shop/t/3/assets/icon-resize.svg?v=121713525090655281271674221055";
  object.set({
    transparentCorners: false,
    borderColor: '#dedede',
    borderDashArray: [4,2],
    cornerSize: 18,
    cornerStyle: 'pointer',
    _controlsVisibility: {
      bl: true,
      br: true,
      tl: true,
      tr: true,
      mb: false,
      ml: false,
      mr: false,
      mt: false,
      mtr: false
    }
  });
  
  fabric.Canvas.prototype.customiseControls({
    tl: {
      action: 'move',
      cursor: 'move',
      text: 'Move'
    },
    tr: {
      action: 'rotate',
      cursor: 'crosshair',
      text: 'Rotate'
    },
    bl: {
      action: 'remove',
      cursor: 'pointer',
      text: 'Remove'
    },
    br: {
      action: 'scale',
      text: 'Resize'
    }
  });
  fabric.Object.prototype.customiseCornerIcons({
    tl: {
      icon: moveIcon,
    },
    tr: {
      icon: rotateIcon,
    },
    bl: {
      icon: trashIcon,
    },
    br: {
      icon: resizeIcon,
    },
  },function(){
    window['canv_'+num].renderAll();
  });
}

function readFile(){
  if(this.files && this.files[0]){
    var FR= new FileReader();
    FR.addEventListener("load", function(e){
      var url = e.target.result,
          uploadedList = jQuery('.upload_list').html();
      if(uploadedList.indexOf(url) > -1){
      }else{
        jQuery('.upload_list').prepend('<li data-for=""><span for-crop="'+url+'"><img src="'+url+'" alt=""></span></li>');
      }
    });
    FR.readAsDataURL(this.files[0]);
    jQuery('#uploadFile').val('');
  }
}

function updateFile(){
  canvas = jQuery('.background-canvas .active .lower-canvas').attr('id');
  num = canvas.replace('canvas_','');
  selectedImgID = window['canv_'+num].getActiveObject().id;
  if(this.files && this.files[0]){
    var FR= new FileReader();
    FR.addEventListener("load", function(e){
      var url = e.target.result,
          uploadedList = jQuery('.upload_list').html();
      if(uploadedList){
        if(uploadedList.indexOf(url) > -1){
        }else{
          jQuery('.upload_list').prepend('<li data-for=""><span for-crop="'+url+'"><img id="upToDateImg" src="'+url+'" alt=""></span></li>');
        }
      }
      jQuery('.upload_list_update').html('<li data-for=""><span class="active" for-crop="'+url+'"><img id="upToDateImg" src="'+url+'" alt=""></span></li>');
    });
    FR.readAsDataURL(this.files[0]);
    jQuery('#uploadCfile').val('');
    setTimeout(function(){
      var exectiveImg = document.querySelector("#upToDateImg"),
          realWidth = exectiveImg.naturalWidth,
          realHeight = exectiveImg.naturalHeight;
      /*if(realWidth === realHeight){
        cropBtn.hide();
      }else{
        cropBtn.show();
      }*/
      //cropBtn.show();
      jQuery('.cropNow>.btn').trigger('click');
      //jQuery('#cImagePop').show();
    },100);
  }
}

function loadColorPicker(colorBox){
  jQuery('#'+colorBox).colorpicker({
    inline: true,
    container: true,
    extensions:[{
      name: 'swatches',
      options:{
        colors:{
          'tetrad1': 'transparent',
          'tetrad2': '#e30405',
          'tetrad3': '#197b30',
          'tetrad4': '#0054a5',
          'tetrad5': '#ffcc00',
          'tetrad6': '#f6ebbe',
          'tetrad7': '#ffea00',
          'tetrad8': '#f8931d',
          'tetrad9': '#f499c2',
          'tetrad10': '#959595',
          'tetrad11': '#fef335',
          'tetrad12': '#a0400d',
          'tetrad13': '#000000',
          'tetrad14': '#604973',
          'tetrad15': '#afe8fc',
          'tetrad16': '#fffafa',
          'tetrad17': '#bc8cbe',
          'tetrad18': '#ff69b4',
          'tetrad19': '#93278f',
          'tetrad20': '#009987',
          'tetrad21': '#0af447',
          'tetrad22': '#00008b',
          'tetrad23': '#006400'
        },
        namesAsValues: false
      }
    }],
    template: '<div class="colorpicker">' +
    '<div class="colorpicker-saturation"><i class="colorpicker-guide"></i></div>' +
    '<div class="colorpicker-hue"><i class="colorpicker-guide"></i></div>' +
    '<div class="colorpicker-alpha">' +
    '   <div class="colorpicker-alpha-color"></div>' +
    '   <i class="colorpicker-guide"></i>' +
    '</div>' +
    '<div class="colorpicker-bar"><a href="javascript:void(0);" class="btn btn-block btn-sm btn-primary colorOFF">Ok</a></div>' +
    '</div>'
  }).on('colorpickerCreate', function(){
    var colorBox = jQuery(this);
    setTimeout(function(){
      var colorID = colorBox.attr('id'),
          active = colorBox.find('.currentColor'),
          activeCOLOR = active.attr('value');
      colorBox.find('.colorBox').attr('style','background:'+activeCOLOR+';');
    },200);
  }).on('colorpickerChange', function(){
    var colorBox = jQuery(this);
    setTimeout(function(){
      var colorID = colorBox.attr('id'),
          active = colorBox.find('.currentColor'),
          activeCOLOR = active.attr('value');
      colorBox.find('.colorBox').attr('style','background:'+activeCOLOR+';');
      canvas = jQuery('.background-canvas .active .lower-canvas').attr('id');
      num = canvas.replace('canvas_','');
      if(colorID === 'bgColor'){
        window['canv_'+num].backgroundColor = activeCOLOR;
        if(window['ring_'+num].paths[1]){
          window['ring_'+num].paths[1].set({
            fill: activeCOLOR
          });
        }
        object = 'background';
        window['canv_'+num].renderAll();
        undoBtn.removeAttribute('data-first');
      }
      if(colorID === 'ringColor'){
        if(window['ring_'+num].paths.length){
          window['ring_'+num].paths[0].set({
            fill: activeCOLOR
          });
          window['canv_'+num].renderAll();
          object = window['ring_'+num];
        }
      }
      if(colorID === 'lineColor'){
        line.set({
          fill: activeCOLOR
        });
        window['canv_'+num].renderAll();
      }
      if(colorID === 'textColor'){
        object = window['canv_'+num].getActiveObject();
        if(object){
          object.set('fill',activeCOLOR);
          window['canv_'+num].renderAll();
        }
      }
      undoBtn.setAttribute('data-first','');
      onObjectModified(num,object);
    },200);
  });
  jQuery(document).on('click','.colorBox',function(){
    jQuery('.colorBox').each(function(){
      jQuery(this).next().hide();
    });
    jQuery(this).next().show();
  });
  jQuery(document).on('click','.colorOFF',function(){
    var parENt = jQuery(this).parent().parent(),
        toolBarBox = parENt.parent().parent().parent().attr('id');
    if(toolBarBox === 'labelBase'){
      parENt.parent().parent().parent().parent().removeClass('active');
    }else{
      parENt.hide();
    }
  });
}

function updateLayers(object,num,objNum){
  var id = objNum,
      iconObjects = jQuery('.objects'),
      iconText = iconObjects.find('#iconText').attr('d'),
      iconMove = iconObjects.find('#iconMove').attr('d'),
      moveTras = iconObjects.find('#moveTras').attr('d');
  iconText = '<svg viewBox="0 0 240 240"><path d="'+iconText+'"/></svg>';
  iconMove = '<svg viewBox="0 0 240 240" class="dragObj"><path d="'+iconMove+'"/></svg>';
  moveTras = '<svg viewBox="0 0 240 240" class="dletObj"><path d="'+moveTras+'"/></svg>';
  if(jQuery('.loadedTemp').length === 1){
    iconMove = '';
    moveTras = '';
  }
  type = object.type;
  objId = object.id;
  if(!objId){
    objNum++;
    objId = 'obj_'+objNum;
    object.id = objId;
    objNum--;
  }
  if(type === 'text' || type === 'curvedText'){
    txt = object.text;
    if(txt.length > 9){
      txt = txt.substr(0,9) + '...';
    }
    jQuery('.lyersBlock').prepend('<li class="ui-state-default layerObject" id="'+id+'" data-for="'+objId+'">'+
                                  '<div>'+
                                  iconText+
                                  '<span>'+txt+'</span></div>'+
                                  '<div>'+
                                  iconMove+
                                  moveTras+
                                  '</div></li>');
  }
  if(type === 'image'){
    imgSrc = object._originalElement.currentSrc;
    jQuery('.lyersBlock').prepend('<li class="ui-state-default layerObject" id="'+id+'" data-for="'+objId+'">'+
                                  '<div>'+
                                  '<img src="'+imgSrc+'" alt="">'+
                                  '<span>Image</span></div>'+
                                  '<div>'+
                                  iconMove+
                                  moveTras+
                                  '</div></li>');
  }
  activeOb = window['canv_'+num].getActiveObject();
  if(activeOb === object){
    jQuery('.layerObject[data-for="'+objId+'"]').addClass('active');
  }
  layerSort(num);
};

function layerSort(num){
  jQuery('.lyersBlock').sortable({
    handle: '.dragObj',
    update: function(event, ui){
      canvas = jQuery('.background-canvas .active .lower-canvas').attr('id');
      num = canvas.replace('canvas_','');
      var items = jQuery(this).children();
      items.each(function(i,item){
        window['canv_'+num].sendToBack(objectArray[item.id]);
      });
      window['canv_'+num].renderAll();
    }
  });
  jQuery('.lyersBlock').disableSelection();
};

function reArrangeLayers(num){
  Objects = window['canv_'+num].getObjects();
  objNum = 0;
  Objects.forEach(function(object){
    objectArray.push(object);
    updateLayers(object,num,objNum);
    objNum++
  });
}

function checkChipColor(chipName){
  if(chipName === 'spot_8'){
    jQuery('.color_BOX').parent().attr('class','theContent spot8');
    jQuery('.color_BAX').parent().attr('class','quantityChipColor spot8');
  }
  if(chipName === 'spot_12'){
    jQuery('.color_BOX').parent().attr('class','theContent spot12');
    jQuery('.color_BAX').parent().attr('class','quantityChipColor spot12');
  }
  if(chipName === 'rounders'){
    jQuery('.color_BOX').parent().attr('class','theContent rounde');
    jQuery('.color_BAX').parent().attr('class','quantityChipColor rounde');
  }
  if(chipName === 'royalt'){
    jQuery('.color_BOX').parent().attr('class','theContent royalt');
    jQuery('.color_BAX').parent().attr('class','quantityChipColor royalt');
  }
  if(chipName === 'specia'){
    jQuery('.color_BOX').parent().attr('class','theContent specia');
    jQuery('.color_BAX').parent().attr('class','quantityChipColor specia');
  }
  if(chipName === 'hotSta'){
    jQuery('.color_BOX').parent().attr('class','theContent hotSta');
    jQuery('.color_BAX').parent().attr('class','quantityChipColor hotSta');
  }
  if(jQuery('.non-custom').length > 0){
    jQuery('.radio_color .color_BOX').each(function(){
      jQuery(this).hide();
    });
    jQuery('.product-single__thumbnail-image').each(function(){
      var thisImg = jQuery(this).parent().parent().parent().parent(),
          colorTag = jQuery(this).attr('data-tag'),
          colorTag = colorTag.split(', ').pop(),
          colorName = colorTag.replace('color-','');
      jQuery('#'+colorName).parent().css('display','inline-block');
      if(thisImg.hasClass('slick-current')){
        jQuery('#'+colorName).prop('checked',true);
      }
    });
  }
  if(jQuery('.custom-Set').length > 0){
    console.log('Now dance');
    jQuery('.radio_color .color_BOX,.cQuantityBlocks .color_BAX').each(function(){
      jQuery(this).hide();
    });
    jQuery('#set_tags>span').each(function(){
      var colorTag = jQuery(this).attr('data-tag'),
          colorTag = colorTag.split(', ').pop(),
          colorName = colorTag.replace('color-','');
      jQuery('#'+colorName).parent().css('display','inline-block');
      jQuery('.cQuantityBlocks .color_BAX input[value="'+colorName+'"]').parent().css('display','inline-block');
    });
  }
}

function loadedTemp(num){
  Objects = window['canv_'+num].getObjects();
  Objects.forEach(function(object){
    editing = object.editing;
    if(editing){
      object.set({
        _controlsVisibility: {
          br: false,
          tl: false,
          tr: false,
          bl: false,
          mb: false,
          ml: false,
          mr: false,
          mt: false,
          mtr: false
        }
      });
    }else{
      object.set({
        _controlsVisibility: {
          br: true,
          tl: true,
          tr: true,
          bl: false,
          mb: false,
          ml: false,
          mr: false,
          mt: false,
          mtr: false
        }
      });
    }
    window['canv_'+num].renderAll();
  });
  jQuery('.toolNote>.iconTrash').hide();
}

function checkLock(){
  if(!$(".radio_rounder .theContent>.pickSolidColor:visible").length){
    jQuery('.radio_rounder').addClass('hiddenWall');
  }else{
    jQuery('.radio_rounder').removeClass('hiddenWall');
  }
}

function addModify(num){
  window['canv_'+num].on('selection:cleared', function(e){
    jQuery('.loading').show();
    jQuery('.thePop').each(function(){
      jQuery(this).removeClass('active').hide();
    });
    jQuery('.accordians').removeClass('popOpen');
    jQuery('.layerObject').each(function(){
      jQuery(this).removeClass('active');
    });
    jQuery('.actionBtns').addClass('disabled');
    jQuery('.loading').hide();
    jQuery('.toolNote').hide();
  });
  window['canv_'+num].on('object:removed',function(e){
    object = e.target;
    jQuery('.loading').show();
    setTimeout(function(){
      if(object.type != 'path-group'){
        jQuery('.layerObject.active').remove();
        objectArray.splice(objectArray.indexOf(object), 1);
        jQuery('.thePop').each(function(){
          jQuery(this).removeClass('active').hide();
        });
        jQuery('.accordians').removeClass('popOpen');
      }
      if(object.type === 'image'){
        jQuery('.updateImage').hide();
      }
    },10);
    jQuery('.actionBtns').addClass('disabled');
    jQuery('.loading').hide();
    jQuery('.toolNote').hide();
  });
  window['canv_'+num].on('object:modified', function(e){
    object = e.target;
    undoBtn.setAttribute('data-first','');
    onObjectModified(num,object);
    jQuery('#undo').prop('disabled', false);
    id = object.id;
  });
  window['canv_'+num].on('object:added', function(e){
    object = e.target;
    addControls(object);
    added = true;
    undoBtn.setAttribute('data-first','');
    onObjectModified(num,object);
    jQuery('#undo').prop('disabled', false);
  });
  // Bleed area
  window['canv_'+num].on('object:moving', function(e){/*
    var obj = e.target;

    // if object is too big ignore
    if (obj.currentHeight > obj.canvas.height - padding * 2 ||
        obj.currentWidth > obj.canvas.width - padding * 2) {
      return;
    }
    obj.setCoords();

    // top-left corner
    if (obj.getBoundingRect().top < padding ||
        obj.getBoundingRect().left < padding) {
      obj.top = Math.max(obj.top, obj.top - obj.getBoundingRect().top + padding);
      obj.left = Math.max(obj.left, obj.left - obj.getBoundingRect().left + padding);
    }

    // bot-right corner
    if (obj.getBoundingRect().top + obj.getBoundingRect().height > obj.canvas.height - padding ||
        obj.getBoundingRect().left + obj.getBoundingRect().width > obj.canvas.width - padding) {
      obj.top = Math.min(
        obj.top,
        obj.canvas.height - obj.getBoundingRect().height + obj.top - obj.getBoundingRect().top - padding);
      obj.left = Math.min(
        obj.left,
        obj.canvas.width - obj.getBoundingRect().width + obj.left - obj.getBoundingRect().left - padding);
    }*/
  });
  window['canv_'+num].on('object:selected', function(e){
    jQuery('.loading').show();
    jQuery('.thePop').each(function(){
      jQuery(this).removeClass('active').hide();
    });
    jQuery('.actionBtns').removeClass('disabled');
    object = e.target;
    type = object.type;
    var selectedId = object.id;
    if(type === 'text' || type === 'curvedText'){
      txt 		= object.text;
      base 		= object.fill;
      font 		= object.fontFamily;
      fontSize  = object.fontSize;
      txtA 		= object.textAlign;
      bold 		= object.fontWeight;
      italic 	= object.fontStyle;
      underline = object.textDecoration;
      
      jQuery('.text_box').prop('disabled',false);
      jQuery('#fontFamily,#fSize').prop('disabled',false);
      jQuery('input#italic,input#bold,input#underline,input#curveMind').prop('disabled',false);
      
      jQuery('#effect').val('straight');
      jQuery('.text_box').val(txt);
      jQuery('#fontFamily').val(font);
      jQuery('#fSize').val(fontSize);
      jQuery('input#italic,input#bold,input#underline,input#curveMind').prop('checked',false);
      jQuery('input#curveMind').removeAttr('disabled');
      jQuery('input#curveRange,input#spaceRange').val(0).change();
      jQuery('#tAlignments').show();
      jQuery('.curveRegistered').hide();
      if(italic === 'italic'){
        jQuery('input#italic').prop('checked',true);
      }
      if(bold === 'bold'){
        jQuery('input#bold').prop('checked',true);
      }
      if(underline === 'underline'){
        jQuery('input#underline').prop('checked',true); 
      }
      jQuery('input[name="text-align"]#'+txtA).prop('checked',true);
      jQuery('#textColor .currentColor').val(base);
      jQuery('#textColor .currentColor+.colorBox').css('backgroundColor',base);
      if(type === 'curvedText'){
        jQuery('#effect').val('curved');
        jQuery('#tAlignments').hide();
        jQuery('.curveRegistered').show();
        radiusT = object.radius;
        spacingT = object.spacing;
        reverseT = object.reverse;
        jQuery('input#curveMind').prop('checked',reverseT);
        if(jQuery('.product-single').hasClass('pradeTemp')){
          jQuery('input#curveMind').attr('disabled','disabled');
        }
        jQuery('input#curveRange').val(radiusT).change();
        jQuery('input#spaceRange').val(spacingT).change();
        curOut.innerHTML = radiusT;
      }
      jQuery('#textPop').addClass('active').show();
      if(jQuery('.product-single.pradeTemp').length){
        jQuery('#effect').prop('disabled',true);
      }
      editing = object.editing;
      if(editing){
        jQuery('.text_box').prop('disabled',true);
        jQuery('#fontFamily,#fSize').prop('disabled',true);
        jQuery('input#italic,input#bold,input#underline,input#curveMind').prop('disabled',true);
      }
    }
    if(type === 'image'){
      if(selectedId.indexOf('qrc') === 0){
        jQuery('#qrmPop').addClass('active').show();
        jQuery('.accordians').addClass('popOpen');
        jQuery('#qrcode').empty().hide();
        jQuery('#updateQR').hide();
      }
      else if(selectedId.indexOf('qrb') === 0){
        jQuery('#qrmPopB').addClass('active').show();
        jQuery('.accordians').addClass('popOpen');
        jQuery('#qrcodeB').empty().hide();
        jQuery('#updateQRB').hide();
      }else{
        imgSrc = object._originalElement.currentSrc;
        jQuery('.upload_list_update').html('<li data-for=""><span class="active" for-crop="'+imgSrc+'"><img src="'+imgSrc+'" alt=""></span></li>');
        jQuery('#cImagePop').show();
      }
    }
    jQuery('.layerObject').each(function(){
      jQuery(this).removeClass('active');
    });
    jQuery('.layerObject[data-for="'+selectedId+'"]').addClass('active');
    jQuery('.accordians').addClass('popOpen');
    jQuery('.loading').hide();
    jQuery('.toolNote').show();
  });
}

function brideGroosmanB(num){
  loadFrontImg();
  jQuery('.workPlace').addClass('loadedTemp');
  jQuery('.product-single').addClass('pradeTemp');
  jQuery('input[name="rounders"]#ring_1').prop('checked',true);
  window['canv_'+num].backgroundColor = '#ba070f';
  var obj,text1,text2,
      label1 = 'Will You Be My Bridesmaid?',
      label2 = '6/6/2030';
  imgSrc = jQuery('#frnt-img').attr('src');
  window['newImg_'+num] = new Image();
  window['newImg_'+num].onload = function(){
    obj = new fabric.Image(window['newImg_'+num],{
      id: 'obj_'+n,
      left: cSize/2,
      top: cSize/2,
      originX: 'center',
      originY: 'center',
      scaleX: 1,
      scaleY: 1,
      selectable: false,
      evented: false,
      hoverCursor: 'default'
    });
    obj.scaleToWidth(cSize/1.18);
    window['canv_'+num].add(obj);
    n++;
    window['canv_'+num].renderAll();
  };
  window['newImg_'+num].src = imgSrc;
  window['canv_'+num].renderAll();
  
  text1 = new fabric.CurvedText(label1,{
    id: 'obj_'+n,
    top:80,
    left:cSize/2,
    originX: 'center',
    originY: 'center',
    fontFamily: "'Arial',sans-serif",
    fontSize: '18',
    fill: '#ffffff',
    textAlign: 'center',
    effect: 'curved',
    radius: 112,
    spacing:3
  });
  n++;
  text2 = new fabric.Text(label2,{
    id: 'obj_'+n,
    top:228,
    left:cSize/2,
    originX: 'center',
    originY: 'center',
    fontFamily: "'Arial',sans-serif",
    fontSize: '16',
    fill: '#000000',
    textAlign: 'center'
  });
  n++;
  text1.lockMovementX = true;
  text2.lockMovementX = true;
  setTimeout(function(){
    window['canv_'+num].add(text1);
    window['canv_'+num].add(text2);
  },40);
  setTimeout(function(){
    window['canv_'+num].sendToBack(obj);
    window['canv_'+num].renderAll();
    loadedTemp(num);
    window['universal'+num] = ['type: bckgrnd'+num+', type: path-group, ring-0'];
    jQuery('#undo').prop('disabled', true);
  },160);
}

function loadBusiness_card(num){
  loadFrontImg();
  jQuery('.workPlace').addClass('loadedTemp');
  jQuery('.product-single').addClass('pradeTemp');
  jQuery('input[name="rounders"]#ring_2').prop('checked',true);
  var obj,text1,text2,
      label1 = 'SIN CITY GAMES',
      label2 = '702-255-1212';
  imgSrc = jQuery('#frnt-img').attr('src');
  window['newImg_'+num] = new Image();
  window['newImg_'+num].onload = function(){
    obj = new fabric.Image(window['newImg_'+num],{
      id: 'obj_'+n,
      left: cSize/2,
      top: cSize/2,
      originX: 'center',
      originY: 'center',
      scaleX: 1,
      scaleY: 1
    });
    obj.scaleToWidth(cSize/1.18);
    window['canv_'+num].add(obj);
    n++;
    window['canv_'+num].renderAll();
  };
  window['newImg_'+num].src = imgSrc;
  
  newRounder = jQuery('input[name="rounders"]:checked').val();
  ringURL = jQuery('input[name="rounders"]:checked+label>span').html();
  ringColor = '#a01c34';
  addRing(num,ringColor);
  
  text1 = new fabric.CurvedText(label1,{
    id: 'obj_'+n,
    top:78,
    left:cSize/2,
    originX: 'center',
    originY: 'center',
    fontFamily: 'Bookman',
    fontSize: '26',
    fill: '#ffffff',
    textAlign: 'center',
    textTransform: 'uppercase',
    effect: 'curved',
    radius: 118,
    spacing: 6
  });
  n++;
  text2 = new fabric.CurvedText(label2,{
    id: 'obj_'+n,
    top:244,
    left:cSize/2,
    originX: 'center',
    originY: 'center',
    fontFamily: 'Bookman',
    fontSize: '24',
    fill: '#ffffff',
    textAlign: 'center',
    textTransform: 'uppercase',
    effect: 'curved',
    radius: 86,
    spacing: 0,
    reverse: true
  });
  n++;
  text1.lockMovementX = true;
  text2.lockMovementX = true;
  setTimeout(function(){
    window['canv_'+num].add(text1);
    window['canv_'+num].add(text2);
  },40);
  setTimeout(function(){
    window['canv_'+num].sendToBack(obj);
    window['canv_'+num].renderAll();
    loadedTemp(num);
    window['universal'+num] = ['type: bckgrnd'+num+', type: path-group, ring-2'];
    jQuery('#undo').prop('disabled', true);
  },160);
}

function CarolynGoodmaF(num){
  loadFrontImg();
  noBackgrounds(num);
  jQuery('.workPlace').addClass('loadedTemp');
  jQuery('.product-single').addClass('pradeTemp');
  jQuery('input[name="rounders"]#ring_1').prop('checked',true);
  var obj,text1,text2,
      label1 = " Carolyn G. Goodman",
      label2 = 'Mayor of Las Vegas';
  imgSrc = jQuery('#frnt-img').attr('src');
  window['newImg_'+num] = new Image();
  window['newImg_'+num].onload = function(){
    obj = new fabric.Image(window['newImg_'+num],{
      id: 'obj_'+n,
      left: cSize/2,
      top: cSize/2,
      originX: 'center',
      originY: 'center',
      scaleX: 1,
      scaleY: 1
    });
    obj.scaleToWidth(cSize/1.18);
    window['canv_'+num].add(obj);
    n++;
    window['canv_'+num].renderAll();
  };
  window['newImg_'+num].src = imgSrc;
  window['canv_'+num].renderAll();
  
  newRounder = jQuery('input[name="rounders"]:checked').val();
  ringURL = jQuery('input[name="rounders"]:checked+label>span').html();
  ringColor = '#794684';
  addRing(num,ringColor);
  
  text1 = new fabric.CurvedText(label1,{
    id: 'obj_'+n,
    top:76,
    left:cSize/2,
    originX: 'center',
    originY: 'center',
    fontFamily: 'abilyaregular',
    fontSize: '24',
    fontWeight: 'bold',
    fill: '#ffed00',
    textAlign: 'center',
    effect: 'curved',
    radius: 116,
    spacing:3
  });
  n++;
  text2 = new fabric.CurvedText(label2,{
    id: 'obj_'+n,
    top:228,
    left:cSize/2,
    originX: 'center',
    originY: 'center',
    fontFamily: 'abilyaregular',
    fontSize: '24',
    fontWeight: 'bold',
    fill: '#ffed00',
    textAlign: 'center',
    effect: 'curved',
    radius: 86,
    spacing: 0,
    reverse: true
  });
  n++;
  setTimeout(function(){
    window['canv_'+num].add(text1);
    window['canv_'+num].add(text2);
  },40);
  setTimeout(function(){
    window['canv_'+num].sendToBack(obj);
    window['canv_'+num].renderAll();
    loadedTemp(num);
    window['universal'+num] = ['type: bckgrnd'+num+', type: path-group, ring-1'];
    jQuery('#undo').prop('disabled', true);
  },160);
}

function CarolynGoodmaB(num){
  jQuery('.workPlace').addClass('loadedTemp');
  jQuery('.product-single').addClass('pradeTemp');
  jQuery('input[name="rounders"]#ring_1').prop('checked',true);
  var obj,text1,text2,text3,
      label1 = " Mayor Carolyn G. Goodman",
      label2 = 'cgoodman@lasvegasnevada.gov',
      label3 = 'City of Las Vegas\n495 S. Main Street\nLas Vegas, NV 89101\n702-229-6241\n702-385-7960 fax';
  window['canv_'+num].backgroundColor = '#fff7b2';
  
  newRounder = jQuery('input[name="rounders"]:checked').val();
  ringURL = jQuery('input[name="rounders"]:checked+label>span').html();
  ringColor = '#794684';
  addRing(num,ringColor);
  
  text1 = new fabric.CurvedText(label1,{
    id: 'obj_'+n,
    top:84,
    left:cSize/2,
    originX: 'center',
    originY: 'center',
    fontFamily: 'abilyaregular',
    fontSize: '18',
    fontWeight: 'bold',
    fill: '#ffed00',
    textAlign: 'center',
    effect: 'curved',
    radius: 112,
    spacing:3
  });
  n++;
  text2 = new fabric.CurvedText(label2,{
    id: 'obj_'+n,
    top:218,
    left:cSize/2,
    originX: 'center',
    originY: 'center',
    fontFamily: 'abilyaregular',
    fontSize: '18',
    fontWeight: 'bold',
    fill: '#ffed00',
    textAlign: 'center',
    effect: 'curved',
    radius: 86,
    spacing: 0,
    reverse: true
  });
  n++;
  text3 = new fabric.Text(label3,{
    id: 'obj_'+n,
    top:cSize/2,
    left:cSize/2,
    originX: 'center',
    originY: 'center',
    fontFamily: 'abilyaregular',
    fontSize: '16',
    lineHeight: .9,
    fontWeight: 'bold',
    fill: '#794684',
    textAlign: 'center'
  });
  setTimeout(function(){
    window['canv_'+num].add(text1);
    window['canv_'+num].add(text2);
    window['canv_'+num].add(text3);
  },40);
  setTimeout(function(){
    window['canv_'+num].sendToBack(obj);
    window['canv_'+num].renderAll();
    loadedTemp(num);
    window['universal'+num] = ['type: bckgrnd'+num+', type: path-group, ring-1'];
    jQuery('#undo').prop('disabled', true);
  },160);
}

function promotion2F(num){
  loadFrontImg();
  noRings(num);
  jQuery('.workPlace').addClass('loadedTemp');
  jQuery('.product-single').addClass('pradeTemp');
  jQuery('input[name="rounders"]#ring_1').prop('checked',true);
  var obj,text1,text2,text3,text4,text5,
      label1 = 'Youremail@gmail.com',
      label2 = '702-555-1212',
      label3 = 'Food & Beverage\nManagement';
  window['canv_'+num].backgroundColor = '#000';
  imgSrc = jQuery('#frnt-img').attr('src');
  window['newImg_'+num] = new Image();
  window['newImg_'+num].onload = function(){
    obj = new fabric.Image(window['newImg_'+num],{
      id: 'obj_'+n,
      left: cSize/2,
      top: cSize/2,
      originX: 'center',
      originY: 'center',
      scaleX: 1,
      scaleY: 1,
      selectable: false,
      evented: false,
      hoverCursor: 'default'
    });
    obj.scaleToWidth(cSize/1.18);
    window['canv_'+num].add(obj);
    n++;
    window['canv_'+num].renderAll();
  };
  window['newImg_'+num].src = imgSrc;
  window['canv_'+num].renderAll();
  
  newRounder = jQuery('input[name="rounders"]:checked').val();
  ringURL = jQuery('input[name="rounders"]:checked+label>span').html();
  ringColor = '#ffffff';
  addRing(num,ringColor);
  
  text1 = new fabric.CurvedText(label1,{
    id: 'obj_'+n,
    top:78,
    left:cSize/2,
    originX: 'center',
    originY: 'center',
    fontFamily: 'Franklin_Gothic',
    fontSize: '24',
    fill: '#000',
    textAlign: 'center',
    effect: 'curved',
    radius: 120,
    spacing:3
  });
  n++;
  text2 = new fabric.CurvedText(label2,{
    id: 'obj_'+n,
    top:242,
    left:cSize/2,
    originX: 'center',
    originY: 'center',
    fontFamily: 'Franklin_Gothic',
    fontSize: '24',
    fill: '#000',
    textAlign: 'center',
    effect: 'curved',
    radius: 86,
    spacing: 0,
    reverse: true
  });
  n++;
  text3 = new fabric.Text(label3,{
    id: 'obj_'+n,
    top:136,
    left:cSize/2,
    originX: 'center',
    originY: 'center',
    fontFamily: "'Arial',sans-serif",
    fontSize: '13',
    lineHeight: .9,
    fill: '#fff',
    textAlign: 'center'
  });
  n++;
  text4 = new fabric.Text(label1,{
    id: 'obj_'+n,
    top:157,
    left:cSize/2,
    originX: 'center',
    originY: 'center',
    fontFamily: "'Arial',sans-serif",
    fontSize: '13',
    lineHeight: .9,
    fill: '#fff',
    textAlign: 'center'
  });
  n++;
  text5 = new fabric.Text(label2,{
    id: 'obj_'+n,
    top:172,
    left:cSize/2,
    originX: 'center',
    originY: 'center',
    fontFamily: "'Arial',sans-serif",
    fontSize: '13',
    lineHeight: .9,
    fill: '#fff',
    textAlign: 'center'
  });
  n++;
  setTimeout(function(){
    window['canv_'+num].add(text1);
    window['canv_'+num].add(text2);
    window['canv_'+num].add(text3);
    window['canv_'+num].add(text4);
    window['canv_'+num].add(text5);
  },40);
  setTimeout(function(){
    window['canv_'+num].sendToBack(obj);
    window['canv_'+num].renderAll();
    loadedTemp(num);
    window['universal'+num] = ['type: bckgrnd'+num+', type: path-group, ring-1'];
    jQuery('#undo').prop('disabled', true);
  },160);
}

function promotion2B(num){
  jQuery('.workPlace').addClass('loadedTemp');
  jQuery('.product-single').addClass('pradeTemp');
  jQuery('input[name="rounders"]#ring_1').prop('checked',true);
  var obj,text1,text2,text3,text4,
      label1 = 'ENTERTAINMENT MARKETING',
      label2 = 'Youremail@gmail.com',
      label3 = '3414\nOLD RICHMOND RD.\nROSENBERG, TEXAS\n702-555-1212';
  window['canv_'+num].backgroundColor = '#fff482';
  imgSrc = jQuery('#back-img').attr('src');
  window['newImg_'+num] = new Image();
  window['newImg_'+num].onload = function(){
    obj = new fabric.Image(window['newImg_'+num],{
      id: 'obj_'+n,
      left: cSize/2,
      top: cSize/2,
      originX: 'center',
      originY: 'center',
      scaleX: 1,
      scaleY: 1,
      selectable: false,
      evented: false,
      hoverCursor: 'default'
    });
    obj.scaleToWidth(cSize/1.18);
    window['canv_'+num].add(obj);
    n++;
    window['canv_'+num].renderAll();
  };
  window['newImg_'+num].src = imgSrc;
  window['canv_'+num].renderAll();
  
  newRounder = jQuery('input[name="rounders"]:checked').val();
  ringURL = jQuery('input[name="rounders"]:checked+label>span').html();
  ringColor = '#009640';
  addRing(num,ringColor);
  
  text1 = new fabric.CurvedText(label1,{
    id: 'obj_'+n,
    top:96,
    left:cSize/2,
    originX: 'center',
    originY: 'center',
    fontFamily: 'Franklin_Gothic',
    fontSize: '20',
    fill: '#fff',
    textAlign: 'center',
    effect: 'curved',
    radius: 110,
    spacing:3
  });
  n++;
  text2 = new fabric.CurvedText(label2,{
    id: 'obj_'+n,
    top:236,
    left:cSize/2,
    originX: 'center',
    originY: 'center',
    fontFamily: 'Franklin_Gothic',
    fontSize: '18',
    fill: '#fff',
    textAlign: 'center',
    effect: 'curved',
    radius: 86,
    spacing: 0,
    reverse: true
  });
  n++;
  text3 = new fabric.Text(label3,{
    id: 'obj_'+n,
    top:cSize/2,
    left:cSize/2,
    originX: 'center',
    originY: 'center',
    fontFamily: "'Arial',sans-serif",
    fontSize: '13',
    fontWeight: 'bold',
    lineHeight: .9,
    fill: '#000',
    textAlign: 'center'
  });
  n++;
  setTimeout(function(){
    window['canv_'+num].add(text1);
    window['canv_'+num].add(text2);
    window['canv_'+num].add(text3);
  },40);
  setTimeout(function(){
    window['canv_'+num].sendToBack(obj);
    window['canv_'+num].renderAll();
    loadedTemp(num);
    window['universal'+num] = ['type: bckgrnd'+num+', type: path-group, ring-1'];
    jQuery('#undo').prop('disabled', true);
  },160);
}

function finallyAskedF(num){
  loadFrontImg();
  noBackgrounds(num);
  jQuery('.workPlace').addClass('loadedTemp');
  jQuery('.product-single').addClass('pradeTemp');
  var obj,obj2,text1,text2,
      label1 = 'Chris and Brooke',
      label2 = 'Tying the Knot';
  imgSrc = jQuery('#frnt-img').attr('src');
  window['newImg_'+num] = new Image();
  window['newImg_'+num].onload = function(){
    obj = new fabric.Image(window['newImg_'+num],{
      id: 'obj_'+n,
      left: cSize/2,
      top: cSize/2,
      originX: 'center',
      originY: 'center',
      scaleX: 1,
      scaleY: 1
    });
    obj.scaleToWidth(cSize/1.18);
    window['canv_'+num].add(obj);
    n++;
    window['canv_'+num].renderAll();
  };
  window['newImg_'+num].src = imgSrc;
  window['canv_'+num].renderAll();
  
  var imgSrc2 = jQuery('#back-img').attr('src');
  window['newImg2_'+num] = new Image();
  window['newImg2_'+num].onload = function(){
    obj2 = new fabric.Image(window['newImg2_'+num],{
      id: 'obj_'+n,
      left: cSize/2,
      top: cSize/2,
      originX: 'center',
      originY: 'center',
      scaleX: 1,
      scaleY: 1,
      selectable: false,
      evented: false,
      hoverCursor: 'default'
    });
    obj2.scaleToWidth(cSize/1.18);
    window['canv_'+num].add(obj2);
    n++;
    window['canv_'+num].renderAll();
  };
  window['newImg2_'+num].src = imgSrc2;
  window['canv_'+num].renderAll();
  
  text1 = new fabric.CurvedText(label1,{
    id: 'obj_'+n,
    top:58,
    left:cSize/2,
    originX: 'center',
    originY: 'center',
    fontFamily: 'Franklin_Gothic',
    fontSize: '18',
    fill: '#b9997d',
    textAlign: 'center',
    effect: 'curved',
    radius: 110,
    spacing:3
  });
  n++;
  text2 = new fabric.CurvedText(label2,{
    id: 'obj_'+n,
    top:240,
    left:cSize/2,
    originX: 'center',
    originY: 'center',
    fontFamily: 'Franklin_Gothic',
    fontSize: '18',
    fill: '#001857',
    textAlign: 'center',
    effect: 'curved',
    radius: 104,
    spacing: 1,
    reverse: true
  });
  n++;
  text1.lockMovementX = true;
  text2.lockMovementX = true;
  setTimeout(function(){
    window['canv_'+num].add(text1);
    window['canv_'+num].add(text2);
  },40);
  setTimeout(function(){
    window['canv_'+num].sendToBack(obj2);
    window['canv_'+num].sendToBack(obj);
    window['canv_'+num].renderAll();
    loadedTemp(num);
    window['universal'+num] = ['type: bckgrnd'+num+', type: path-group, ring-0'];
    jQuery('#undo').prop('disabled', true);
  },160);
}

function finallyAskedB(num){
  noBackgrounds(num);
  var obj,obj2,text1,text2,
      label1 = 'September 22, 2022',
      label2 = 'Honolulu, Hawaii';
  imgSrc = jQuery('#frnt-img').attr('src');
  window['newImg_'+num] = new Image();
  window['newImg_'+num].onload = function(){
    obj = new fabric.Image(window['newImg_'+num],{
      id: 'obj_'+n,
      left: cSize/2,
      top: cSize/2,
      originX: 'center',
      originY: 'center',
      scaleX: 1,
      scaleY: 1
    });
    obj.scaleToWidth(cSize/1.18);
    window['canv_'+num].add(obj);
    n++;
    window['canv_'+num].renderAll();
  };
  window['newImg_'+num].src = imgSrc;
  window['canv_'+num].renderAll();
  
  var imgSrc2 = jQuery('#back-img').attr('src');
  window['newImg2_'+num] = new Image();
  window['newImg2_'+num].onload = function(){
    obj2 = new fabric.Image(window['newImg2_'+num],{
      id: 'obj_'+n,
      left: cSize/2,
      top: cSize/2,
      originX: 'center',
      originY: 'center',
      scaleX: 1,
      scaleY: 1,
      selectable: false,
      evented: false,
      hoverCursor: 'default'
    });
    obj2.scaleToWidth(cSize/1.18);
    window['canv_'+num].add(obj2);
    n++;
    window['canv_'+num].renderAll();
  };
  window['newImg2_'+num].src = imgSrc2;
  window['canv_'+num].renderAll();
  
  text1 = new fabric.CurvedText(label1,{
    id: 'obj_'+n,
    top:66,
    left:cSize/2,
    originX: 'center',
    originY: 'center',
    fontFamily: 'Franklin_Gothic',
    fontSize: '18',
    fill: '#b9997d',
    textAlign: 'center',
    effect: 'curved',
    radius: 120,
    spacing:3
  });
  n++;
  text2 = new fabric.CurvedText(label2,{
    id: 'obj_'+n,
    top:240,
    left:cSize/2,
    originX: 'center',
    originY: 'center',
    fontFamily: 'Franklin_Gothic',
    fontSize: '18',
    fill: '#001857',
    textAlign: 'center',
    effect: 'curved',
    radius: 104,
    spacing: 1,
    reverse: true
  });
  n++;
  text1.lockMovementX = true;
  text2.lockMovementX = true;
  setTimeout(function(){
    window['canv_'+num].add(text1);
    window['canv_'+num].add(text2);
  },40);
  setTimeout(function(){
    window['canv_'+num].sendToBack(obj2);
    window['canv_'+num].sendToBack(obj);
    window['canv_'+num].renderAll();
    loadedTemp(num);
    window['universal'+num] = ['type: bckgrnd'+num+', type: path-group, ring-0'];
    jQuery('#undo').prop('disabled', true);
  },160);
}

function loadWeddingF(num){
  loadFrontImg();
  noBackgrounds(num);
  jQuery('.workPlace').addClass('loadedTemp');
  jQuery('.product-single').addClass('pradeTemp');
  var obj,text1,text2,
      label1 = 'Michael & Donna',
      label2 = 'Memory of our Wedding';
  imgSrc = jQuery('#frnt-img').attr('src');
  window['newImg_'+num] = new Image();
  window['newImg_'+num].onload = function(){
    obj = new fabric.Image(window['newImg_'+num],{
      id: 'obj_'+n,
      left: cSize/2,
      top: cSize/2,
      originX: 'center',
      originY: 'center',
      scaleX: 1,
      scaleY: 1
    });
    obj.scaleToWidth(cSize/1.18);
    window['canv_'+num].add(obj);
    n++;
    window['canv_'+num].renderAll();
  };
  window['newImg_'+num].src = imgSrc;
  window['canv_'+num].renderAll();
  text1 = new fabric.CurvedText(label1,{
    id: 'obj_'+n,
    top:58,
    left:cSize/2,
    originX: 'center',
    originY: 'center',
    fontFamily: 'Georgia',
    fontSize: '18',
    fill: '#ffffff',
    textAlign: 'center',
    effect: 'curved',
    radius: 110,
    spacing:1
  });
  n++;
  text2 = new fabric.CurvedText(label2,{
    id: 'obj_'+n,
    top:234,
    left:cSize/2,
    originX: 'center',
    originY: 'center',
    fontFamily: 'Georgia',
    fontSize: '18',
    fill: '#ffffff',
    textAlign: 'center',
    effect: 'curved',
    radius: 88,
    spacing: -1,
    reverse: true
  });
  n++;
  text1.lockMovementX = true;
  text2.lockMovementX = true;
  setTimeout(function(){
    window['canv_'+num].add(text1);
    window['canv_'+num].add(text2);
  },40);
  setTimeout(function(){
    window['canv_'+num].sendToBack(obj);
    window['canv_'+num].renderAll();
    loadedTemp(num);
    window['universal'+num] = ['type: bckgrnd'+num+', type: path-group, ring-0'];
    jQuery('#undo').prop('disabled', true);
  },160);
}

function loadWeddingB(num){
  noBackgrounds(num);
  jQuery('.workPlace').addClass('loadedTemp');
  jQuery('.product-single').addClass('pradeTemp');
  jQuery('input[name="rounders"]#ring_1').prop('checked',true);
  var obj,text1,text2,
      label1 = 'Alexander & Abigail',
      label2 = '6-03-18';
  imgSrc = jQuery('#back-img').attr('src');
  window['newImg_'+num] = new Image();
  window['newImg_'+num].onload = function(){
    obj = new fabric.Image(window['newImg_'+num],{
      id: 'obj_'+n,
      left: cSize/2,
      top: cSize/2,
      originX: 'center',
      originY: 'center',
      scaleX: 1,
      scaleY: 1
    });
    obj.scaleToWidth(cSize/1.18);
    window['canv_'+num].add(obj);
    n++;
    window['canv_'+num].renderAll();
  };
  window['newImg_'+num].src = imgSrc;
  window['canv_'+num].renderAll();
  
  newRounder = jQuery('input[name="rounders"]:checked').val();
  ringURL = jQuery('input[name="rounders"]:checked+label>span').html();
  ringColor = '#f8931d';         
  addRing(num,ringColor);
  
  text1 = new fabric.CurvedText(label1,{
    id: 'obj_'+n,
    top:66,
    left:cSize/2,
    originX: 'center',
    originY: 'center',
    fontFamily: 'Rockwell',
    fontSize: '18',
    fill: '#ffffff',
    textAlign: 'center',
    effect: 'curved',
    radius: 106,
    spacing:2
  });
  n++;
  text2 = new fabric.CurvedText(label2,{
    id: 'obj_'+n,
    top:252,
    left:cSize/2,          
    originX: 'center',
    originY: 'center',
    fontFamily: 'Rockwell',
    fontSize: '18',
    fill: '#ffffff',
    textAlign: 'center',
    effect: 'curved',
    radius: 100,
    spacing: 1,
    reverse: true
  });
  n++;
  text1.lockMovementX = true;
  text2.lockMovementX = true;
  setTimeout(function(){
    window['canv_'+num].add(text1);
    window['canv_'+num].add(text2);
  },40);
  setTimeout(function(){
    window['canv_'+num].sendToBack(obj);
    window['canv_'+num].renderAll();
    loadedTemp(num);
    window['universal'+num] = ['type: bckgrnd'+num+', type: path-group, ring-1'];
    jQuery('#undo').prop('disabled', true);
  },160);
}

function coffeeF(num){
  loadFrontImg();
  noBackgrounds(num);
  jQuery('#spot_12').prop('checked',true).change();
  jQuery('.workPlace').addClass('loadedTemp');
  jQuery('.product-single').addClass('pradeTemp');
  var obj;
  window['canv_'+num].backgroundColor = '#68c4dd';
  imgSrc = jQuery('#frnt-img').attr('src');
  window['newImg_'+num] = new Image();
  window['newImg_'+num].onload = function(){
    obj = new fabric.Image(window['newImg_'+num],{
      id: 'obj_'+n,
      left: cSize/2,
      top: cSize/2,
      originX: 'center',
      originY: 'center',
      scaleX: 1,
      scaleY: 1
    });
    obj.scaleToWidth(cSize/1.18);
    window['canv_'+num].add(obj);
    n++;
    window['canv_'+num].renderAll();
  };
  window['newImg_'+num].src = imgSrc;
  window['canv_'+num].renderAll();
  setTimeout(function(){
    loadedTemp(num);
    jQuery('input[name="pro_color"]#blue').prop('checked',true).change();
    window['universal'+num] = ['type: bckgrnd'+num+', type: path-group, ring-0'];
    jQuery('#undo').prop('disabled', true);
  },160);
}

function coffeeB(num){
  jQuery('.canvas_'+num).addClass('doQR');
  var obj,text1,text2,
      label1 = 'SCAN ME',
      label2 = 'CONTACTLESS MENU';
  window['canv_'+num].backgroundColor = '#1b75bc';
  imgSrc = jQuery('#back-img').attr('src');
  window['newImg_'+num] = new Image();
  window['newImg_'+num].onload = function(){
    obj = new fabric.Image(window['newImg_'+num],{
      id: 'qrc_'+n,
      left: cSize/2,
      top: cSize/2,
      originX: 'center',
      originY: 'center',
      scaleX: 1,
      scaleY: 1
    });
    obj.scaleToWidth(cSize/2.75);
    window['canv_'+num].add(obj);
    n++;
    window['canv_'+num].renderAll();
  };
  window['newImg_'+num].src = imgSrc;
  window['canv_'+num].renderAll();
  
  text1 = new fabric.Text(label1,{
    id: 'obj_'+n,
    top:81,
    left:cSize/2,
    originX: 'center',
    originY: 'center',
    fontFamily: "'Arial',sans-serif",
    fontSize: '14',
    fill: '#ffffff',
    textAlign: 'center'
  });
  n++;
  text2 = new fabric.Text(label2,{
    id: 'obj_'+n,
    top:220,
    left:cSize/2,
    originX: 'center',
    originY: 'center',
    fontFamily: "'Arial',sans-serif",
    fontSize: '14',
    fill: '#ffffff',
    textAlign: 'center'
  });
  n++;
  text1.lockMovementX = true;
  text2.lockMovementX = true;
  setTimeout(function(){
    window['canv_'+num].add(text1);
    window['canv_'+num].add(text2);
  },40);
  setTimeout(function(){
    window['canv_'+num].sendToBack(obj);
    window['canv_'+num].renderAll();
    loadedTemp(num);
    window['universal'+num] = ['type: bckgrnd'+num+', type: path-group, ring-0'];
    jQuery('#undo').prop('disabled', true);
  },160);
}

function dateChipF(num){
  loadFrontImg();
  noBackgrounds(num);
  jQuery('#spot_12').prop('checked',true).change();
  jQuery('.workPlace').addClass('loadedTemp');
  jQuery('.product-single').addClass('pradeTemp');
  var obj,obj2,obj3,text1,
      label1 = 'THIS GUY';
  imgSrc = jQuery('#frnt-img').attr('src');
  window['canv_'+num].backgroundColor = '#ba2025';
  window['newImg_'+num] = new Image();
  window['newImg_'+num].onload = function(){
    obj = new fabric.Image(window['newImg_'+num],{
      id: 'obj_'+n,
      left: cSize/2,
      top: cSize/2,
      originX: 'center',
      originY: 'center',
      scaleX: 1,
      scaleY: 1,
      selectable: false,
      evented: false,
      hoverCursor: 'default'
    });
    obj.scaleToWidth(cSize/1.18);
    window['canv_'+num].add(obj);
    n++;
    window['canv_'+num].renderAll();
  };
  window['newImg_'+num].src = imgSrc;
  window['canv_'+num].renderAll();
  
  imgSrc = jQuery('#back-img').attr('src');
  window['newImg_3'+num] = new Image();
  window['newImg_3'+num].onload = function(){
    obj3 = new fabric.Image(window['newImg_3'+num],{
      id: 'obj_'+n,
      left: cSize/2,
      top: 214,
      originX: 'center',
      originY: 'center',
      scaleX: 1,
      scaleY: 1
    });
    obj3.scaleToWidth(cSize/2.75);
    window['canv_'+num].add(obj3);
    n++;
    window['canv_'+num].renderAll();
  };
  window['newImg_3'+num].src = imgSrc;
  window['canv_'+num].renderAll();
  
  imgSrc = jQuery('#midl-img').attr('src');
  window['newImg_2'+num] = new Image();
  window['newImg_2'+num].onload = function(){
    obj2 = new fabric.Image(window['newImg_2'+num],{
      id: 'obj_'+n,
      left: cSize/2,
      top: cSize/2,
      originX: 'center',
      originY: 'center',
      scaleX: 1,
      scaleY: 1,
      selectable: false,
      evented: false,
      hoverCursor: 'default'
    });
    obj2.scaleToWidth(cSize/1.18);
    window['canv_'+num].add(obj2);
    
    n++;
    window['canv_'+num].renderAll();
  };
  window['newImg_2'+num].src = imgSrc;
  window['canv_'+num].renderAll();
  
  text1 = new fabric.Text(label1,{
    id: 'obj_'+n,
    top:110,
    left:cSize/2,
    originX: 'center',
    originY: 'center',
    fontFamily: 'Georgia',
    fontSize: '30',
    fill: '#000000',
    textAlign: 'center'
  });
  n++;
  text1.lockMovementX = true;
  setTimeout(function(){
    window['canv_'+num].add(text1);
  },40);
  setTimeout(function(){
    window['canv_'+num].sendToBack(obj);
    window['canv_'+num].renderAll();
    loadedTemp(num);
    jQuery('input[name="pro_color"]#red').prop('checked',true).change();
    window['universal'+num] = ['type: bckgrnd'+num+', type: path-group, ring-0'];
    jQuery('#undo').prop('disabled', true);
  },160);
}

function dateChipB(num){
  jQuery('.workPlace').addClass('loadedTemp');
  jQuery('.product-single').addClass('pradeTemp');
  jQuery('input[name="rounders"]#ring_1').prop('checked',true);
  var obj,text1,text2,
      label1 = 'MY NAME HERE',
      label2 = 'MY NUMBER HERE';
  
  text1 = new fabric.Text(label1,{
    id: 'obj_'+n,
    top:126,
    left:cSize/2,
    originX: 'center',
    originY: 'center',
    fontFamily: 'Impact',
    fontSize: '30',
    fill: '#ba2025',
    textAlign: 'center'
  });
  n++;
  text2 = new fabric.Text(label2,{
    id: 'obj_'+n,
    top:180,
    left:cSize/2,
    originX: 'center',
    originY: 'center',
    fontFamily: 'Impact',
    fontSize: '26',
    fill: '#ba2025',
    textAlign: 'center'
  });
  n++;
  text1.lockMovementX = true;
  text2.lockMovementX = true;
  setTimeout(function(){
    window['canv_'+num].add(text1);
    window['canv_'+num].add(text2);
  },40);
  setTimeout(function(){
    window['canv_'+num].sendToBack(obj);
    window['canv_'+num].renderAll();
    loadedTemp(num);
    window['universal'+num] = ['type: bckgrnd'+num+', type: path-group, ring-0'];
    jQuery('#undo').prop('disabled', true);
  },160);
}

function drinksOnMeF(num){
  loadFrontImg();
  noBackgrounds(num);
  jQuery('#spot_12').prop('checked',true).change();
  jQuery('.workPlace').addClass('loadedTemp');
  jQuery('.product-single').addClass('pradeTemp');
  var obj,text1,
      label1 = 'It’s a Party!';
  window['canv_'+num].backgroundColor = '#f0e2ba';
  imgSrc = jQuery('#frnt-img').attr('src');
  window['newImg_'+num] = new Image();
  window['newImg_'+num].onload = function(){
    obj = new fabric.Image(window['newImg_'+num],{
      id: 'obj_'+n,
      left: cSize/2,
      top: cSize/2,
      originX: 'center',
      originY: 'center',
      scaleX: 1,
      scaleY: 1,
      selectable: false,
      evented: false,
      hoverCursor: 'default'
    });
    obj.scaleToWidth(cSize/1.18);
    window['canv_'+num].add(obj);
    n++;
    window['canv_'+num].renderAll();
  };
  window['newImg_'+num].src = imgSrc;
  window['canv_'+num].renderAll();
  
  text1 = new fabric.Text(label1,{
    id: 'obj_'+n,
    top:cSize/2,
    left:cSize/2,
    originX: 'center',
    originY: 'center',
    fontFamily: 'Bookman',
    fontSize: '30',
    fontWeight: 'bold',
    fill: '#c5050d',
    textAlign: 'center',
    stroke: '#f8a01a',
    strokeWidth: '1'
  });
  n++;
  text1.lockMovementX = true;
  setTimeout(function(){
    window['canv_'+num].add(text1);
  },40);
  
  setTimeout(function(){
    window['canv_'+num].sendToBack(obj);
    window['canv_'+num].renderAll();
    loadedTemp(num);
    jQuery('input[name="pro_color"]#green').prop('checked',true).change();
    window['universal'+num] = ['type: bckgrnd'+num+', type: path-group, ring-0'];
    jQuery('#undo').prop('disabled', true);
  },160);
}

function drinksOnMeB(num){
  noBackgrounds(num);
  jQuery('.workPlace').addClass('loadedTemp');
  jQuery('.product-single').addClass('pradeTemp');
  var obj,text1,
      label1 = 'Drinks\nOn Me!';
  window['canv_'+num].backgroundColor = '#efb054';
  imgSrc = jQuery('#frnt-img').attr('src');
  window['newImg_'+num] = new Image();
  window['newImg_'+num].onload = function(){
    obj = new fabric.Image(window['newImg_'+num],{
      id: 'obj_'+n,
      left: cSize/2,
      top: cSize/2,
      originX: 'center',
      originY: 'center',
      scaleX: 1,
      scaleY: 1,
      selectable: false,
      evented: false,
      hoverCursor: 'default'
    });
    obj.scaleToWidth(cSize/1.18);
    window['canv_'+num].add(obj);
    n++;
    window['canv_'+num].renderAll();
  };
  window['newImg_'+num].src = imgSrc;
  window['canv_'+num].renderAll();
  
  text1 = new fabric.Text(label1,{
    id: 'obj_'+n,
    top:cSize/2,
    left:cSize/2,
    originX: 'center',
    originY: 'center',
    fontFamily: 'Bookman',
    fontSize: '30',
    fontWeight: 'bold',
    lineHeight: .75,
    fill: '#c5050d',
    textAlign: 'center',
    stroke: '#f8a01a',
    strokeWidth: '1'
  });
  n++;
  text1.lockMovementX = true;
  setTimeout(function(){
    window['canv_'+num].add(text1);
  },40);
  setTimeout(function(){
    window['canv_'+num].sendToBack(obj);
    window['canv_'+num].renderAll();
    loadedTemp(num);
    window['universal'+num] = ['type: bckgrnd'+num+', type: path-group, ring-0'];
    jQuery('#undo').prop('disabled', true);
  },160);
}

function dylanCasino(num){
  loadFrontImg();
  jQuery('#spot_12').prop('checked',true).change();
  jQuery('.workPlace').addClass('loadedTemp');
  jQuery('.product-single').addClass('pradeTemp');
  var obj,text1,text2,
      label1 = 'Dylan’s casino',
      label2 = '$5000';
  window['canv_'+num].backgroundColor = '#a91e23';
  imgSrc = jQuery('#frnt-img').attr('src');
  window['newImg_'+num] = new Image();
  window['newImg_'+num].onload = function(){
    obj = new fabric.Image(window['newImg_'+num],{
      id: 'obj_'+n,
      left: cSize/2,
      top: cSize/2,
      originX: 'center',
      originY: 'center',
      scaleX: 1,
      scaleY: 1,
      selectable: false,
      evented: false,
      hoverCursor: 'default'
    });
    obj.scaleToWidth(cSize/1.18);
    window['canv_'+num].add(obj);
    n++;
    window['canv_'+num].renderAll();
  };
  window['newImg_'+num].src = imgSrc;
  window['canv_'+num].renderAll();
  
  text1 = new fabric.CurvedText(label1,{
    id: 'obj_'+n,
    top:78,
    left:104,
    originX: 'center',
    originY: 'center',
    fontFamily: 'DSCaslonGotisch',
    fontSize: '28',
    fill: '#ffffff',
    textAlign: 'center',
    effect: 'curved',
    angle: -35,
    radius: 120,
    spacing:2
  });
  n++;
  text2 = new fabric.Text(label2,{
    id: 'obj_'+n,
    top:238,
    left:cSize/2,
    originX: 'center',
    originY: 'center',
    fontFamily: "'Arial',sans-serif",
    fontSize: '30',
    fill: '#fff',
    textAlign: 'center',
    stroke: '#000',
    strokeWidth: 2
  });
  n++;
  text1.lockMovementX = true;
  text2.lockMovementX = true;
  setTimeout(function(){
    window['canv_'+num].add(text1);
    window['canv_'+num].add(text2);
  },40);
  setTimeout(function(){
    window['canv_'+num].sendToBack(obj);
    window['canv_'+num].renderAll();
    loadedTemp(num);
    window['universal'+num] = ['type: bckgrnd'+num+', type: path-group, ring-0'];
    jQuery('#undo').prop('disabled', true);
  },160);
}

function policeSpecialF(num){
  loadFrontImg();
  jQuery('#spot_12').prop('checked',true).change();
  jQuery('.workPlace').addClass('loadedTemp');
  jQuery('.product-single').addClass('pradeTemp');
  jQuery('input[name="rounders"]#ring_1').prop('checked',true);
  var obj,text1,text2,text3,
      label1 = 'Your Name',
      label2 = '702-555-1212',
      label3 = 'YourEmail@Police.Com';
  window['canv_'+num].backgroundColor = '#222730';
  imgSrc = jQuery('#frnt-img').attr('src');
  window['newImg_'+num] = new Image();
  window['newImg_'+num].onload = function(){
    obj = new fabric.Image(window['newImg_'+num],{
      id: 'obj_'+n,
      left: cSize/2,
      top: cSize/2,
      originX: 'center',
      originY: 'center',
      scaleX: 1,
      scaleY: 1
    });
    obj.scaleToWidth(cSize/1.18);
    window['canv_'+num].add(obj);
    n++;
    window['canv_'+num].renderAll();
  };
  window['newImg_'+num].src = imgSrc;
  window['canv_'+num].renderAll();
  
  newRounder = jQuery('input[name="rounders"]:checked').val();
  ringURL = jQuery('input[name="rounders"]:checked+label>span').html();
  ringColor = '#ffffff';
  addRing(num,ringColor);
  
  text1 = new fabric.CurvedText(label1,{
    id: 'obj_'+n,
    top:56,
    left:cSize/2,
    originX: 'center',
    originY: 'center',
    fontFamily: 'Franklin_Gothic',
    fontSize: '26',
    fill: '#000',
    textAlign: 'center',
    effect: 'curved',
    radius: 120,
    spacing:3
  });
  n++;
  text2 = new fabric.CurvedText(label2,{
    id: 'obj_'+n,
    top:210,
    left:72,
    originX: 'center',
    originY: 'center',
    fontFamily: 'Franklin_Gothic',
    fontSize: '20',
    fill: '#000',
    textAlign: 'center',
    effect: 'curved',
    radius: 84,
    spacing: -1,
    reverse: true,
    angle: 52
  });
  n++;
  text3 = new fabric.CurvedText(label3,{
    id: 'obj_'+n,
    top:212,
    left:cSize - 90,
    originX: 'center',
    originY: 'center',
    fontFamily: 'Franklin_Gothic',
    fontSize: '20',
    fill: '#000',
    textAlign: 'center',
    effect: 'curved',
    radius: 84,
    spacing: -1,
    reverse: true,
    angle: -48
  });
  n++;
  setTimeout(function(){
    window['canv_'+num].add(text1);
    window['canv_'+num].add(text2);
    window['canv_'+num].add(text3);
  },40);
  setTimeout(function(){
    window['canv_'+num].sendToBack(obj);
    window['canv_'+num].renderAll();
    loadedTemp(num);
    jQuery('input[name="pro_color"]#blue').prop('checked',true).change();
    window['universal'+num] = ['type: bckgrnd'+num+', type: path-group, ring-1'];
    jQuery('#undo').prop('disabled', true);
  },160);
}

function policeSpecialB(num){
  jQuery('.workPlace').addClass('loadedTemp');
  jQuery('.product-single').addClass('pradeTemp');
  jQuery('input[name="rounders"]#ring_1').prop('checked',true);
  var obj,text1,text2,
      label1 = 'LAS VEGAS METRO',
      label2 = 'S.W.A.T';
  window['canv_'+num].backgroundColor = '#12100b';
  imgSrc = jQuery('#back-img').attr('src');
  window['newImg_'+num] = new Image();
  window['newImg_'+num].onload = function(){
    obj = new fabric.Image(window['newImg_'+num],{
      id: 'obj_'+n,
      left: cSize/2,
      top: cSize/2,
      originX: 'center',
      originY: 'center',
      scaleX: 1,
      scaleY: 1,
      selectable: false,
      evented: false,
      hoverCursor: 'default'
    });
    obj.scaleToWidth(cSize/1.18);
    window['canv_'+num].add(obj);
    n++;
    window['canv_'+num].renderAll();
  };
  window['newImg_'+num].src = imgSrc;
  window['canv_'+num].renderAll();
  
  newRounder = jQuery('input[name="rounders"]:checked').val();
  ringURL = jQuery('input[name="rounders"]:checked+label>span').html();
  ringColor = '#ffffff';
  addRing(num,ringColor);
  
  text1 = new fabric.CurvedText(label1,{
    id: 'obj_'+n,
    top:74,
    left:cSize/2,
    originX: 'center',
    originY: 'center',
    fontFamily: 'Franklin_Gothic',
    fontSize: '24',
    fill: '#000',
    textAlign: 'center',
    effect: 'curved',
    radius: 116,
    spacing:3
  });
  n++;
  text2 = new fabric.CurvedText(label2,{
    id: 'obj_'+n,
    top:252,
    left:cSize/2,
    originX: 'center',
    originY: 'center',
    fontFamily: 'Franklin_Gothic',
    fontSize: '24',
    fill: '#000',
    textAlign: 'center',
    effect: 'curved',
    radius: 90,
    spacing: 0,
    reverse: true
  });
  n++;
  setTimeout(function(){
    window['canv_'+num].add(text1);
    window['canv_'+num].add(text2);
  },40);
  setTimeout(function(){
    window['canv_'+num].sendToBack(obj);
    window['canv_'+num].renderAll();
    loadedTemp(num);
    window['universal'+num] = ['type: bckgrnd'+num+', type: path-group, ring-1'];
    jQuery('#undo').prop('disabled', true);
  },160);
}

function loadPokerF(num){
  loadFrontImg();
  noBackgrounds(num);
  jQuery('.workPlace').addClass('loadedTemp');
  jQuery('.product-single').addClass('pradeTemp');
  jQuery('input[name="rounders"]#ring_1').prop('checked',true);
  var obj,text1,text2,
      label1 = "EMILIO'S CASINO",
      label2 = 'ONE THOUSAND DOLLAR';
  imgSrc = jQuery('#frnt-img').attr('src');
  window['newImg_'+num] = new Image();
  window['newImg_'+num].onload = function(){
    obj = new fabric.Image(window['newImg_'+num],{
      id: 'obj_'+n,
      left: cSize/2,
      top: cSize/2,
      originX: 'center',
      originY: 'center',
      scaleX: 1,
      scaleY: 1
    });
    obj.scaleToWidth(cSize/1.18);
    window['canv_'+num].add(obj);
    n++;
    window['canv_'+num].renderAll();
  };
  window['newImg_'+num].src = imgSrc;
  window['canv_'+num].renderAll();
  
  newRounder = jQuery('input[name="rounders"]:checked').val();
  ringURL = jQuery('input[name="rounders"]:checked+label>span').html();
  ringColor = '#bc8cbe';
  addRing(num,ringColor);
  
  text1 = new fabric.CurvedText(label1,{
    id: 'obj_'+n,
    top:72,
    left:cSize/2,
    originX: 'center',
    originY: 'center',
    fontFamily: "Bookman",
    fontSize: '20',
    fill: '#231e20',
    textAlign: 'center',
    effect: 'curved',
    radius: 112,
    spacing:4
  });
  n++;
  text2 = new fabric.CurvedText(label2,{
    id: 'obj_'+n,
    top:218,
    left:cSize/2,
    originX: 'center',
    originY: 'center',
    fontFamily: "Bookman",
    fontSize: '20',
    fill: '#231e20',
    textAlign: 'center',
    effect: 'curved',
    radius: 90,
    spacing: 0,
    reverse: true
  });
  n++;
  setTimeout(function(){
    window['canv_'+num].add(text1);
    window['canv_'+num].add(text2);
  },40);
  setTimeout(function(){
    window['canv_'+num].sendToBack(obj);
    window['canv_'+num].renderAll();
    loadedTemp(num);
    window['universal'+num] = ['type: bckgrnd'+num+', type: path-group, ring-1'];
    jQuery('#undo').prop('disabled', true);
  },160);
}

function loadPokerB(num){
  jQuery('.workPlace').addClass('loadedTemp');
  jQuery('.product-single').addClass('pradeTemp');
  jQuery('input[name="rounders"]#ring_1').prop('checked',true);
  var obj,text1,text2,text3,
      label1 = "EMILIO'S CASINO",
      label2 = 'ONE THOUSAND DOLLAR',
      label3 = '1000';
  imgSrc = jQuery('#back-img').attr('src');
  window['newImg_'+num] = new Image();
  window['newImg_'+num].onload = function(){
    obj = new fabric.Image(window['newImg_'+num],{
      id: 'obj_'+n,
      left: cSize/2,
      top: cSize/2,
      originX: 'center',
      originY: 'center',
      scaleX: 1,
      scaleY: 1,
      selectable: false,
      evented: false,
      hoverCursor: 'default'
    });
    obj.scaleToWidth(cSize/1.18);
    window['canv_'+num].add(obj);
    n++;
    window['canv_'+num].renderAll();
  };
  window['newImg_'+num].src = imgSrc;
  window['canv_'+num].renderAll();
  
  newRounder = jQuery('input[name="rounders"]:checked').val();
  ringURL = jQuery('input[name="rounders"]:checked+label>span').html();
  ringColor = '#bc8cbe';
  addRing(num,ringColor);
  
  text1 = new fabric.CurvedText(label1,{
    id: 'obj_'+n,
    top:72,
    left:cSize/2,
    originX: 'center',
    originY: 'center',
    fontFamily: "Bookman",
    fontSize: '20',
    fill: '#231e20',
    textAlign: 'center',
    effect: 'curved',
    radius: 112,
    spacing:4
  });
  n++;
  text2 = new fabric.CurvedText(label2,{
    id: 'obj_'+n,
    top:218,
    left:cSize/2,
    originX: 'center',
    originY: 'center',
    fontFamily: "Bookman",
    fontSize: '20',
    fill: '#231e20',
    textAlign: 'center',
    effect: 'curved',
    radius: 90,
    spacing: 0,
    reverse: true
  });
  n++;
  text3 = new fabric.Text(label3,{
    id: 'obj_'+n,
    top:cSize/2,
    left:cSize/2,
    originX: 'center',
    originY: 'center',
    fontFamily: "Bookman",
    fontSize: '90',
    charSpacing: -150,
    fill: '#f58b7e',
    stroke: '#181b1b',
    strokeWidth: 2,
    textAlign: 'center'
  });
  setTimeout(function(){
    window['canv_'+num].add(text1);
    window['canv_'+num].add(text2);
    window['canv_'+num].add(text3);
  },40);
  setTimeout(function(){
    window['canv_'+num].sendToBack(obj);
    window['canv_'+num].renderAll();
    loadedTemp(num);
    window['universal'+num] = ['type: bckgrnd'+num+', type: path-group, ring-1'];
    jQuery('#undo').prop('disabled', true);
  },160);
}

function justin2F(num){
  loadFrontImg();
  jQuery('.workPlace').addClass('loadedTemp');
  jQuery('.product-single').addClass('pradeTemp');
  var obj,text1,text2,text3,text4,text5,
      label1 = 'FRANK & LISA',
      label2 = 'WEDDING',
      label3 = '10',
      label4 = '16',
      label5 = '21';
  imgSrc = jQuery('#frnt-img').attr('src');
  window['newImg_'+num] = new Image();
  window['newImg_'+num].onload = function(){
    obj = new fabric.Image(window['newImg_'+num],{
      id: 'obj_'+n,
      left: cSize/2,
      top: cSize/2,
      originX: 'center',
      originY: 'center',
      scaleX: 1,
      scaleY: 1,
      selectable: false,
      evented: false,
      hoverCursor: 'default'
    });
    obj.scaleToWidth(cSize/1.18);
    window['canv_'+num].add(obj);
    n++;
    window['canv_'+num].renderAll();
  };
  window['newImg_'+num].src = imgSrc;
  window['canv_'+num].renderAll();
  
  text1 = new fabric.Text(label1,{
    id: 'obj_'+n,
    top:132,
    left:cSize/2,
    originX: 'center',
    originY: 'center',
    fontFamily: 'Franklin_Gothic',
    fontSize: '18',
    fill: '#e71e25',
    textAlign: 'center'
  });
  n++;
  
  text2 = new fabric.Text(label2,{
    id: 'obj_'+n,
    top:148,
    left:cSize/2,
    originX: 'center',
    originY: 'center',
    fontFamily: 'Calibri',
    fontSize: '16',
    fill: '#e71e25',
    textAlign: 'center'
  });
  n++;
  
  text3 = new fabric.Text(label3,{
    id: 'obj_'+n,
    top:205,
    left:(cSize/2)-42,
    originX: 'center',
    originY: 'center',
    fontFamily: 'abilyaregular',
    fontSize: '30',
    fill: '#e71e25',
    textAlign: 'center'
  });
  n++;
  
  text4 = new fabric.Text(label4,{
    id: 'obj_'+n,
    top:205,
    left:cSize/2,
    originX: 'center',
    originY: 'center',
    fontFamily: 'abilyaregular',
    fontSize: '30',
    fill: '#e71e25',
    textAlign: 'center'
  });
  n++;
  
  text5 = new fabric.Text(label5,{
    id: 'obj_'+n,
    top:205,
    left:(cSize/2)+44,
    originX: 'center',
    originY: 'center',
    fontFamily: 'abilyaregular',
    fontSize: '30',
    fill: '#e71e25',
    textAlign: 'center'
  });
  n++;
  text1.lockMovementX = true;
  text2.lockMovementX = true;
  text3.lockMovementX = true;
  text4.lockMovementX = true;
  text5.lockMovementX = true;
  setTimeout(function(){
    window['canv_'+num].add(text1);
    window['canv_'+num].add(text2);
    window['canv_'+num].add(text3);
    window['canv_'+num].add(text4);
    window['canv_'+num].add(text5);
  },40);
  setTimeout(function(){
    window['canv_'+num].sendToBack(obj);
    window['canv_'+num].renderAll();
    loadedTemp(num);
    jQuery('input[name="pro_color"]#red').prop('checked',true).change();
    window['universal'+num] = ['type: bckgrnd'+num+', type: path-group, ring-0'];
    jQuery('#undo').prop('disabled', true);
  },160);
}

function freeDrinkF(num){
  loadFrontImg();
  jQuery('.workPlace').addClass('loadedTemp');
  jQuery('.product-single').addClass('pradeTemp');
  var obj,text1,text2,text3,
      label1 = 'FREE\nDRINK',
      label2 = '702-355-6869',
      label3 = 'WWW.WEBSITEGOESHERE.COM';
  window['canv_'+num].backgroundColor = '#dfc124';
  imgSrc = jQuery('#frnt-img').attr('src');
  window['newImg_'+num] = new Image();
  window['newImg_'+num].onload = function(){
    obj = new fabric.Image(window['newImg_'+num],{
      id: 'obj_'+n,
      left: cSize/2,
      top: cSize/2,
      originX: 'center',
      originY: 'center',
      scaleX: 1,
      scaleY: 1,
      selectable: false,
      evented: false,
      hoverCursor: 'default'
    });
    obj.scaleToWidth(cSize/1.18);
    window['canv_'+num].add(obj);
    n++;
    window['canv_'+num].renderAll();
  };
  window['newImg_'+num].src = imgSrc;
  window['canv_'+num].renderAll();
  
  text1 = new fabric.Text(label1,{
    id: 'obj_'+n,
    top:106,
    left:cSize/2,
    originX: 'center',
    originY: 'center',
    fontFamily: 'Impact',
    fontSize: '54',
    lineHeight: .75,
    fill: '#000',
    textAlign: 'center'
  });
  n++;
  text2 = new fabric.Text(label2,{
    id: 'obj_'+n,
    top:190,
    left:cSize/2,
    originX: 'center',
    originY: 'center',
    fontFamily: "'Arial',sans-serif",
    fontSize: '14',
    fill: '#000',
    textAlign: 'center'
  });
  n++;
  text3 = new fabric.CurvedText(label3,{
    id: 'obj_'+n,
    top:236,
    left:cSize/2,
    originX: 'center',
    originY: 'center',
    fontFamily: "'Arial',sans-serif",
    fontSize: '9',
    fill: '#000000',
    textAlign: 'center',
    effect: 'curved',
    radius: 86,
    spacing: 0,
    reverse: true
  });
  n++;
  text1.lockMovementX = true;
  text2.lockMovementX = true;
  text3.lockMovementX = true;
  setTimeout(function(){
    window['canv_'+num].add(text1);
    window['canv_'+num].add(text2);
    window['canv_'+num].add(text3);
  },40);
  
  setTimeout(function(){
    window['canv_'+num].sendToBack(obj);
    window['canv_'+num].renderAll();
    loadedTemp(num);
    jQuery('input[name="pro_color"]#blue').prop('checked',true).change();
    window['universal'+num] = ['type: bckgrnd'+num+', type: path-group, ring-0'];
    jQuery('#undo').prop('disabled', true);
  },160);
}

function oneBeerF(num){
  loadFrontImg();
  noBackgrounds(num);
  jQuery('.workPlace').addClass('loadedTemp');
  jQuery('.product-single').addClass('pradeTemp');
  var obj,text1,text2,text3,text4,
      label1 = 'MAIN STREET BAR & GRILL',
      label2 = 'RICHFIELD IDAHO',
      label3 = 'Good for',
      label4 = 'One Beer';
  imgSrc = jQuery('#frnt-img').attr('src');
  window['newImg_'+num] = new Image();
  window['newImg_'+num].onload = function(){
    obj = new fabric.Image(window['newImg_'+num],{
      id: 'obj_'+n,
      left: cSize/2,
      top: cSize/2,
      originX: 'center',
      originY: 'center',
      scaleX: 1,
      scaleY: 1,
      selectable: false,
      evented: false,
      hoverCursor: 'default'
    });
    obj.scaleToWidth(cSize/1.18);
    window['canv_'+num].add(obj);
    n++;
    window['canv_'+num].renderAll();
  };
  window['newImg_'+num].src = imgSrc;
  window['canv_'+num].renderAll();
  
  text1 = new fabric.CurvedText(label1,{
    id: 'obj_'+n,
    top:92,
    left:cSize/2,
    originX: 'center',
    originY: 'center',
    fontFamily: "'Arial',sans-serif",
    fontSize: '24',
    fill: '#000000',
    textAlign: 'center',
    effect: 'curved',
    radius: 120,
    spacing: 2
  });
  n++;
  text2 = new fabric.CurvedText(label2,{
    id: 'obj_'+n,
    top:228,
    left:cSize/2,
    originX: 'center',
    originY: 'center',
    fontFamily: "'Arial',sans-serif",
    fontSize: '24',
    fontWeight: 'bold',
    fill: '#000000',
    textAlign: 'center',
    effect: 'curved',
    radius: 90,
    spacing: 0,
    reverse: true
  });
  n++;
  text3 = new fabric.Text(label3,{
    id: 'obj_'+n,
    top:(cSize/2) - 16,
    left:cSize/2,
    originX: 'center',
    originY: 'center',
    fontFamily: 'Georgia',
    fontWeight: 'bold',
    fontSize: '24',
    fill: '#000',
    textAlign: 'center',
    stroke: '#fff',
    strokeWidth: '1',
    editing: true
  });
  n++;
  text4 = new fabric.Text(label4,{
    id: 'obj_'+n,
    top:(cSize/2) + 10,
    left:cSize/2,
    originX: 'center',
    originY: 'center',
    fontFamily: 'Georgia',
    fontWeight: 'bold',
    fontSize: '28',
    fill: '#000',
    textAlign: 'center',
    stroke: '#fff',
    strokeWidth: '1',
    editing: true
  });
  n++;
  text1.lockMovementX = true;
  text2.lockMovementX = true;
  text3.lockMovementX = true;
  text3.lockMovementY = true;
  text4.lockMovementX = true;
  text4.lockMovementY = true;
  console.log(text3);
  setTimeout(function(){
    window['canv_'+num].add(text1);
    window['canv_'+num].add(text2);
    window['canv_'+num].add(text3);
    window['canv_'+num].add(text4);
  },40);
  setTimeout(function(){
    window['canv_'+num].sendToBack(obj);
    window['canv_'+num].renderAll();
    loadedTemp(num);
    window['universal'+num] = ['type: bckgrnd'+num+', type: path-group, ring-0'];
    jQuery('#undo').prop('disabled', true);
  },160);
}

function oneBeerB(num){
  noBackgrounds(num);
  var obj,text1,text2,text3,text4,
      label1 = 'MAIN STREET BAR & GRILL',
      label2 = 'RICHFIELD IDAHO',
      label3 = 'Good for',
      label4 = 'One Drink';
  imgSrc = jQuery('#back-img').attr('src');
  window['newImg_'+num] = new Image();
  window['newImg_'+num].onload = function(){
    obj = new fabric.Image(window['newImg_'+num],{
      id: 'obj_'+n,
      left: cSize/2,
      top: cSize/2,
      originX: 'center',
      originY: 'center',
      scaleX: 1,
      scaleY: 1,
      selectable: false,
      evented: false,
      hoverCursor: 'default'
    });
    obj.scaleToWidth(cSize/1.18);
    window['canv_'+num].add(obj);
    n++;
    window['canv_'+num].renderAll();
  };
  window['newImg_'+num].src = imgSrc;
  window['canv_'+num].renderAll();
  
  text1 = new fabric.CurvedText(label1,{
    id: 'obj_'+n,
    top:92,
    left:cSize/2,
    originX: 'center',
    originY: 'center',
    fontFamily: "'Arial',sans-serif",
    fontSize: '24',
    fill: '#000000',
    textAlign: 'center',
    effect: 'curved',
    radius: 120,
    spacing: 2
  });
  n++;
  text2 = new fabric.CurvedText(label2,{
    id: 'obj_'+n,
    top:228,
    left:cSize/2,
    originX: 'center',
    originY: 'center',
    fontFamily: "'Arial',sans-serif",
    fontSize: '24',
    fontWeight: 'bold',
    fill: '#000000',
    textAlign: 'center',
    effect: 'curved',
    radius: 90,
    spacing: 0,
    reverse: true
  });
  n++;
  text3 = new fabric.Text(label3,{
    id: 'obj_'+n,
    top:(cSize/2) - 16,
    left:cSize/2,
    originX: 'center',
    originY: 'center',
    fontFamily: 'Georgia',
    fontWeight: 'bold',
    fontSize: '24',
    fill: '#000',
    textAlign: 'center',
    stroke: '#fff',
    strokeWidth: '1',
    editing: true
  });
  n++;
  text4 = new fabric.Text(label4,{
    id: 'obj_'+n,
    top:(cSize/2) + 10,
    left:cSize/2,
    originX: 'center',
    originY: 'center',
    fontFamily: 'Georgia',
    fontWeight: 'bold',
    fontSize: '28',
    fill: '#000',
    textAlign: 'center',
    stroke: '#fff',
    strokeWidth: '1',
    editing: true
  });
  n++;
  text1.lockMovementX = true;
  text2.lockMovementX = true;
  text3.lockMovementX = true;
  text3.lockMovementY = true;
  text4.lockMovementX = true;
  text4.lockMovementY = true;
  console.log(text3);
  setTimeout(function(){
    window['canv_'+num].add(text1);
    window['canv_'+num].add(text2);
    window['canv_'+num].add(text3);
    window['canv_'+num].add(text4);
  },40);
  setTimeout(function(){
    window['canv_'+num].sendToBack(obj);
    window['canv_'+num].renderAll();
    loadedTemp(num);
    window['universal'+num] = ['type: bckgrnd'+num+', type: path-group, ring-0'];
    jQuery('#undo').prop('disabled', true);
  },160);
}

function freeDrinkB(num){
  var obj,text1,text2,
      label1 = 'THREE\nANGRY\nWIVES\nPUB',
      label2 = 'WWW.WEBSITEGOESHERE.COM';
  window['canv_'+num].backgroundColor = '#ff69b4';
  imgSrc = jQuery('#frnt-img').attr('src');
  window['newImg_'+num] = new Image();
  window['newImg_'+num].onload = function(){
    obj = new fabric.Image(window['newImg_'+num],{
      id: 'obj_'+n,
      left: cSize/2,
      top: cSize/2,
      originX: 'center',
      originY: 'center',
      scaleX: 1,
      scaleY: 1,
      selectable: false,
      evented: false,
      hoverCursor: 'default'
    });
    obj.scaleToWidth(cSize/1.18);
    window['canv_'+num].add(obj);
    n++;
    window['canv_'+num].renderAll();
  };
  window['newImg_'+num].src = imgSrc;
  window['canv_'+num].renderAll();
  
  text1 = new fabric.Text(label1,{
    id: 'obj_'+n,
    top:126,
    left:cSize/2,
    originX: 'center',
    originY: 'center',
    fontFamily: 'Impact',
    fontSize: '32',
    lineHeight: .9,
    fill: '#000000',
    textAlign: 'center'
  });
  n++;
  text2 = new fabric.CurvedText(label2,{
    id: 'obj_'+n,
    top:236,
    left:cSize/2,
    originX: 'center',
    originY: 'center',
    fontFamily: "'Arial',sans-serif",
    fontSize: '9',
    fill: '#000000',
    textAlign: 'center',
    effect: 'curved',
    radius: 86,
    spacing: 0,
    reverse: true
  });
  n++;
  text1.lockMovementX = true;
  text2.lockMovementX = true;
  setTimeout(function(){
    window['canv_'+num].add(text1);
    window['canv_'+num].add(text2);
  },40);
  setTimeout(function(){
    window['canv_'+num].sendToBack(obj);
    window['canv_'+num].renderAll();
    loadedTemp(num);
    window['universal'+num] = ['type: bckgrnd'+num+', type: path-group, ring-0'];
    jQuery('#undo').prop('disabled', true);
  },160);
}

function grandOpening(num){
  loadFrontImg();
  noBackgrounds(num);
  jQuery('#royalt').prop('checked',true).change();
  jQuery('.workPlace').addClass('loadedTemp');
  jQuery('.product-single').addClass('pradeTemp');
  var obj,text1,
      label1= 'July 4th, 2019';
  imgSrc = jQuery('#frnt-img').attr('src');
  window['newImg_'+num] = new Image();
  window['newImg_'+num].onload = function(){
    obj = new fabric.Image(window['newImg_'+num],{
      id: 'obj_'+n,
      left: cSize/2,
      top: cSize/2,
      originX: 'center',
      originY: 'center',
      scaleX: 1,
      scaleY: 1,
      selectable: false,
      evented: false,
      hoverCursor: 'default'
    });
    obj.scaleToWidth(cSize/1.18);
    window['canv_'+num].add(obj);
    n++;
    window['canv_'+num].renderAll();
  };
  window['newImg_'+num].src = imgSrc;
  window['canv_'+num].renderAll();
  
  text1 = new fabric.CurvedText(label1,{
    id: 'obj_'+n,
    top:244,
    left:cSize/2,
    originX: 'center',
    originY: 'center',
    fontFamily: "'Arial',sans-serif",
    fontSize: '18',
    fontWeight: 'bold',
    fill: '#e30405',
    stroke: '#fff',
    strokeWidth: 2,
    textAlign: 'center',
    effect: 'curved',
    radius: 84,
    spacing: 0,
    reverse: true
  });
  n++;
  text1.lockMovementX = true;
  setTimeout(function(){
    window['canv_'+num].add(text1);
  },40);
  setTimeout(function(){
    window['canv_'+num].sendToBack(obj);
    window['canv_'+num].renderAll();
    loadedTemp(num);
    window['universal'+num] = ['type: bckgrnd'+num+', type: path-group, ring-0'];
    jQuery('#undo').prop('disabled', true);
  },160);
}

function brideGroomsmanF(num){
  loadFrontImg();
  jQuery('.workPlace').addClass('loadedTemp');
  jQuery('.product-single').addClass('pradeTemp');
  window['canv_'+num].backgroundColor = '#000';
  var obj,text1,text2,
      label1 = 'Groomsman Assemble!',
      label2 = 'Bachelor Party 6/6/2030';
  imgSrc = jQuery('#frnt-img').attr('src');
  window['newImg_'+num] = new Image();
  window['newImg_'+num].onload = function(){
    obj = new fabric.Image(window['newImg_'+num],{
      id: 'obj_'+n,
      left: cSize/2,
      top: cSize/2,
      originX: 'center',
      originY: 'center',
      scaleX: 1,
      scaleY: 1,
      selectable: false,
      evented: false,
      hoverCursor: 'default'
    });
    obj.scaleToWidth(cSize/1.18);
    window['canv_'+num].add(obj);
    n++;
    window['canv_'+num].renderAll();
  };
  window['newImg_'+num].src = imgSrc;
  window['canv_'+num].renderAll();
  text1 = new fabric.CurvedText(label1,{
    id: 'obj_'+n,
    top:70,
    left:cSize/2,
    originX: 'center',
    originY: 'center',
    fontFamily: "'Arial',sans-serif",
    fontSize: '18',
    fill: '#ffffff',
    textAlign: 'center',
    effect: 'curved',
    radius: 115,
    spacing:4
  });
  n++;
  text2 = new fabric.CurvedText(label2,{
    id: 'obj_'+n,
    top:228,
    left:cSize/2,
    originX: 'center',
    originY: 'center',
    fontFamily: "'Arial',sans-serif",
    fontSize: '18',
    fill: '#ffffff',
    textAlign: 'center',
    effect: 'curved',
    radius: 84,
    spacing: 0,
    reverse: true
  });
  n++;
  text1.lockMovementX = true;
  text2.lockMovementX = true;
  setTimeout(function(){
    window['canv_'+num].add(text1);
    window['canv_'+num].add(text2);
  },40);
  setTimeout(function(){
    window['canv_'+num].sendToBack(obj);
    window['canv_'+num].renderAll();
    loadedTemp(num);
    jQuery('input[name="pro_color"]#blue').prop('checked',true).change();
    window['universal'+num] = ['type: bckgrnd'+num+', type: path-group, ring-0'];
    jQuery('#undo').prop('disabled', true);
  },160);
}

function hennessey2F(num){
  loadFrontImg();
  noBackgrounds(num);
  jQuery('#spot_12').prop('checked',true).change();
  jQuery('.workPlace').addClass('loadedTemp');
  jQuery('.product-single').addClass('pradeTemp');
  var obj,text1,
      label1 = 'www.highoctanesaloon.com';
  window['canv_'+num].backgroundColor = '#000';
  imgSrc = jQuery('#frnt-img').attr('src');
  window['newImg_'+num] = new Image();
  window['newImg_'+num].onload = function(){
    obj = new fabric.Image(window['newImg_'+num],{
      id: 'obj_'+n,
      left: cSize/2,
      top: cSize/2,
      originX: 'center',
      originY: 'center',
      scaleX: 1,
      scaleY: 1
    });
    obj.scaleToWidth(cSize/1.18);
    window['canv_'+num].add(obj);
    n++;
    window['canv_'+num].renderAll();
  };
  window['newImg_'+num].src = imgSrc;
  window['canv_'+num].renderAll();
  
  text1 = new fabric.CurvedText(label1,{
    id: 'obj_'+n,
    top:244,
    left:cSize/2,
    originX: 'center',
    originY: 'center',
    fontFamily: 'Athelas',
    fontSize: '12',
    fill: '#ffffff',
    textAlign: 'center',
    effect: 'curved',
    radius: 94,
    spacing: 0,
    reverse: true
  });
  n++;
  text1.lockMovementX = true;
  setTimeout(function(){
    window['canv_'+num].add(text1);
  },40);
  setTimeout(function(){
    window['canv_'+num].sendToBack(obj);
    window['canv_'+num].renderAll();
    loadedTemp(num);
    window['universal'+num] = ['type: bckgrnd'+num+', type: path-group, ring-0'];
    jQuery('#undo').prop('disabled', true);
  },160);
}

function hennessey2B(num){
  jQuery('.workPlace').addClass('loadedTemp');
  jQuery('.product-single').addClass('pradeTemp');
  var obj,text1,text2,
      label1 = 'THIS GUY',
      label2 = '1 FREE DRINK';
  window['canv_'+num].backgroundColor = '#ed6d16';
  imgSrc = jQuery('#back-img').attr('src');
  window['newImg_'+num] = new Image();
  window['newImg_'+num].onload = function(){
    obj = new fabric.Image(window['newImg_'+num],{
      id: 'obj_'+n,
      left: cSize/2,
      top: cSize/2,
      originX: 'center',
      originY: 'center',
      scaleX: 1,
      scaleY: 1
    });
    obj.scaleToWidth(cSize/1.18);
    window['canv_'+num].add(obj);
    n++;
    window['canv_'+num].renderAll();
  };
  window['newImg_'+num].src = imgSrc;
  window['canv_'+num].renderAll();
  
  text1 = new fabric.Text(label1,{
    id: 'obj_'+n,
    top:66,
    left:cSize/2,
    originX: 'center',
    originY: 'center',
    fontFamily: 'Georgia',
    fontSize: '16',
    fill: '#000000',
    textAlign: 'center'
  });
  n++;
  
  text2 = new fabric.Text(label2,{
    id: 'obj_'+n,
    top:102,
    left:cSize/2,
    originX: 'center',
    originY: 'center',
    fontFamily: 'Impact',
    fontSize: '26',
    lineHeight: .75,
    fill: '#000000',
    textAlign: 'center'
  });
  n++;
  text1.lockMovementX = true;
  text2.lockMovementX = true;
  setTimeout(function(){
    //window['canv_'+num].add(text1);
    window['canv_'+num].add(text2);
  },40);
  setTimeout(function(){
    window['canv_'+num].sendToBack(obj);
    window['canv_'+num].renderAll();
    loadedTemp(num);
    window['universal'+num] = ['type: bckgrnd'+num+', type: path-group, ring-0'];
    jQuery('#undo').prop('disabled', true);
  },160);
}

function jasonCasino(num){
  loadFrontImg();
  jQuery('#royalt').prop('checked',true).change();
  jQuery('.workPlace').addClass('loadedTemp');
  jQuery('.product-single').addClass('pradeTemp');
  window['canv_'+num].backgroundColor = '#0d6835';
  var obj,text1,text2,
      label1 = 'Jason’s casino',
      label2 = '$25';
  imgSrc = jQuery('#frnt-img').attr('src');
  window['newImg_'+num] = new Image();
  window['newImg_'+num].onload = function(){
    obj = new fabric.Image(window['newImg_'+num],{
      id: 'obj_'+n,
      left: cSize/2,
      top: cSize/2,
      originX: 'center',
      originY: 'center',
      scaleX: 1,
      scaleY: 1,
      selectable: false,
      evented: false,
      hoverCursor: 'default'
    });
    obj.scaleToWidth(cSize/1.18);
    window['canv_'+num].add(obj);
    n++;
    window['canv_'+num].renderAll();
  };
  window['newImg_'+num].src = imgSrc;
  window['canv_'+num].renderAll();
  
  text1 = new fabric.CurvedText(label1,{
    id: 'obj_'+n,
    top:74,
    left:cSize/2,
    originX: 'center',
    originY: 'center',
    fontFamily: 'Impact',
    fontSize: '24',
    fill: '#dfc124',
    stroke: '#010101',
    strokeWidth: 1,
    textAlign: 'center',
    effect: 'curved',
    radius: 96,
    spacing:3
  });
  n++;
  
  text2 = new fabric.Text(label2,{
    id: 'obj_'+n,
    top:240,
    left:cSize/2,
    originX: 'center',
    originY: 'center',
    fontFamily: 'Impact',
    fontSize: '26',
    fill: '#dfc124',
    stroke: '#010101',
    strokeWidth: 1,
    textAlign: 'center'
  });
  n++;
  text1.lockMovementX = true;
  text2.lockMovementX = true;
  setTimeout(function(){
    window['canv_'+num].add(text1);
    window['canv_'+num].add(text2);
  },40);
  setTimeout(function(){
    window['canv_'+num].sendToBack(obj);
    window['canv_'+num].renderAll();
    loadedTemp(num);
    jQuery('input[name="pro_color"]#green').prop('checked',true).change();
    window['universal'+num] = ['type: bckgrnd'+num+', type: path-group, ring-0'];
    jQuery('#undo').prop('disabled', true);
  },160);
}

function justinKellyF(num){
  loadFrontImg();
  noBackgrounds(num);
  jQuery('#rounders').prop('checked',true).change();
  jQuery('.workPlace').addClass('loadedTemp');
  jQuery('.product-single').addClass('pradeTemp');
  var obj,text1,text2,
      label1 = 'MARK & BECKY',
      label2 = '02/12/22';
  imgSrc = jQuery('#frnt-img').attr('src');
  window['newImg_'+num] = new Image();
  window['newImg_'+num].onload = function(){
    obj = new fabric.Image(window['newImg_'+num],{
      id: 'obj_'+n,
      left: cSize/2,
      top: cSize/2,
      originX: 'center',
      originY: 'center',
      scaleX: 1,
      scaleY: 1
    });
    obj.scaleToWidth(cSize/1.18);
    window['canv_'+num].add(obj);
    n++;
    window['canv_'+num].renderAll();
  };
  window['newImg_'+num].src = imgSrc;
  window['canv_'+num].renderAll();
  
  text1 = new fabric.CurvedText(label1,{
    id: 'obj_'+n,
    top:68,
    left:cSize/2,
    originX: 'center',
    originY: 'center',
    fontFamily: 'Georgia',
    fontSize: '24',
    fontWeight: 'bold',
    fill: '#000000',
    stroke: '#fff',
    strokeWidth: 3,
    textAlign: 'center',
    effect: 'curved',
    radius: 120,
    spacing:4
  });
  n++;
  
  text2 = new fabric.CurvedText(label2,{
    id: 'obj_'+n,
    top:248,
    left:cSize/2,
    originX: 'center',
    originY: 'center',
    fontFamily: 'Georgia',
    fontSize: '24',
    fontWeight: 'bold',
    fill: '#000000',
    stroke: '#fff',
    strokeWidth: 3,
    textAlign: 'center',
    effect: 'curved',
    radius: 84,
    spacing: 0,
    reverse: true
  });
  n++;
  text1.lockMovementX = true;
  text2.lockMovementX = true;
  setTimeout(function(){
    window['canv_'+num].add(text1);
    window['canv_'+num].add(text2);
  },40);
  setTimeout(function(){
    window['canv_'+num].sendToBack(obj);
    window['canv_'+num].renderAll();
    loadedTemp(num);
    //console.log(window['universal'+num]);
    window['universal'+num] = ['type: bckgrnd'+num+', type: path-group, ring-0'];
    //console.log(window['universal'+num]);
    jQuery('#undo').attr('disabled', true);
  },160);
}

function justinKellyB(num){
  noBackgrounds(num);
  jQuery('.workPlace').addClass('loadedTemp');
  jQuery('.product-single').addClass('pradeTemp');
  var obj,text1,text2,
      label1 = 'MARK & BECKY',
      label2 = '02/12/22';
  imgSrc = jQuery('#back-img').attr('src');
  window['newImg_'+num] = new Image();
  window['newImg_'+num].onload = function(){
    obj = new fabric.Image(window['newImg_'+num],{
      id: 'obj_'+n,
      left: cSize/2,
      top: cSize/2,
      originX: 'center',
      originY: 'center',
      scaleX: 1,
      scaleY: 1,
      selectable: false,
      evented: false,
      hoverCursor: 'default'
    });
    obj.scaleToWidth(cSize/1.18);
    window['canv_'+num].add(obj);
    n++;
    window['canv_'+num].renderAll();
  };
  window['newImg_'+num].src = imgSrc;
  window['canv_'+num].renderAll();
  
  text1 = new fabric.CurvedText(label1,{
    id: 'obj_'+n,
    top:68,
    left:cSize/2,
    originX: 'center',
    originY: 'center',
    fontFamily: 'Georgia',
    fontSize: '24',
    fontWeight: 'bold',
    fill: '#000000',
    stroke: '#fff',
    strokeWidth: 3,
    textAlign: 'center',
    effect: 'curved',
    radius: 120,
    spacing:4
  });
  n++;
  
  text2 = new fabric.CurvedText(label2,{
    id: 'obj_'+n,
    top:248,
    left:cSize/2,
    originX: 'center',
    originY: 'center',
    fontFamily: 'Georgia',
    fontSize: '24',
    fontWeight: 'bold',
    fill: '#000000',
    stroke: '#fff',
    strokeWidth: 3,
    textAlign: 'center',
    effect: 'curved',
    radius: 84,
    spacing: 0,
    reverse: true
  });
  n++;
  
  text1.lockMovementX = true;
  text2.lockMovementX = true;
  setTimeout(function(){
    window['canv_'+num].add(text1);
    window['canv_'+num].add(text2);
  },40);
  
  setTimeout(function(){
    window['canv_'+num].sendToBack(obj);
    window['canv_'+num].renderAll();
    loadedTemp(num);
    window['universal'+num] = ['type: bckgrnd'+num+', type: path-group, ring-0'];
    jQuery('#undo').prop('disabled', true);
  },160);
}

function martiniChip(num){
  loadFrontImg();
  jQuery('#spot_12').prop('checked',true).change();
  jQuery('.workPlace').addClass('loadedTemp');
  jQuery('.product-single').addClass('pradeTemp');
  window['canv_'+num].backgroundColor = '#bc8cbe';
  jQuery('input[name="rounders"]#ring_3').prop('checked',true);
  var obj,text1,text2,
      label1 = 'O’KEEFE’S PUB',
      label2 = 'ONE FREE DRINK';
  
  newRounder = jQuery('input[name="rounders"]:checked').val();
  ringURL	 = jQuery('input[name="rounders"]:checked+label>span').html();
  ringColor  = '#ffffff';
  addRing(num,ringColor);
  
  imgSrc = jQuery('#frnt-img').attr('src');
  window['newImg_'+num] = new Image();
  window['newImg_'+num].onload = function(){
    obj = new fabric.Image(window['newImg_'+num],{
      id: 'obj_'+n,
      left: cSize/2,
      top: cSize/2,
      originX: 'center',
      originY: 'center',
      scaleX: 1,
      scaleY: 1,
      selectable: false,
      evented: false,
      hoverCursor: 'default'
    });
    obj.scaleToWidth(cSize/1.18);
    window['canv_'+num].add(obj);
    n++;
    window['canv_'+num].renderAll();
  };
  window['newImg_'+num].src = imgSrc;
  window['canv_'+num].renderAll();
  text1 = new fabric.CurvedText(label1,{
    id: 'obj_'+n,
    top:80,
    left:cSize/2,
    originX: 'center',
    originY: 'center',
    fontFamily: 'Impact',
    fontSize: '26',
    fill: '#000000',
    textAlign: 'center',
    effect: 'curved',
    radius: 110,
    spacing:10
  });
  n++;
  text2 = new fabric.CurvedText(label2,{
    id: 'obj_'+n,
    top:222,
    left:cSize/2,
    originX: 'center',
    originY: 'center',
    fontFamily: 'Impact',
    fontSize: '26',
    fill: '#000000',
    textAlign: 'center',
    effect: 'curved',
    radius: 84,
    spacing: 5,
    reverse: true
  });
  n++;
  text1.lockMovementX = true;
  text2.lockMovementX = true;
  setTimeout(function(){
    window['canv_'+num].add(text1);
    window['canv_'+num].add(text2);
  },40);
  setTimeout(function(){
    window['canv_'+num].sendToBack(obj);
    window['canv_'+num].sendToBack(window['ring_'+num]);
    window['canv_'+num].renderAll();
    loadedTemp(num);
    window['universal'+num] = ['type: bckgrnd'+num+', type: path-group, ring-0'];
    jQuery('#undo').prop('disabled', true);
  },160);
}

function justinWedding(num){
  loadFrontImg();
  noBackgrounds(num);
  jQuery('#royalt').prop('checked',true).change();
  jQuery('.workPlace').addClass('loadedTemp');
  jQuery('.product-single').addClass('pradeTemp');
  var obj,text1,text2,text3,text4,text5,
      label1 = 'MIKE & AMY',
      label2 = 'WEDDING',
      label3 = '10',
      label4 = '16',
      label5 = '21';
  imgSrc = jQuery('#frnt-img').attr('src');
  window['newImg_'+num] = new Image();
  window['newImg_'+num].onload = function(){
    obj = new fabric.Image(window['newImg_'+num],{
      id: 'obj_'+n,
      left: cSize/2,
      top: cSize/2,
      originX: 'center',
      originY: 'center',
      scaleX: 1,
      scaleY: 1,
      selectable: false,
      evented: false,
      hoverCursor: 'default'
    });
    obj.scaleToWidth(cSize/1.18);
    window['canv_'+num].add(obj);
    n++;
    window['canv_'+num].renderAll();
  };
  window['newImg_'+num].src = imgSrc;
  window['canv_'+num].renderAll();
  
  text1 = new fabric.Text(label1,{
    id: 'obj_'+n,
    top:132,
    left:cSize/2,
    originX: 'center',
    originY: 'center',
    fontFamily: 'Franklin_Gothic',
    fontSize: '18',
    fill: '#e71e25',
    textAlign: 'center'
  });
  n++;
  
  text2 = new fabric.Text(label2,{
    id: 'obj_'+n,
    top:148,
    left:cSize/2,
    originX: 'center',
    originY: 'center',
    fontFamily: 'Calibri',
    fontSize: '16',
    fill: '#e71e25',
    textAlign: 'center'
  });
  n++;
  
  text3 = new fabric.Text(label3,{
    id: 'obj_'+n,
    top:207.75,
    left:(cSize/2)-40,
    originX: 'center',
    originY: 'center',
    fontFamily: 'abilyaregular',
    fontSize: '30',
    lineHeight: '30',
    fill: '#e71e25',
    textAlign: 'center'
  });
  n++;
  
  text4 = new fabric.Text(label4,{
    id: 'obj_'+n,
    top:207.75,
    left:cSize/2,
    originX: 'center',
    originY: 'center',
    fontFamily: 'abilyaregular',
    fontSize: '30',
    lineHeight: '30',
    fill: '#e71e25',
    textAlign: 'center'
  });
  n++;
  
  text5 = new fabric.Text(label5,{
    id: 'obj_'+n,
    top:207.75,
    left:(cSize/2)+40,
    originX: 'center',
    originY: 'center',
    fontFamily: 'abilyaregular',
    fontSize: '30',
    lineHeight: '30',
    fill: '#e71e25',
    textAlign: 'center'
  });
  n++;
  text1.lockMovementX = true;
  text2.lockMovementX = true;
  text3.lockMovementX = true;
  text4.lockMovementX = true;
  text5.lockMovementX = true;
  setTimeout(function(){
    window['canv_'+num].add(text1);
    window['canv_'+num].add(text2);
    window['canv_'+num].add(text3);
    window['canv_'+num].add(text4);
    window['canv_'+num].add(text5);
  },40);
  setTimeout(function(){
    window['canv_'+num].sendToBack(obj);
    window['canv_'+num].renderAll();
    loadedTemp(num);
    jQuery('input[name="pro_color"]#red').prop('checked',true).change();
    window['universal'+num] = ['type: bckgrnd'+num+', type: path-group, ring-0'];
    jQuery('#undo').prop('disabled', true);
  },160);
}

function loadPromoF(num){
  loadFrontImg();
  jQuery('.workPlace').addClass('loadedTemp');
  jQuery('.product-single').addClass('pradeTemp');
  var obj,text1,text2,
      label1 = "ESTHER'S KITCHEN",
      label2 = 'Seasonal Italian Soul Food In The Arts District';
  imgSrc = jQuery('#frnt-img').attr('src');
  window['newImg_'+num] = new Image();
  window['newImg_'+num].onload = function(){
    obj = new fabric.Image(window['newImg_'+num],{
      id: 'obj_'+n,
      left: cSize/2,
      top: cSize/2,
      originX: 'center',
      originY: 'center',
      scaleX: 1,
      scaleY: 1
    });
    obj.scaleToWidth(cSize/1.18);
    window['canv_'+num].add(obj);
    n++;
    window['canv_'+num].renderAll();
  };
  
  window['newImg_'+num].src = imgSrc;
  window['canv_'+num].renderAll();
  text1 = new fabric.Text(label1,{
    id: 'obj_'+n,
    top:(cSize/2)-8,
    left:cSize/2,
    originX: 'center',
    originY: 'center',
    fontFamily: "'Arial',sans-serif",
    fontSize: '18',
    letterSpacing: 1,
    fill: '#ffffff',
    textAlign: 'center'
  });
  n++;
  text2 = new fabric.Text(label2,{
    id: 'obj_'+n,
    top:(cSize/2)+12,
    left:cSize/2,
    originX: 'center',
    originY: 'center',
    fontFamily: "Calibri",
    fontSize: '10',
    fill: '#ffffff',
    textAlign: 'center'
  });
  n++;
  setTimeout(function(){
    window['canv_'+num].add(text1);
    window['canv_'+num].add(text2);
  },40);
  setTimeout(function(){
    window['canv_'+num].sendToBack(obj);
    window['canv_'+num].renderAll();
    loadedTemp(num);
    window['universal'+num] = ['type: bckgrnd'+num+', type: path-group, ring-0'];
    jQuery('#undo').prop('disabled', true);
  },160);
}

function loadPromoB(num){
  jQuery('.workPlace').addClass('loadedTemp');
  jQuery('.product-single').addClass('pradeTemp');
  var text1,text2,text3,text4,text5,text6,
      label1 = "ESTHER'S KITCHEN",
      label2 = '$',
      label3 = '10',
      label4 = 'OFF',
      label5 = '$100 OR MORE',
      label6 = '1700 E. Viking Rd Las\nVegas NV, 89119';
  window['canv_'+num].backgroundColor = '#005f8a';
  window['canv_'+num].renderAll();
  text1 = new fabric.CurvedText(label1,{
    id: 'obj_'+n,
    top:72,
    left:cSize/2,
    originX: 'center',
    originY: 'center',
    fontFamily: "'Arial',sans-serif",
    fontSize: '16',
    fill: '#ffffff',
    textAlign: 'center',
    effect: 'curved',
    radius: 106,
    spacing:2
  });
  n++;
  text2 = new fabric.Text(label2,{
    id: 'obj_'+n,
    top:124,
    left:77,
    originX: 'center',
    originY: 'center',
    fontFamily: 'abilyaregular',
    fontSize: '34',
    fill: '#ff0000',
    textAlign: 'left'
  });
  n++;
  text3 = new fabric.Text(label3,{
    id: 'obj_'+n,
    top:140,
    left:126,
    originX: 'center',
    originY: 'center',
    fontFamily: 'abilyaregular',
    fontSize: '106',
    fill: '#ff0000',
    textAlign: 'left'
  });
  n++;
  text4 = new fabric.Text(label4,{
    id: 'obj_'+n,
    top:162,
    left:210,
    originX: 'center',
    originY: 'center',
    fontFamily: 'abilyaregular',
    fontSize: '34',
    fill: '#ff0000',
    textAlign: 'left'
  });
  n++;
  text5 = new fabric.Text(label5,{
    id: 'obj_'+n,
    top:192,
    left:cSize/2,
    originX: 'center',
    originY: 'center',
    fontFamily: 'abilyaregular',
    fontSize: '20',
    fill: '#ffffff',
    textAlign: 'center'
  });
  n++;
  text6 = new fabric.Text(label6,{
    id: 'obj_'+n,
    top:222,
    left:cSize/2,
    originX: 'center',
    originY: 'center',
    fontFamily: "'Arial',sans-serif",
    fontSize: '14',
    lineHeight: 1.2,
    fill: '#ffffff',
    textAlign: 'center'
  });
  setTimeout(function(){
    window['canv_'+num].add(text1);
    window['canv_'+num].add(text2);
    window['canv_'+num].add(text3);
    window['canv_'+num].add(text4);
    window['canv_'+num].add(text5);
    window['canv_'+num].add(text6);
    window['canv_'+num].renderAll();
    loadedTemp(num);
    window['universal'+num] = ['type: bckgrnd'+num+', type: path-group, ring-0'];
    jQuery('#undo').prop('disabled', true);
  },40);
}

function sugarRockF(num){
  loadFrontImg();
  jQuery('.workPlace').addClass('loadedTemp');
  jQuery('.product-single').addClass('pradeTemp');
  jQuery('#royalt').prop('checked',true).change();
  var obj;
  window['canv_'+num].backgroundColor = '#000';
  imgSrc = jQuery('#frnt-img').attr('src');
  window['newImg_'+num] = new Image();
  window['newImg_'+num].onload = function(){
    obj = new fabric.Image(window['newImg_'+num],{
      id: 'obj_'+n,
      left: cSize/2,
      top: cSize/2,
      originX: 'center',
      originY: 'center',
      scaleX: 1,
      scaleY: 1
    });
    obj.scaleToWidth(cSize/1.18);
    window['canv_'+num].add(obj);
    n++;
    window['canv_'+num].renderAll();
  };
  window['newImg_'+num].src = imgSrc;
  window['canv_'+num].renderAll();
  
  setTimeout(function(){
    window['canv_'+num].renderAll();
    loadedTemp(num);
    jQuery('input[name="pro_color"]#pink').prop('checked',true).change();
    window['universal'+num] = ['type: bckgrnd'+num+', type: path-group, ring-0'];
    jQuery('#undo').prop('disabled', true);
  },160);
}

function sugarRockB(num){
  jQuery('.workPlace').addClass('loadedTemp');
  jQuery('.product-single').addClass('pradeTemp');
  window['canv_'+num].backgroundColor = '#000';
  var obj,text1,text2,text3,
      label1 = 'Dallas’ Oldest & Most Trusted\nGold Refinder & Diamond Buyer.',
      label2 = '1-800-216-9796',
      label3 = 'www.aragold.com';
  
  text1 = new fabric.Text(label1,{
    id: 'obj_'+n,
    top:116,
    left:cSize/2,
    originX: 'center',
    originY: 'center',
    fontFamily: 'Calibri',
    fontSize: '16',
    lineHeight: .9,
    fill: '#057b35',
    textAlign: 'center'
  });
  n++;
  text2 = new fabric.Text(label2,{
    id: 'obj_'+n,
    top:155,
    left:cSize/2,
    originX: 'center',
    originY: 'center',
    fontFamily: 'Calibri',
    fontSize: '28',
    lineHeight: .9,
    fill: '#fff',
    textAlign: 'center'
  });
  n++;
  text3 = new fabric.Text(label3,{
    id: 'obj_'+n,
    top:190,
    left:cSize/2,
    originX: 'center',
    originY: 'center',
    fontFamily: 'Calibri',
    fontSize: '26',
    lineHeight: .9,
    fill: '#d2ac01',
    textAlign: 'center'
  });
  n++;
  setTimeout(function(){
    window['canv_'+num].add(text1);
    window['canv_'+num].add(text2);
    window['canv_'+num].add(text3);
  },40);
  setTimeout(function(){
    window['canv_'+num].sendToBack(obj);
    window['canv_'+num].renderAll();
    loadedTemp(num);
    window['universal'+num] = ['type: bckgrnd'+num+', type: path-group, ring-1'];
    jQuery('#undo').prop('disabled', true);
  },160);
}

function texasHoldem(num){
  loadFrontImg();
  jQuery('#spot_12').prop('checked',true).change();
  jQuery('.workPlace').addClass('loadedTemp');
  jQuery('.product-single').addClass('pradeTemp');
  var obj,text1,text2,text3,
      label1 = 'TEXAS HOLDEM',
      label2 = '10,000',
      label3 = 'NO CASH VALUE';
  imgSrc = jQuery('#frnt-img').attr('src');
  window['newImg_'+num] = new Image();
  window['newImg_'+num].onload = function(){
    obj = new fabric.Image(window['newImg_'+num],{
      id: 'obj_'+n,
      left: cSize/2,
      top: cSize/2,
      originX: 'center',
      originY: 'center',
      scaleX: 1,
      scaleY: 1
    });
    obj.scaleToWidth(cSize/1.18);
    window['canv_'+num].add(obj);
    n++;
    window['canv_'+num].renderAll();
  };
  window['newImg_'+num].src = imgSrc;
  window['canv_'+num].renderAll();
  
  text1 = new fabric.CurvedText(label1,{
    id: 'obj_'+n,
    top:84,
    left:cSize/2,
    originX: 'center',
    originY: 'center',
    fontFamily: 'Rockwell',
    fontSize: '24',
    fontWeight: 'bold',
    fill: '#fff',
    textAlign: 'center',
    effect: 'curved',
    radius: 106,
    spacing:6
  });
  n++;
  
  text2 = new fabric.Text(label2,{
    id: 'obj_'+n,
    top:(cSize/2),
    left:cSize/2,
    originX: 'center',
    originY: 'center',
    fontFamily: "Bookman",
    fontSize: '30',
    charSpacing: -100,
    fill: '#aa1e22',
    stroke: '#e9ba7b',
    strokeWidth: 2,
    textAlign: 'center'
  });
  n++;
  
  text3 = new fabric.CurvedText(label3,{
    id: 'obj_'+n,
    top:218,
    left:cSize/2,
    originX: 'center',
    originY: 'center',
    fontFamily: 'Rockwell',
    fontSize: '22',
    fontWeight: 'bold',
    fill: '#fff',
    textAlign: 'center',
    effect: 'curved',
    radius: 78,
    spacing: 1,
    reverse: true
  });
  n++;
  text1.lockMovementX = true;
  text2.lockMovementX = true;
  text3.lockMovementX = true;
  setTimeout(function(){
    window['canv_'+num].add(text1);
    window['canv_'+num].add(text2);
    window['canv_'+num].add(text3);
  },40);
  setTimeout(function(){
    window['canv_'+num].sendToBack(obj);
    window['canv_'+num].renderAll();
    loadedTemp(num);
    jQuery('input[name="pro_color"]#red').prop('checked',true).change();
    window['universal'+num] = ['type: bckgrnd'+num+', type: path-group, ring-0'];
    jQuery('#undo').prop('disabled', true);
  },160);
}

function freeDrink2F(num){
  loadFrontImg();
  jQuery('#royalt').prop('checked',true).change();
  jQuery('.workPlace').addClass('loadedTemp');
  jQuery('.product-single').addClass('pradeTemp');
  jQuery('input[name="rounders"]#ring_1').prop('checked',true);
  var text1,text2,text3,text4,
      label1 = 'WORLD OF DRINKS',
      label2 = '1\nFREE\nDRINK',
      label3 = 'WWW.WEBSITEGOESHERE.COM',
      label4 = 'LAS VEGAS, USA';
  
  newRounder = jQuery('input[name="rounders"]:checked').val();
  ringURL = jQuery('input[name="rounders"]:checked+label>span').html();
  ringColor = '#111111';
  addRing(num,ringColor);
  
  text1 = new fabric.CurvedText(label1,{
    id: 'obj_'+n,
    top:70,
    left:cSize/2,
    originX: 'center',
    originY: 'center',
    fontFamily: 'Impact',
    fontSize: '22',
    fill: '#ffffff',
    textAlign: 'center',
    effect: 'curved',
    radius: 110,
    spacing: 4
  });
  n++;
  text2 = new fabric.Text(label2,{
    id: 'obj_'+n,
    top:153,
    left:cSize/2,
    originX: 'center',
    originY: 'center',
    fontFamily: 'Impact',
    fontSize: '36',
    lineHeight:.88,
    fill: '#000',
    textAlign: 'center'
  });
  n++;
  text3 = new fabric.CurvedText(label3,{
    id: 'obj_'+n,
    top:212,
    left:cSize/2,
    originX: 'center',
    originY: 'center',
    fontFamily: "'Arial',sans-serif",
    fontSize: '8',
    fill: '#000000',
    textAlign: 'center',
    effect: 'curved',
    radius: 80,
    spacing: 1,
    reverse: true
  });
  n++;
  text4 = new fabric.CurvedText(label4,{
    id: 'obj_'+n,
    top:242,
    left:cSize/2,
    originX: 'center',
    originY: 'center',
    fontFamily: 'Impact',
    fontSize: '22',
    fill: '#ffffff',
    textAlign: 'center',
    effect: 'curved',
    radius: 92,
    spacing: 1,
    reverse: true
  });
  n++;
  text1.lockMovementX = true;
  text2.lockMovementX = true;
  text3.lockMovementX = true;
  text4.lockMovementX = true;
  setTimeout(function(){
    window['canv_'+num].add(text1);
    window['canv_'+num].add(text2);
    window['canv_'+num].add(text3);
    window['canv_'+num].add(text4);
  },40);
  
  setTimeout(function(){
    window['canv_'+num].renderAll();
    loadedTemp(num);
    window['universal'+num] = ['type: bckgrnd'+num+', type: path-group, ring-1'];
    jQuery('#undo').prop('disabled', true);
  },160);
}

function lasVegasF(num){
  loadFrontImg();
  noBackgrounds(num);
  jQuery('.workPlace').addClass('loadedTemp');
  jQuery('.product-single').addClass('pradeTemp');
  var obj,text1,text2,
      label1 = 'THE LAS VEGAS',
      label2 = 'SEX STONE';
  imgSrc = jQuery('#frnt-img').attr('src');
  window['newImg_'+num] = new Image();
  window['newImg_'+num].onload = function(){
    obj = new fabric.Image(window['newImg_'+num],{
      id: 'obj_'+n,
      left: cSize/2,
      top: cSize/2,
      originX: 'center',
      originY: 'center',
      scaleX: 1,
      scaleY: 1
    });
    obj.scaleToWidth(cSize/1.18);
    window['canv_'+num].add(obj);
    n++;
    window['canv_'+num].renderAll();
  };
  window['newImg_'+num].src = imgSrc;
  window['canv_'+num].renderAll();
  
  text1 = new fabric.CurvedText(label1,{
    id: 'obj_'+n,
    top:70,
    left:cSize/2,
    originX: 'center',
    originY: 'center',
    fontFamily: 'Rockwell',
    fontSize: '24',
    fill: '#000',
    textAlign: 'center',
    effect: 'curved',
    radius: 114,
    spacing:3
  });
  n++;
  text2 = new fabric.CurvedText(label2,{
    id: 'obj_'+n,
    top:242,
    left:cSize/2,
    originX: 'center',
    originY: 'center',
    fontFamily: 'Rockwell',
    fontSize: '24',
    fill: '#000',
    textAlign: 'center',
    effect: 'curved',
    radius: 86,
    spacing: 0,
    reverse: true
  });
  n++;
  setTimeout(function(){
    window['canv_'+num].add(text1);
    window['canv_'+num].add(text2);
  },40);
  setTimeout(function(){
    window['canv_'+num].sendToBack(obj);
    window['canv_'+num].renderAll();
    loadedTemp(num);
    window['universal'+num] = ['type: bckgrnd'+num+', type: path-group, ring-0'];
    jQuery('#undo').prop('disabled', true);
  },160);
}

function lasVegasB(num){
  noBackgrounds(num);
  jQuery('.workPlace').addClass('loadedTemp');
  jQuery('.product-single').addClass('pradeTemp');
  var obj,text1,text2,text3,
      label1 = 'Certified',
      label2 = 'Sexologiest',
      label3 = 'Geology';
  
  text1 = new fabric.CurvedText(label1,{
    id: 'obj_'+n,
    top:54,
    left:cSize/2,
    originX: 'center',
    originY: 'center',
    fontFamily: 'Bookman',
    fontSize: '28',
    fill: '#000',
    textAlign: 'center',
    effect: 'curved',
    radius: 100,
    spacing:3
  });
  n++;
  text2 = new fabric.CurvedText(label2,{
    id: 'obj_'+n,
    top:230,
    left:cSize/2,
    originX: 'center',
    originY: 'center',
    fontFamily: 'Bookman',
    fontSize: '28',
    fill: '#000',
    textAlign: 'center',
    effect: 'curved',
    radius: 80,
    spacing: 0,
    reverse: true
  });
  n++;
  text3 = new fabric.Text(label3,{
    id: 'obj_'+n,
    top:cSize/2,
    left:cSize/2,
    originX: 'center',
    originY: 'center',
    fontFamily: 'Bookman',
    fontSize: '28',
    fill: '#000',
    textAlign: 'center'
  });
  n++;
  setTimeout(function(){
    window['canv_'+num].add(text1);
    window['canv_'+num].add(text2);
    window['canv_'+num].add(text3);
  },40);
  setTimeout(function(){
    window['canv_'+num].sendToBack(obj);
    window['canv_'+num].renderAll();
    loadedTemp(num);
    window['universal'+num] = ['type: bckgrnd'+num+', type: path-group, ring-1'];
    jQuery('#undo').prop('disabled', true);
  },160);
}

function csarDevF(num){
  loadFrontImg();
  jQuery('.workPlace').addClass('loadedTemp');
  jQuery('.product-single').addClass('pradeTemp');
  jQuery('#rounders').prop('checked',true).change();
  jQuery('input[name="rounders"]#ring_1').prop('checked',true);
  var obj,text1,text2,
      label1 = 'CSAR DEVELOPMENT TEST',
      label2 = 'PRESENTED BY THE COMMANDER';
  window['canv_'+num].backgroundColor = '#000';
  imgSrc = jQuery('#frnt-img').attr('src');
  
  window['newImg_'+num] = new Image();
  window['newImg_'+num].onload = function(){
    obj = new fabric.Image(window['newImg_'+num],{
      id: 'obj_'+n,
      left: cSize/2,
      top: cSize/2,
      originX: 'center',
      originY: 'center',
      scaleX: 1,
      scaleY: 1
    });
    obj.scaleToWidth(cSize/1.18);
    window['canv_'+num].add(obj);
    n++;
    window['canv_'+num].renderAll();
  };
  window['newImg_'+num].src = imgSrc;
  window['canv_'+num].renderAll();
  
  newRounder = jQuery('input[name="rounders"]:checked').val();
  ringURL = jQuery('input[name="rounders"]:checked+label>span').html();
  ringColor = '#dd052b';
  addRing(num,ringColor);
  
  text1 = new fabric.CurvedText(label1,{
    id: 'obj_'+n,
    top:80,
    left:cSize/2,
    originX: 'center',
    originY: 'center',
    fontFamily: 'Calibri',
    fontSize: '20',
    fontWeight: 'bold',
    fill: '#f28c00',
    textAlign: 'center',
    effect: 'curved',
    radius: 112,
    spacing:3
  });
  n++;
  text2 = new fabric.CurvedText(label2,{
    id: 'obj_'+n,
    top:210,
    left:cSize/2,
    originX: 'center',
    originY: 'center',
    fontFamily: 'Calibri',
    fontSize: '20',
    fontWeight: 'bold',
    fill: '#f28c00',
    textAlign: 'center',
    effect: 'curved',
    radius: 88,
    spacing: 0,
    reverse: true
  });
  n++;
  setTimeout(function(){
    window['canv_'+num].add(text1);
    window['canv_'+num].add(text2);
  },40);
  setTimeout(function(){
    window['canv_'+num].sendToBack(obj);
    loadedTemp(num);
    jQuery('input[name="pro_color"]#lightBlue').prop('checked',true).change();
    window['universal'+num] = ['type: bckgrnd'+num+', type: path-group, ring-1'];
    jQuery('#undo').prop('disabled', true);
  },160);
}

function csarDevB(num){
  jQuery('.workPlace').addClass('loadedTemp');
  jQuery('.product-single').addClass('pradeTemp');
  var obj,text1,text2,
      label1 = 'NELLIS AIR FORCE BASE',
      label2 = '413 FLIGHT TEST SQUADRON';
  
  window['canv_'+num].backgroundColor = '#dd052b';
  imgSrc = jQuery('#back-img').attr('src');
  
  window['newImg_'+num] = new Image();
  window['newImg_'+num].onload = function(){
    obj = new fabric.Image(window['newImg_'+num],{
      id: 'obj_'+n,
      left: cSize/2,
      top: cSize/2,
      originX: 'center',
      originY: 'center',
      scaleX: 1,
      scaleY: 1
    });
    obj.scaleToWidth(cSize/1.18);
    window['canv_'+num].add(obj);
    n++;
    window['canv_'+num].renderAll();
  };
  window['newImg_'+num].src = imgSrc;
  window['canv_'+num].renderAll();
  
  
  text1 = new fabric.CurvedText(label1,{
    id: 'obj_'+n,
    top:68,
    left:cSize/2,
    originX: 'center',
    originY: 'center',
    fontFamily: 'Calibri',
    fontSize: '16',
    fontWeight: 'bold',
    fill: '#fff',
    textAlign: 'center',
    effect: 'curved',
    radius: 118,
    spacing:3,
    selectable: false,
    evented: false,
    hoverCursor: 'default'
  });
  n++;
  text2 = new fabric.CurvedText(label2,{
    id: 'obj_'+n,
    top:236,
    left:cSize/2,
    originX: 'center',
    originY: 'center',
    fontFamily: 'Calibri',
    fontSize: '16',
    fontWeight: 'bold',
    fill: '#fff',
    textAlign: 'center',
    effect: 'curved',
    radius: 90,
    spacing: 0,
    reverse: true,
    selectable: false,
    evented: false,
    hoverCursor: 'default'
  });
  setTimeout(function(){
    window['canv_'+num].add(text1);
    window['canv_'+num].add(text2);
  },40);
  setTimeout(function(){
    window['canv_'+num].sendToBack(obj);
    window['canv_'+num].renderAll();
    loadedTemp(num);
    window['universal'+num] = ['type: bckgrnd'+num+', type: path-group, ring-1'];
    jQuery('#undo').prop('disabled', true);
  },160);
}

function segundoF(num){
  loadFrontImg();
  jQuery('.workPlace').addClass('loadedTemp');
  jQuery('.product-single').addClass('pradeTemp');
  jQuery('#spot_12').prop('checked',true).change();
  var obj,text1,text2,
      label1 = 'EXPIRES 12/1/22',
      label2 = 'FOR FOOD ONLY. NO CASH VALUE.';
  window['canv_'+num].backgroundColor = '#e30405';
  imgSrc = jQuery('#frnt-img').attr('src');
  
  window['newImg_'+num] = new Image();
  window['newImg_'+num].onload = function(){
    obj = new fabric.Image(window['newImg_'+num],{
      id: 'obj_'+n,
      left: cSize/2,
      top: cSize/2,
      originX: 'center',
      originY: 'center',
      scaleX: 1,
      scaleY: 1
    });
    obj.scaleToWidth(cSize/1.18);
    window['canv_'+num].add(obj);
    n++;
    window['canv_'+num].renderAll();
  };
  window['newImg_'+num].src = imgSrc;
  window['canv_'+num].renderAll();
  
  text1 = new fabric.CurvedText(label1,{
    id: 'obj_'+n,
    top:56,
    left:cSize/2,
    originX: 'center',
    originY: 'center',
    fontFamily: 'Impact',
    fontSize: '16',
    fill: '#000',
    textAlign: 'center',
    effect: 'curved',
    radius: 110,
    spacing:3
  });
  n++;
  text2 = new fabric.CurvedText(label2,{
    id: 'obj_'+n,
    top:234,
    left:cSize/2,
    originX: 'center',
    originY: 'center',
    fontFamily: 'Impact',
    fontSize: '16',
    fill: '#000',
    textAlign: 'center',
    effect: 'curved',
    radius: 96,
    spacing: 0,
    reverse: true
  });
  n++;
  setTimeout(function(){
    window['canv_'+num].add(text1);
    window['canv_'+num].add(text2);
  },40);
  setTimeout(function(){
    window['canv_'+num].sendToBack(obj);
    loadedTemp(num);
    jQuery('input[name="pro_color"]#green').prop('checked',true).change();
    window['universal'+num] = ['type: bckgrnd'+num+', type: path-group, ring-0'];
    jQuery('#undo').prop('disabled', true);
  },160);
}

function segundoB(num){
  jQuery('.workPlace').addClass('loadedTemp');
  jQuery('.product-single').addClass('pradeTemp');
  var obj,text1,text2,text3,text4,
      label1 = 'CORNER OF FASHION SHOW DR. & LAS VEGAS STRIP',
      label2 = '702-258-1211',
      label3 = '$',
      label4 = '10';
  
  window['canv_'+num].backgroundColor = '#e30405';
  
  
  text1 = new fabric.CurvedText(label1,{
    id: 'obj_'+n,
    top:128,
    left:cSize/2,
    originX: 'center',
    originY: 'center',
    fontFamily: 'Impact',
    fontSize: '20',
    fill: '#000',
    textAlign: 'center',
    effect: 'curved',
    radius: 116,
    spacing:3
  });
  n++;
  text2 = new fabric.CurvedText(label2,{
    id: 'obj_'+n,
    top:250,
    left:cSize/2,
    originX: 'center',
    originY: 'center',
    fontFamily: 'Impact',
    fontSize: '20',
    fill: '#000',
    textAlign: 'center',
    effect: 'curved',
    radius: 90,
    spacing: 0,
    reverse: true
  });
  n++;
  text3 = new fabric.Text(label3,{
    id: 'obj_'+n,
    top:118,
    left:86,
    originX: 'center',
    originY: 'center',
    fontFamily: 'Georgia',
    fontSize: '32',
    fill: '#fff',
    textAlign: 'center',
    selectable: false,
    evented: false,
    hoverCursor: 'default'
  });
  n++;
  text4 = new fabric.Text(label4,{
    id: 'obj_'+n,
    top:158,
    left:cSize/2,
    originX: 'center',
    originY: 'center',
    fontFamily: 'Impact',
    fontSize: '106',
    lineHeight: 1,
    fill: '#000',
    stroke: '#fff',
    strokeWidth: 3,
    textAlign: 'center'
  });
  setTimeout(function(){
    window['canv_'+num].add(text1);
    window['canv_'+num].add(text2);
    window['canv_'+num].add(text3);
    window['canv_'+num].add(text4);
  },40);
  setTimeout(function(){
    window['canv_'+num].sendToBack(obj);
    window['canv_'+num].renderAll();
    loadedTemp(num);
    window['universal'+num] = ['type: bckgrnd'+num+', type: path-group, ring-0'];
    jQuery('#undo').prop('disabled', true);
  },160);
}

function nGuardF(num){
  loadFrontImg();
  noBackgrounds(num);
  noRings(num);
  jQuery('.workPlace').addClass('loadedTemp');
  jQuery('.product-single').addClass('pradeTemp');
  jQuery('#spot_12').prop('checked',true).change();
  jQuery('input[name="rounders"]#ring_1').prop('checked',true);
  var obj,text1,text2,
      label1 = 'NATIONAL GUARD',
      label2 = 'ALWAYS READY    ALWAYS THERE';
  window['canv_'+num].backgroundColor = '#f50003';
  imgSrc = jQuery('#frnt-img').attr('src');
  
  window['newImg_'+num] = new Image();
  window['newImg_'+num].onload = function(){
    obj = new fabric.Image(window['newImg_'+num],{
      id: 'obj_'+n,
      left: cSize/2,
      top: cSize/2,
      originX: 'center',
      originY: 'center',
      scaleX: 1,
      scaleY: 1
    });
    obj.scaleToWidth(cSize/1.18);
    window['canv_'+num].add(obj);
    n++;
    window['canv_'+num].renderAll();
  };
  window['newImg_'+num].src = imgSrc;
  window['canv_'+num].renderAll();
  
  newRounder = jQuery('input[name="rounders"]:checked').val();
  ringURL = jQuery('input[name="rounders"]:checked+label>span').html();
  ringColor = '#072a5e';
  addRing(num,ringColor);
  
  text1 = new fabric.CurvedText(label1,{
    id: 'obj_'+n,
    top:88,
    left:cSize/2,
    originX: 'center',
    originY: 'center',
    fontFamily: "'Arial',sans-serif",
    fontSize: '30',
    fontWeight: 'bold',
    fill: '#fff',
    textAlign: 'center',
    effect: 'curved',
    radius: 118,
    spacing:5,
    selectable: false,
    evented: false,
    hoverCursor: 'default'
  });
  n++;
  text2 = new fabric.CurvedText(label2,{
    id: 'obj_'+n,
    top:224,
    left:cSize/2,
    originX: 'center',
    originY: 'center',
    fontFamily: "'Arial',sans-serif",
    fontSize: '14',
    fontWeight: 'bold',
    fill: '#fff',
    textAlign: 'center',
    effect: 'curved',
    radius: 92,
    spacing: 0,
    reverse: true,
    selectable: false,
    evented: false,
    hoverCursor: 'default'
  });
  n++;
  setTimeout(function(){
    window['canv_'+num].add(text1);
    window['canv_'+num].add(text2);
  },40);
  setTimeout(function(){
    window['canv_'+num].sendToBack(obj);
    loadedTemp(num);
    jQuery('input[name="pro_color"]#beige').prop('checked',true).change();
    window['universal'+num] = ['type: bckgrnd'+num+', type: path-group, ring-1'];
    jQuery('#undo').prop('disabled', true);
  },160);
}

function nGuardB(num){
  noBackgrounds(num);
  noRings(num);
  jQuery('.workPlace').addClass('loadedTemp');
  jQuery('.product-single').addClass('pradeTemp');
  jQuery('input[name="rounders"]#ring_1').prop('checked',true);
  var obj,text1,text2,
      label1 = 'NATIONAL GUARD',
      label2 = 'ALWAYS READY    ALWAYS THERE';
  window['canv_'+num].backgroundColor = '#f50003';
  imgSrc = jQuery('#frnt-img').attr('src');
  
  window['newImg_'+num] = new Image();
  window['newImg_'+num].onload = function(){
    obj = new fabric.Image(window['newImg_'+num],{
      id: 'obj_'+n,
      left: cSize/2,
      top: cSize/2,
      originX: 'center',
      originY: 'center',
      scaleX: 1,
      scaleY: 1
    });
    obj.scaleToWidth(cSize/1.18);
    window['canv_'+num].add(obj);
    n++;
    window['canv_'+num].renderAll();
  };
  window['newImg_'+num].src = imgSrc;
  window['canv_'+num].renderAll();
  
  newRounder = jQuery('input[name="rounders"]:checked').val();
  ringURL = jQuery('input[name="rounders"]:checked+label>span').html();
  ringColor = '#072a5e';
  addRing(num,ringColor);
  
  text1 = new fabric.CurvedText(label1,{
    id: 'obj_'+n,
    top:88,
    left:cSize/2,
    originX: 'center',
    originY: 'center',
    fontFamily: "'Arial',sans-serif",
    fontSize: '30',
    fontWeight: 'bold',
    fill: '#fff',
    textAlign: 'center',
    effect: 'curved',
    radius: 118,
    spacing:5
  });
  n++;
  text2 = new fabric.CurvedText(label2,{
    id: 'obj_'+n,
    top:224,
    left:cSize/2,
    originX: 'center',
    originY: 'center',
    fontFamily: "'Arial',sans-serif",
    fontSize: '14',
    fontWeight: 'bold',
    fill: '#fff',
    textAlign: 'center',
    effect: 'curved',
    radius: 92,
    spacing: 0,
    reverse: true
  });
  n++;
  setTimeout(function(){
    window['canv_'+num].add(text1);
    window['canv_'+num].add(text2);
  },40);
  setTimeout(function(){
    window['canv_'+num].sendToBack(obj);
    window['canv_'+num].renderAll();
    loadedTemp(num);
    window['universal'+num] = ['type: bckgrnd'+num+', type: path-group, ring-1'];
    jQuery('#undo').prop('disabled', true);
  },160);
}

function dNavyF(num){
  loadFrontImg();
  noBackgrounds(num);
  noRings(num);
  jQuery('.workPlace').addClass('loadedTemp');
  jQuery('.product-single').addClass('pradeTemp');
  var obj,text1,text2,
      label1 = 'DEPARTMENT OF THE NAVY',
      label2 = 'UNITED STATES OF AMERICA';
  window['canv_'+num].backgroundColor = '#030b29';
  imgSrc = jQuery('#frnt-img').attr('src');
  
  window['newImg_'+num] = new Image();
  window['newImg_'+num].onload = function(){
    obj = new fabric.Image(window['newImg_'+num],{
      id: 'obj_'+n,
      left: cSize/2,
      top: cSize/2,
      originX: 'center',
      originY: 'center',
      scaleX: 1,
      scaleY: 1
    });
    obj.scaleToWidth(cSize/1.18);
    window['canv_'+num].add(obj);
    n++;
    window['canv_'+num].renderAll();
  };
  window['newImg_'+num].src = imgSrc;
  window['canv_'+num].renderAll();
  
  text1 = new fabric.CurvedText(label1,{
    id: 'obj_'+n,
    top:94,
    left:cSize/2,
    originX: 'center',
    originY: 'center',
    fontFamily: 'Georgia',
    fontSize: '18',
    fill: '#f7bb3f',
    textAlign: 'center',
    effect: 'curved',
    radius: 108,
    spacing:3,
    selectable: false,
    evented: false,
    hoverCursor: 'default'
  });
  n++;
  text2 = new fabric.CurvedText(label2,{
    id: 'obj_'+n,
    top:212,
    left:cSize/2,
    originX: 'center',
    originY: 'center',
    fontFamily: 'Georgia',
    fontSize: '18',
    fill: '#f7bb3f',
    textAlign: 'center',
    effect: 'curved',
    radius: 88,
    spacing: 0,
    reverse: true,
    selectable: false,
    evented: false,
    hoverCursor: 'default'
  });
  n++;
  setTimeout(function(){
    window['canv_'+num].add(text1);
    window['canv_'+num].add(text2);
  },40);
  setTimeout(function(){
    window['canv_'+num].sendToBack(obj);
    loadedTemp(num);
    window['universal'+num] = ['type: bckgrnd'+num+', type: path-group, ring-0'];
    jQuery('#undo').prop('disabled', true);
  },160);
}

function dNavyB(num){
  noBackgrounds(num);
  noRings(num);
  jQuery('.workPlace').addClass('loadedTemp');
  jQuery('.product-single').addClass('pradeTemp');
  var obj,text1,text2,
      label1 = 'DEPARTMENT OF THE NAVY',
      label2 = 'UNITED STATES OF AMERICA';
  window['canv_'+num].backgroundColor = '#030b29';
  imgSrc = jQuery('#frnt-img').attr('src');
  
  window['newImg_'+num] = new Image();
  window['newImg_'+num].onload = function(){
    obj = new fabric.Image(window['newImg_'+num],{
      id: 'obj_'+n,
      left: cSize/2,
      top: cSize/2,
      originX: 'center',
      originY: 'center',
      scaleX: 1,
      scaleY: 1
    });
    obj.scaleToWidth(cSize/1.18);
    window['canv_'+num].add(obj);
    n++;
    window['canv_'+num].renderAll();
  };
  window['newImg_'+num].src = imgSrc;
  window['canv_'+num].renderAll();
  
  text1 = new fabric.CurvedText(label1,{
    id: 'obj_'+n,
    top:94,
    left:cSize/2,
    originX: 'center',
    originY: 'center',
    fontFamily: 'Georgia',
    fontSize: '18',
    fill: '#f7bb3f',
    textAlign: 'center',
    effect: 'curved',
    radius: 108,
    spacing:3
  });
  n++;
  text2 = new fabric.CurvedText(label2,{
    id: 'obj_'+n,
    top:212,
    left:cSize/2,
    originX: 'center',
    originY: 'center',
    fontFamily: 'Georgia',
    fontSize: '18',
    fill: '#f7bb3f',
    textAlign: 'center',
    effect: 'curved',
    radius: 88,
    spacing: 0,
    reverse: true
  });
  n++;
  setTimeout(function(){
    window['canv_'+num].add(text1);
    window['canv_'+num].add(text2);
  },40);
  setTimeout(function(){
    window['canv_'+num].sendToBack(obj);
    window['canv_'+num].renderAll();
    loadedTemp(num);
    window['universal'+num] = ['type: bckgrnd'+num+', type: path-group, ring-0'];
    jQuery('#undo').prop('disabled', true);
  },160);
}

function usaArmyF(num){
  loadFrontImg();
  noBackgrounds(num);
  noRings(num);
  jQuery('.workPlace').addClass('loadedTemp');
  jQuery('.product-single').addClass('pradeTemp');
  jQuery('#royalt').prop('checked',true).change();
  var obj,text1,text2,
      label1 = 'UNITED STATES',
      label2 = 'ARMY';
  window['canv_'+num].backgroundColor = '#030b29';
  imgSrc = jQuery('#frnt-img').attr('src');
  
  window['newImg_'+num] = new Image();
  window['newImg_'+num].onload = function(){
    obj = new fabric.Image(window['newImg_'+num],{
      id: 'obj_'+n,
      left: cSize/2,
      top: cSize/2,
      originX: 'center',
      originY: 'center',
      scaleX: 1,
      scaleY: 1
    });
    obj.scaleToWidth(cSize/1.18);
    window['canv_'+num].add(obj);
    n++;
    window['canv_'+num].renderAll();
  };
  window['newImg_'+num].src = imgSrc;
  window['canv_'+num].renderAll();
  
  text1 = new fabric.CurvedText(label1,{
    id: 'obj_'+n,
    top:80,
    left:cSize/2,
    originX: 'center',
    originY: 'center',
    fontFamily: 'Georgia',
    fontSize: '24',
    fill: '#f8cb16',
    textAlign: 'center',
    effect: 'curved',
    radius: 108,
    spacing:4,
    selectable: false,
    evented: false,
    hoverCursor: 'default'
  });
  n++;
  text2 = new fabric.CurvedText(label2,{
    id: 'obj_'+n,
    top:240,
    left:cSize/2,
    originX: 'center',
    originY: 'center',
    fontFamily: 'Georgia',
    fontSize: '24',
    fill: '#f8cb16',
    textAlign: 'center',
    effect: 'curved',
    radius: 86,
    spacing: 0,
    reverse: true,
    selectable: false,
    evented: false,
    hoverCursor: 'default'
  });
  n++;
  setTimeout(function(){
    window['canv_'+num].add(text1);
    window['canv_'+num].add(text2);
  },40);
  setTimeout(function(){
    window['canv_'+num].sendToBack(obj);
    loadedTemp(num);
    jQuery('input[name="pro_color"]#green').prop('checked',true).change();
    window['universal'+num] = ['type: bckgrnd'+num+', type: path-group, ring-0'];
    jQuery('#undo').prop('disabled', true);
  },160);
}

function usaArmyB(num){
  noBackgrounds(num);
  noRings(num);
  jQuery('.workPlace').addClass('loadedTemp');
  jQuery('.product-single').addClass('pradeTemp');
  var obj,text1,text2,
      label1 = 'UNITED STATES',
      label2 = 'ARMY';
  window['canv_'+num].backgroundColor = '#030b29';
  imgSrc = jQuery('#frnt-img').attr('src');
  
  window['newImg_'+num] = new Image();
  window['newImg_'+num].onload = function(){
    obj = new fabric.Image(window['newImg_'+num],{
      id: 'obj_'+n,
      left: cSize/2,
      top: cSize/2,
      originX: 'center',
      originY: 'center',
      scaleX: 1,
      scaleY: 1
    });
    obj.scaleToWidth(cSize/1.18);
    window['canv_'+num].add(obj);
    n++;
    window['canv_'+num].renderAll();
  };
  window['newImg_'+num].src = imgSrc;
  window['canv_'+num].renderAll();
  
  text1 = new fabric.CurvedText(label1,{
    id: 'obj_'+n,
    top:80,
    left:cSize/2,
    originX: 'center',
    originY: 'center',
    fontFamily: 'Georgia',
    fontSize: '24',
    fill: '#f8cb16',
    textAlign: 'center',
    effect: 'curved',
    radius: 108,
    spacing:4
  });
  n++;
  text2 = new fabric.CurvedText(label2,{
    id: 'obj_'+n,
    top:240,
    left:cSize/2,
    originX: 'center',
    originY: 'center',
    fontFamily: 'Georgia',
    fontSize: '24',
    fill: '#f8cb16',
    textAlign: 'center',
    effect: 'curved',
    radius: 86,
    spacing: 0,
    reverse: true
  });
  n++;
  setTimeout(function(){
    window['canv_'+num].add(text1);
    window['canv_'+num].add(text2);
  },40);
  setTimeout(function(){
    window['canv_'+num].sendToBack(obj);
    window['canv_'+num].renderAll();
    loadedTemp(num);
    window['universal'+num] = ['type: bckgrnd'+num+', type: path-group, ring-0'];
    jQuery('#undo').prop('disabled', true);
  },160);
}

function ariForceF(num){
  loadFrontImg();
  noBackgrounds(num);
  noRings(num);
  jQuery('.workPlace').addClass('loadedTemp');
  jQuery('.product-single').addClass('pradeTemp');
  jQuery('#spot_12').prop('checked',true).change();
  var obj,text1,text2,
      label1 = 'DEPARTMENT OF THE AIR FORCE',
      label2 = 'UNITED STATES OF AMERICA';
  imgSrc = jQuery('#frnt-img').attr('src');
  
  window['newImg_'+num] = new Image();
  window['newImg_'+num].onload = function(){
    obj = new fabric.Image(window['newImg_'+num],{
      id: 'obj_'+n,
      left: cSize/2,
      top: cSize/2,
      originX: 'center',
      originY: 'center',
      scaleX: 1,
      scaleY: 1
    });
    obj.scaleToWidth(cSize/1.18);
    window['canv_'+num].add(obj);
    n++;
    window['canv_'+num].renderAll();
  };
  window['newImg_'+num].src = imgSrc;
  window['canv_'+num].renderAll();
  
  text1 = new fabric.CurvedText(label1,{
    id: 'obj_'+n,
    top:104,
    left:cSize/2,
    originX: 'center',
    originY: 'center',
    fontFamily: 'Georgia',
    fontSize: '20',
    fill: '#000',
    textAlign: 'center',
    effect: 'curved',
    radius: 116,
    spacing:3,
    selectable: false,
    evented: false,
    hoverCursor: 'default'
  });
  n++;
  text2 = new fabric.CurvedText(label2,{
    id: 'obj_'+n,
    top:236,
    left:cSize/2,
    originX: 'center',
    originY: 'center',
    fontFamily: 'Georgia',
    fontSize: '13',
    fill: '#000',
    textAlign: 'center',
    effect: 'curved',
    radius: 96,
    spacing: 0,
    reverse: true,
    selectable: false,
    evented: false,
    hoverCursor: 'default'
  });
  n++;
  setTimeout(function(){
    window['canv_'+num].add(text1);
    window['canv_'+num].add(text2);
  },40);
  setTimeout(function(){
    window['canv_'+num].sendToBack(obj);
    loadedTemp(num);
    jQuery('input[name="pro_color"]#red').prop('checked',true).change();
    window['universal'+num] = ['type: bckgrnd'+num+', type: path-group, ring-0'];
    jQuery('#undo').prop('disabled', true);
  },160);
}

function ariForceB(num){
  noBackgrounds(num);
  noRings(num);
  jQuery('.workPlace').addClass('loadedTemp');
  jQuery('.product-single').addClass('pradeTemp');
  var obj,text1,text2,
      label1 = 'DEPARTMENT OF THE AIR FORCE',
      label2 = 'UNITED STATES OF AMERICA';
  imgSrc = jQuery('#frnt-img').attr('src');
  
  window['newImg_'+num] = new Image();
  window['newImg_'+num].onload = function(){
    obj = new fabric.Image(window['newImg_'+num],{
      id: 'obj_'+n,
      left: cSize/2,
      top: cSize/2,
      originX: 'center',
      originY: 'center',
      scaleX: 1,
      scaleY: 1
    });
    obj.scaleToWidth(cSize/1.18);
    window['canv_'+num].add(obj);
    n++;
    window['canv_'+num].renderAll();
  };
  window['newImg_'+num].src = imgSrc;
  window['canv_'+num].renderAll();
  
  text1 = new fabric.CurvedText(label1,{
    id: 'obj_'+n,
    top:104,
    left:cSize/2,
    originX: 'center',
    originY: 'center',
    fontFamily: 'Georgia',
    fontSize: '20',
    fill: '#000',
    textAlign: 'center',
    effect: 'curved',
    radius: 116,
    spacing:3
  });
  n++;
  text2 = new fabric.CurvedText(label2,{
    id: 'obj_'+n,
    top:236,
    left:cSize/2,
    originX: 'center',
    originY: 'center',
    fontFamily: 'Georgia',
    fontSize: '13',
    fill: '#000',
    textAlign: 'center',
    effect: 'curved',
    radius: 96,
    spacing: 0,
    reverse: true
  });
  n++;
  setTimeout(function(){
    window['canv_'+num].add(text1);
    window['canv_'+num].add(text2);
  },40);
  setTimeout(function(){
    window['canv_'+num].sendToBack(obj);
    window['canv_'+num].renderAll();
    loadedTemp(num);
    window['universal'+num] = ['type: bckgrnd'+num+', type: path-group, ring-0'];
    jQuery('#undo').prop('disabled', true);
  },160);
}

function marineCorpsF(num){
  loadFrontImg();
  noBackgrounds(num);
  noRings(num);
  jQuery('.workPlace').addClass('loadedTemp');
  jQuery('.product-single').addClass('pradeTemp');
  var obj,text1,text2,
      label1 = 'UNITED STATES',
      label2 = 'MARINE CORPS';
  imgSrc = jQuery('#frnt-img').attr('src');
  
  window['newImg_'+num] = new Image();
  window['newImg_'+num].onload = function(){
    obj = new fabric.Image(window['newImg_'+num],{
      id: 'obj_'+n,
      left: cSize/2,
      top: cSize/2,
      originX: 'center',
      originY: 'center',
      scaleX: 1,
      scaleY: 1
    });
    obj.scaleToWidth(cSize/1.18);
    window['canv_'+num].add(obj);
    n++;
    window['canv_'+num].renderAll();
  };
  window['newImg_'+num].src = imgSrc;
  window['canv_'+num].renderAll();
  
  text1 = new fabric.CurvedText(label1,{
    id: 'obj_'+n,
    top:78,
    left:cSize/2,
    originX: 'center',
    originY: 'center',
    fontFamily: 'Georgia',
    fontSize: '28',
    fill: '#fff',
    textAlign: 'center',
    effect: 'curved',
    radius: 116,
    spacing:4,
    selectable: false,
    evented: false,
    hoverCursor: 'default'
  });
  n++;
  text2 = new fabric.CurvedText(label2,{
    id: 'obj_'+n,
    top:224,
    left:cSize/2,
    originX: 'center',
    originY: 'center',
    fontFamily: 'Georgia',
    fontSize: '28',
    fill: '#fff',
    textAlign: 'center',
    effect: 'curved',
    radius: 84,
    spacing: 0,
    reverse: true,
    selectable: false,
    evented: false,
    hoverCursor: 'default'
  });
  n++;
  setTimeout(function(){
    window['canv_'+num].add(text1);
    window['canv_'+num].add(text2);
  },40);
  setTimeout(function(){
    window['canv_'+num].sendToBack(obj);
    loadedTemp(num);
    jQuery('input[name="pro_color"]#green').prop('checked',true).change();
    window['universal'+num] = ['type: bckgrnd'+num+', type: path-group, ring-0'];
    jQuery('#undo').prop('disabled', true);
  },160);
}

function marineCorpsB(num){
  noBackgrounds(num);
  noRings(num);
  jQuery('.workPlace').addClass('loadedTemp');
  jQuery('.product-single').addClass('pradeTemp');
  var obj,text1,text2,
      label1 = 'UNITED STATES',
      label2 = 'MARINE CORPS';
  imgSrc = jQuery('#frnt-img').attr('src');
  
  window['newImg_'+num] = new Image();
  window['newImg_'+num].onload = function(){
    obj = new fabric.Image(window['newImg_'+num],{
      id: 'obj_'+n,
      left: cSize/2,
      top: cSize/2,
      originX: 'center',
      originY: 'center',
      scaleX: 1,
      scaleY: 1
    });
    obj.scaleToWidth(cSize/1.18);
    window['canv_'+num].add(obj);
    n++;
    window['canv_'+num].renderAll();
  };
  window['newImg_'+num].src = imgSrc;
  window['canv_'+num].renderAll();
  
  text1 = new fabric.CurvedText(label1,{
    id: 'obj_'+n,
    top:78,
    left:cSize/2,
    originX: 'center',
    originY: 'center',
    fontFamily: 'Georgia',
    fontSize: '28',
    fill: '#fff',
    textAlign: 'center',
    effect: 'curved',
    radius: 116,
    spacing:4
  });
  n++;
  text2 = new fabric.CurvedText(label2,{
    id: 'obj_'+n,
    top:224,
    left:cSize/2,
    originX: 'center',
    originY: 'center',
    fontFamily: 'Georgia',
    fontSize: '28',
    fill: '#fff',
    textAlign: 'center',
    effect: 'curved',
    radius: 84,
    spacing: 0,
    reverse: true
  });
  n++;
  setTimeout(function(){
    window['canv_'+num].add(text1);
    window['canv_'+num].add(text2);
  },40);
  setTimeout(function(){
    window['canv_'+num].sendToBack(obj);
    window['canv_'+num].renderAll();
    loadedTemp(num);
    window['universal'+num] = ['type: bckgrnd'+num+', type: path-group, ring-0'];
    jQuery('#undo').prop('disabled', true);
  },160);
}

function knightsGameF(num){
  loadFrontImg();
  noBackgrounds(num);
  noRings(num);
  jQuery('.workPlace').addClass('loadedTemp');
  jQuery('.product-single').addClass('pradeTemp');
  var obj,obj1,text1,text2,text3,
      label1 = 'Mark Andre Fleury',
      label2 = '#29',
      label3 = 'Pos:G\nHt:6’2”\nWt:18';
  imgSrc = jQuery('#frnt-img').attr('src');
  
  window['newImg_'+num] = new Image();
  window['newImg_'+num].onload = function(){
    obj = new fabric.Image(window['newImg_'+num],{
      id: 'obj_'+n,
      left: cSize/2,
      top: cSize/2,
      originX: 'center',
      originY: 'center',
      scaleX: 1,
      scaleY: 1,
      opacity: .2
    });
    obj.scaleToWidth(cSize/1.18);
    window['canv_'+num].add(obj);
    n++;
    window['canv_'+num].renderAll();
  };
  window['newImg_'+num].src = imgSrc;
  window['canv_'+num].renderAll();
  
  imgSrc = jQuery('#frnt-img1').attr('src');
  
  window['newImg_1'+num] = new Image();
  window['newImg_1'+num].onload = function(){
    obj1 = new fabric.Image(window['newImg_1'+num],{
      id: 'obj_'+n,
      left: cSize/2,
      top: 84,
      originX: 'center',
      originY: 'center',
      scaleX: 1,
      scaleY: 1
    });
    obj1.scaleToWidth(cSize/2.25);
    window['canv_'+num].add(obj1);
    n++;
    window['canv_'+num].renderAll();
  };
  window['newImg_1'+num].src = imgSrc;
  window['canv_'+num].renderAll();
  
  text1 = new fabric.Text(label1,{
    id: 'obj_'+n,
    top:128,
    left:cSize/2,
    originX: 'center',
    originY: 'center',
    fontFamily: 'Rockwell',
    fontSize: '18',
    fill: '#000',
    textAlign: 'center'
  });
  n++;
  text2 = new fabric.Text(label2,{
    id: 'obj_'+n,
    top:156,
    left:cSize/2,
    originX: 'center',
    originY: 'center',
    fontFamily: 'Rockwell',
    fontSize: '24',
    fontWeight: 'bold',
    fill: '#000',
    textAlign: 'center'
  });
  n++;
  text3 = new fabric.Text(label3,{
    id: 'obj_'+n,
    top:208,
    left:cSize/2,
    originX: 'center',
    originY: 'center',
    fontFamily: 'Rockwell',
    fontSize: '18',
    fill: '#000',
    textAlign: 'center'
  });
  n++;
  setTimeout(function(){
    window['canv_'+num].add(text1);
    window['canv_'+num].add(text2);
    window['canv_'+num].add(text3);
  },40);
  setTimeout(function(){
    window['canv_'+num].sendToBack(obj);
    loadedTemp(num);
    window['universal'+num] = ['type: bckgrnd'+num+', type: path-group, ring-0'];
    jQuery('#undo').prop('disabled', true);
  },160);
}

function knightsGameB(num){
  noBackgrounds(num);
  noRings(num);
  jQuery('.workPlace').addClass('loadedTemp');
  jQuery('.product-single').addClass('pradeTemp');
  var obj;
  imgSrc = jQuery('#back-img').attr('src');
  
  window['newImg_'+num] = new Image();
  window['newImg_'+num].onload = function(){
    obj = new fabric.Image(window['newImg_'+num],{
      id: 'obj_'+n,
      left: cSize/2,
      top: cSize/2,
      originX: 'center',
      originY: 'center',
      scaleX: 1,
      scaleY: 1
    });
    obj.scaleToWidth(cSize/1.18);
    window['canv_'+num].add(obj);
    n++;
    window['canv_'+num].renderAll();
  };
  window['newImg_'+num].src = imgSrc;
  window['canv_'+num].renderAll();
  setTimeout(function(){
    loadedTemp(num);
    window['universal'+num] = ['type: bckgrnd'+num+', type: path-group, ring-0'];
    jQuery('#undo').prop('disabled', true);
  },160);
}

function jslF(num){
  loadFrontImg();
  noBackgrounds(num);
  noRings(num);
  jQuery('.workPlace').addClass('loadedTemp');
  jQuery('.product-single').addClass('pradeTemp');
  var obj,text1,text2,
      label1 = 'John L. Sauter',
      label2 = 'Menorial Golf Tournament';
  imgSrc = jQuery('#frnt-img').attr('src');
  
  window['newImg_'+num] = new Image();
  window['newImg_'+num].onload = function(){
    obj = new fabric.Image(window['newImg_'+num],{
      id: 'obj_'+n,
      left: cSize/2,
      top: cSize/2,
      originX: 'center',
      originY: 'center',
      scaleX: 1,
      scaleY: 1
    });
    obj.scaleToWidth(cSize/1.18);
    window['canv_'+num].add(obj);
    n++;
    window['canv_'+num].renderAll();
  };
  window['newImg_'+num].src = imgSrc;
  window['canv_'+num].renderAll();
  
  text1 = new fabric.CurvedText(label1,{
    id: 'obj_'+n,
    top:60,
    left: cSize/2,
    originX: 'center',
    originY: 'center',
    fontFamily: "'Arial',sans-serif",
    fontSize: '22',
    fontWeight: 'bold',
    fill: '#000',
    textAlign: 'center',
    effect: 'curved',
    radius: 112,
    spacing:4
  });
  n++;
  text2 = new fabric.CurvedText(label2,{
    id: 'obj_'+n,
    top:202,
    left: cSize/2,
    originX: 'center',
    originY: 'center',
    fontFamily: "'Arial',sans-serif",
    fontSize: '22',
    fontWeight: 'bold',
    fill: '#000',
    textAlign: 'center',
    radius: 120,
    spacing:6,
    angle: -180
  });
  n++;
  setTimeout(function(){
    window['canv_'+num].add(text1);
    window['canv_'+num].add(text2);
  },40);
  setTimeout(function(){
    window['canv_'+num].sendToBack(obj);
    loadedTemp(num);
    window['universal'+num] = ['type: bckgrnd'+num+', type: path-group, ring-0'];
    jQuery('#undo').prop('disabled', true);
  },160);
}

function jslB(num){
  noBackgrounds(num);
  noRings(num);
  jQuery('.workPlace').addClass('loadedTemp');
  jQuery('.product-single').addClass('pradeTemp');
  var obj;
  imgSrc = jQuery('#back-img').attr('src');
  
  window['newImg_'+num] = new Image();
  window['newImg_'+num].onload = function(){
    obj = new fabric.Image(window['newImg_'+num],{
      id: 'obj_'+n,
      left: cSize/2,
      top: cSize/2,
      originX: 'center',
      originY: 'center',
      scaleX: 1,
      scaleY: 1
    });
    obj.scaleToWidth(cSize/1.18);
    window['canv_'+num].add(obj);
    n++;
    window['canv_'+num].renderAll();
  };
  window['newImg_'+num].src = imgSrc;
  window['canv_'+num].renderAll();
  setTimeout(function(){
    window['canv_'+num].sendToBack(obj);
    window['canv_'+num].renderAll();
    loadedTemp(num);
    window['universal'+num] = ['type: bckgrnd'+num+', type: path-group, ring-0'];
    jQuery('#undo').prop('disabled', true);
  },160);
}

function thermonF(num){
  loadFrontImg();
  noBackgrounds(num);
  noRings(num);
  jQuery('.workPlace').addClass('loadedTemp');
  jQuery('.product-single').addClass('pradeTemp');
  jQuery('#spot_12').prop('checked',true).change();
  var obj;
  imgSrc = jQuery('#frnt-img').attr('src');
  
  window['newImg_'+num] = new Image();
  window['newImg_'+num].onload = function(){
    obj = new fabric.Image(window['newImg_'+num],{
      id: 'obj_'+n,
      left: cSize/2,
      top: cSize/2,
      originX: 'center',
      originY: 'center',
      scaleX: 1,
      scaleY: 1
    });
    obj.scaleToWidth(cSize/1.18);
    window['canv_'+num].add(obj);
    n++;
    window['canv_'+num].renderAll();
  };
  window['newImg_'+num].src = imgSrc;
  window['canv_'+num].renderAll();
  setTimeout(function(){
    window['canv_'+num].sendToBack(obj);
    loadedTemp(num);
    jQuery('input[name="pro_color"]#gold').prop('checked',true).change();
    window['universal'+num] = ['type: bckgrnd'+num+', type: path-group, ring-0'];
    jQuery('#undo').prop('disabled', true);
  },160);
}

function thermonB(num){
  noRings(num);
  jQuery('.workPlace').addClass('loadedTemp');
  jQuery('.product-single').addClass('pradeTemp');
  var obj,text1,text2,
      label1 = 'THERMON',
      label2 = 'YOUR ACE IN THE HOLE';
  imgSrc = jQuery('#back-img').attr('src');
  
  window['newImg_'+num] = new Image();
  window['newImg_'+num].onload = function(){
    obj = new fabric.Image(window['newImg_'+num],{
      id: 'obj_'+n,
      left: cSize/2,
      top: cSize/2,
      originX: 'center',
      originY: 'center',
      scaleX: 1,
      scaleY: 1
    });
    obj.scaleToWidth(cSize/1.18);
    window['canv_'+num].add(obj);
    n++;
    window['canv_'+num].renderAll();
  };
  window['newImg_'+num].src = imgSrc;
  window['canv_'+num].renderAll();
  
  text1 = new fabric.CurvedText(label1,{
    id: 'obj_'+n,
    top:52,
    left: cSize/2,
    originX: 'center',
    originY: 'center',
    fontFamily: "'Arial',sans-serif",
    fontSize: '24',
    fontWeight: 'bold',
    fill: '#000',
    textAlign: 'center',
    effect: 'curved',
    radius: 112,
    spacing:4
  });
  n++;
  text2 = new fabric.CurvedText(label2,{
    id: 'obj_'+n,
    top:220,
    left: cSize/2,
    originX: 'center',
    originY: 'center',
    fontFamily: "'Arial',sans-serif",
    fontSize: '22',
    fontWeight: 'bold',
    fill: '#000',
    textAlign: 'center',
    radius: 94,
    spacing:0,
    reverse:true
  });
  n++;
  setTimeout(function(){
    window['canv_'+num].add(text1);
    window['canv_'+num].add(text2);
  },40);
  setTimeout(function(){
    window['canv_'+num].sendToBack(obj);
    window['canv_'+num].renderAll();
    loadedTemp(num);
    window['universal'+num] = ['type: bckgrnd'+num+', type: path-group, ring-0'];
    jQuery('#undo').prop('disabled', true);
  },160);
}

function eConnectF(num){
  loadFrontImg();
  noBackgrounds(num);
  noRings(num);
  jQuery('.workPlace').addClass('loadedTemp');
  jQuery('.product-single').addClass('pradeTemp');
  var obj,text1,text2,text3,
      label1 = 'Henry Valentino',
      label2 = 'President & CEO',
      label3 = 'you@youremail.com';
  imgSrc = jQuery('#frnt-img').attr('src');
  
  window['newImg_'+num] = new Image();
  window['newImg_'+num].onload = function(){
    obj = new fabric.Image(window['newImg_'+num],{
      id: 'obj_'+n,
      top: 110,
      left: cSize/2,
      originX: 'center',
      originY: 'center',
      scaleX: 1,
      scaleY: 1
    });
    obj.scaleToWidth(cSize/3);
    window['canv_'+num].add(obj);
    n++;
    window['canv_'+num].renderAll();
  };
  window['newImg_'+num].src = imgSrc;
  window['canv_'+num].renderAll();
  
  text1 = new fabric.Text(label1,{
    id: 'obj_'+n,
    top:160,
    left:cSize/2,
    originX: 'center',
    originY: 'center',
    fontFamily: "'Arial',sans-serif",
    fontSize: '22',
    fontWeight: 'bold',
    fill: '#000',
    textAlign: 'center'
  });
  n++;
  text2 = new fabric.Text(label2,{
    id: 'obj_'+n,
    top:182,
    left:cSize/2,
    originX: 'center',
    originY: 'center',
    fontFamily: 'Calibri',
    fontSize: '20',
    fill: '#000',
    textAlign: 'center'
  });
  n++;
  text3 = new fabric.Text(label3,{
    id: 'obj_'+n,
    top:202,
    left:cSize/2,
    originX: 'center',
    originY: 'center',
    fontFamily: "'Arial',sans-serif",
    fontSize: '18',
    fontWeight: 'bold',
    fill: '#000',
    textAlign: 'center'
  });
  n++;
  setTimeout(function(){
    window['canv_'+num].add(text1);
    window['canv_'+num].add(text2);
    window['canv_'+num].add(text3);
  },40);
  setTimeout(function(){
    window['canv_'+num].sendToBack(obj);
    loadedTemp(num);
    jQuery('input[name="pro_color"]#red').prop('checked',true).change();
    window['universal'+num] = ['type: bckgrnd'+num+', type: path-group, ring-0'];
    jQuery('#undo').prop('disabled', true);
  },160);
}

function eConnectB(num){
  noBackgrounds(num);
  noRings(num);
  jQuery('.workPlace').addClass('loadedTemp');
  jQuery('.product-single').addClass('pradeTemp');
  var obj,text1,text2,
      label1 = 'you@youremail.com',
      label2 = '702-555-1212';
  imgSrc = jQuery('#frnt-img').attr('src');
  
  window['newImg_'+num] = new Image();
  window['newImg_'+num].onload = function(){
    obj = new fabric.Image(window['newImg_'+num],{
      id: 'obj_'+n,
      top: 130,
      left: cSize/2,
      originX: 'center',
      originY: 'center',
      scaleX: 1,
      scaleY: 1
    });
    obj.scaleToWidth(cSize/3);
    window['canv_'+num].add(obj);
    n++;
    window['canv_'+num].renderAll();
  };
  window['newImg_'+num].src = imgSrc;
  window['canv_'+num].renderAll();
  
  text1 = new fabric.Text(label1,{
    id: 'obj_'+n,
    top:170,
    left:cSize/2,
    originX: 'center',
    originY: 'center',
    fontFamily: "'Arial',sans-serif",
    fontSize: '20',
    fontWeight: 'bold',
    fill: '#000',
    textAlign: 'center'
  });
  n++;
  text2 = new fabric.Text(label2,{
    id: 'obj_'+n,
    top:194,
    left:cSize/2,
    originX: 'center',
    originY: 'center',
    fontFamily: "'Arial',sans-serif",
    fontSize: '18',
    fill: '#000',
    textAlign: 'center'
  });
  setTimeout(function(){
    window['canv_'+num].add(text1);
    window['canv_'+num].add(text2);
  },40);
  setTimeout(function(){
    window['canv_'+num].sendToBack(obj);
    window['canv_'+num].renderAll();
    loadedTemp(num);
    window['universal'+num] = ['type: bckgrnd'+num+', type: path-group, ring-0'];
    jQuery('#undo').prop('disabled', true);
  },160);
}

function mrlawlvF(num){
  loadFrontImg();
  noRings(num);
  jQuery('#royalt').prop('checked',true).change();
  jQuery('.workPlace').addClass('loadedTemp');
  jQuery('.product-single').addClass('pradeTemp');
  var obj,text1,text2,
      label1 = 'Don’t Gamble With Your Case',
      label2 = '1-833-MRLAWLV';
  imgSrc = jQuery('#frnt-img').attr('src');
  
  window['newImg_'+num] = new Image();
  window['newImg_'+num].onload = function(){
    obj = new fabric.Image(window['newImg_'+num],{
      id: 'obj_'+n,
      top: cSize/2,
      left: cSize/2,
      originX: 'center',
      originY: 'center',
      scaleX: 1,
      scaleY: 1
    });
    obj.scaleToWidth(cSize/1.18);
    window['canv_'+num].add(obj);
    n++;
    window['canv_'+num].renderAll();
  };
  window['newImg_'+num].src = imgSrc;
  window['canv_'+num].renderAll();
  
  text1 = new fabric.CurvedText(label1,{
    id: 'obj_'+n,
    top:82,
    left:cSize/2,
    originX: 'center',
    originY: 'center',
    fontFamily: 'Calibri',
    fontSize: '20',
    fill: '#000',
    textAlign: 'center',
    effect: 'curved',
    radius: 120,
    spacing:3
  });
  n++;
  text2 = new fabric.CurvedText(label2,{
    id: 'obj_'+n,
    top:244,
    left:cSize/2,
    originX: 'center',
    originY: 'center',
    fontFamily: 'Calibri',
    fontSize: '20',
    fill: '#000',
    textAlign: 'center',
    effect: 'curved',
    radius: 86,
    spacing:0,
    reverse: true
  });
  n++;
  setTimeout(function(){
    window['canv_'+num].add(text1);
    window['canv_'+num].add(text2);
  },40);
  setTimeout(function(){
    window['canv_'+num].sendToBack(obj);
    loadedTemp(num);
    jQuery('input[name="pro_color"]#blue').prop('checked',true).change();
    window['universal'+num] = ['type: bckgrnd'+num+', type: path-group, ring-0'];
    jQuery('#undo').prop('disabled', true);
  },160);
}

function mrlawlvB(num){
  noRings(num);
  jQuery('.workPlace').addClass('loadedTemp');
  jQuery('.product-single').addClass('pradeTemp');
  var text1,text2,text3,
      label1 = 'Injury Attorneys',
      label2 = 'McAvoy Amaya &\nRevero, Attorneys',
      label3 = 'www.mrlawlv.com';
  
  text1 = new fabric.CurvedText(label1,{
    id: 'obj_'+n,
    top:60,
    left:cSize/2,
    originX: 'center',
    originY: 'center',
    fontFamily: "'Arial',sans-serif",
    fontSize: '20',
    fill: '#000',
    textAlign: 'center',
    effect: 'curved',
    radius: 120,
    spacing:3
  });
  n++;
  text2 = new fabric.Text(label2,{
    id: 'obj_'+n,
    top:cSize/2,
    left:cSize/2,
    originX: 'center',
    originY: 'center',
    fontFamily: 'abilyaregular',
    fontSize: '20',
    lineHeight:.75,
    fill: '#1a2954',
    textAlign: 'center'
  });
  n++;
  text3 = new fabric.CurvedText(label3,{
    id: 'obj_'+n,
    top:234,
    left:cSize/2,
    originX: 'center',
    originY: 'center',
    fontFamily: "'Arial',sans-serif",
    fontSize: '20',
    fill: '#000',
    textAlign: 'center',
    effect: 'curved',
    radius: 90,
    spacing:2,
    reverse: true
  });
  setTimeout(function(){
    window['canv_'+num].add(text1);
    window['canv_'+num].add(text2);
    window['canv_'+num].add(text3);
  },40);
  setTimeout(function(){
    window['canv_'+num].renderAll();
    loadedTemp(num);
    window['universal'+num] = ['type: bckgrnd'+num+', type: path-group, ring-0'];
    jQuery('#undo').prop('disabled', true);
  },160);
}

function unlvRebels(num){
  loadFrontImg();
  noBackgrounds(num);
  noRings(num);
  jQuery('.workPlace').addClass('loadedTemp');
  jQuery('.product-single').addClass('pradeTemp');
  var obj;
  imgSrc = jQuery('#frnt-img').attr('src');
  
  window['newImg_'+num] = new Image();
  window['newImg_'+num].onload = function(){
    obj = new fabric.Image(window['newImg_'+num],{
      id: 'obj_'+n,
      left: cSize/2,
      top: cSize/2,
      originX: 'center',
      originY: 'center',
      scaleX: 1,
      scaleY: 1
    });
    obj.scaleToWidth(cSize/1.18);
    window['canv_'+num].add(obj);
    n++;
    window['canv_'+num].renderAll();
  };
  window['newImg_'+num].src = imgSrc;
  window['canv_'+num].renderAll();
  setTimeout(function(){
    loadedTemp(num);
    window['universal'+num] = ['type: bckgrnd'+num+', type: path-group, ring-0'];
    jQuery('#undo').prop('disabled', true);
  },160);
}

function valleyVikingsF(num){
  loadFrontImg();
  noBackgrounds(num);
  noRings(num);
  jQuery('.workPlace').addClass('loadedTemp');
  jQuery('.product-single').addClass('pradeTemp');
  var obj;
  imgSrc = jQuery('#frnt-img').attr('src');
  
  window['newImg_'+num] = new Image();
  window['newImg_'+num].onload = function(){
    obj = new fabric.Image(window['newImg_'+num],{
      id: 'obj_'+n,
      left: cSize/2,
      top: cSize/2,
      originX: 'center',
      originY: 'center',
      scaleX: 1,
      scaleY: 1
    });
    obj.scaleToWidth(cSize/1.18);
    window['canv_'+num].add(obj);
    n++;
    window['canv_'+num].renderAll();
  };
  window['newImg_'+num].src = imgSrc;
  window['canv_'+num].renderAll();
  setTimeout(function(){
    loadedTemp(num);
    jQuery('input[name="pro_color"]#blue').prop('checked',true).change();
    window['universal'+num] = ['type: bckgrnd'+num+', type: path-group, ring-0'];
    jQuery('#undo').prop('disabled', true);
  },160);
}

function valleyVikingsB(num){
  noRings(num);
  jQuery('.workPlace').addClass('loadedTemp');
  jQuery('.product-single').addClass('pradeTemp');
  var obj,text1,text2,
      label1 = 'Valley Vikings Baseball',
      label2 = '2018-2019';
  imgSrc = jQuery('#frnt-img').attr('src');
  
  window['newImg_'+num] = new Image();
  window['newImg_'+num].onload = function(){
    obj = new fabric.Image(window['newImg_'+num],{
      id: 'obj_'+n,
      left: cSize/2,
      top: cSize/2,
      originX: 'center',
      originY: 'center',
      scaleX: 1,
      scaleY: 1
    });
    obj.scaleToWidth(cSize/1.75);
    window['canv_'+num].add(obj);
    n++;
    window['canv_'+num].renderAll();
  };
  window['newImg_'+num].src = imgSrc;
  window['canv_'+num].renderAll();
  
  text1 = new fabric.CurvedText(label1,{
    id: 'obj_'+n,
    top:86,
    left:cSize/2,
    originX: 'center',
    originY: 'center',
    fontFamily: 'abilyaregular',
    fontSize: '24',
    fontWeight: 'bold',
    fill: '#000000',
    stroke: '#a0400d',
    strokeWidth: 1,
    textAlign: 'center',
    effect: 'curved',
    radius: 120,
    spacing:4
  });
  n++;
  
  text2 = new fabric.CurvedText(label2,{
    id: 'obj_'+n,
    top:248,
    left:cSize/2,
    originX: 'center',
    originY: 'center',
    fontFamily: 'abilyaregular',
    fontSize: '24',
    fontWeight: 'bold',
    fill: '#000000',
    stroke: '#a0400d',
    strokeWidth: 1,
    textAlign: 'center',
    effect: 'curved',
    radius: 84,
    spacing: 2,
    reverse: true
  });
  n++;
  text1.lockMovementX = true;
  text2.lockMovementX = true;
  setTimeout(function(){
    window['canv_'+num].add(text1);
    window['canv_'+num].add(text2);
  },40);
  setTimeout(function(){
    window['canv_'+num].sendToBack(obj);
    window['canv_'+num].renderAll();
    loadedTemp(num);
    window['universal'+num] = ['type: bckgrnd'+num+', type: path-group, ring-0'];
    jQuery('#undo').prop('disabled', true);
  },160);
}

function raidersF(num){
  loadFrontImg();
  noRings(num);
  jQuery('.workPlace').addClass('loadedTemp');
  jQuery('.product-single').addClass('pradeTemp');
  var obj,text1,
      label1 = 'Inaugural PSL Member\n2020';
  imgSrc = jQuery('#frnt-img').attr('src');
  window['canv_'+num].backgroundColor = '#000';
  
  window['newImg_'+num] = new Image();
  window['newImg_'+num].onload = function(){
    obj = new fabric.Image(window['newImg_'+num],{
      id: 'obj_'+n,
      top: 130,
      left: cSize/2,
      originX: 'center',
      originY: 'center',
      scaleX: 1,
      scaleY: 1
    });
    obj.scaleToWidth(cSize/2.75);
    window['canv_'+num].add(obj);
    n++;
    window['canv_'+num].renderAll();
  };
  window['newImg_'+num].src = imgSrc;
  window['canv_'+num].renderAll();
  
  text1 = new fabric.Text(label1,{
    id: 'obj_'+n,
    top:220,
    left:cSize/2,
    originX: 'center',
    originY: 'center',
    fontFamily: "'Arial',sans-serif",
    fontSize: '16',
    fontStyle: 'italic',
    fill: '#fff',
    textAlign: 'center'
  });
  n++;
  setTimeout(function(){
    window['canv_'+num].add(text1);
  },40);
  setTimeout(function(){
    window['canv_'+num].sendToBack(obj);
    loadedTemp(num);
    window['universal'+num] = ['type: bckgrnd'+num+', type: path-group, ring-0'];
  },160);
}

function raidersB(num){
  noRings(num);
  jQuery('.workPlace').addClass('loadedTemp');
  jQuery('.product-single').addClass('pradeTemp');
  imgSrc = jQuery('#back-img').attr('src');
  var obj,text1,
      label1 = '“Once a Raider\nAlways a Raider”\n- Al Davis';
  
  window['newImg_'+num] = new Image();
  window['newImg_'+num].onload = function(){
    obj = new fabric.Image(window['newImg_'+num],{
      id: 'obj_'+n,
      top: cSize/2,
      left: cSize/2,
      originX: 'center',
      originY: 'center',
      scaleX: 1,
      scaleY: 1,
      opacity: .2
    });
    obj.scaleToWidth(cSize/1.5);
    window['canv_'+num].add(obj);
    n++;
    window['canv_'+num].renderAll();
  };
  window['newImg_'+num].src = imgSrc;
  window['canv_'+num].renderAll();
  
  text1 = new fabric.Text(label1,{
    id: 'obj_'+n,
    top:cSize/2,
    left:cSize/2,
    originX: 'center',
    originY: 'center',
    fontFamily: 'Rockwell',
    fontSize: '26',
    lineHeight: 1.25,
    fill: '#000',
    textAlign: 'center'
  });
  setTimeout(function(){
    window['canv_'+num].add(text1);
  },40);
  setTimeout(function(){
    window['canv_'+num].renderAll();
    loadedTemp(num);
    window['universal'+num] = ['type: bckgrnd'+num+', type: path-group, ring-0'];
  },160);
}

function pgaF(num){
  loadFrontImg();
  noRings(num);
  showLine(num);
  jQuery('.workPlace').addClass('loadedTemp');
  jQuery('.product-single').addClass('pradeTemp');
  var obj,text1,text2,text3,
      label1 = 'Justin Marsh, PGA',
      label2 = '575-650-3245',
      label3 = 'jmarsh@pga.com';
  imgSrc = jQuery('#frnt-img').attr('src');
  
  window['newImg_'+num] = new Image();
  window['newImg_'+num].onload = function(){
    obj = new fabric.Image(window['newImg_'+num],{
      id: 'obj_'+n,
      top: 74,
      left: cSize/2,
      originX: 'center',
      originY: 'center',
      scaleX: 1,
      scaleY: 1
    });
    obj.scaleToWidth(cSize/5.5);
    window['canv_'+num].add(obj);
    n++;
    window['canv_'+num].renderAll();
  };
  window['newImg_'+num].src = imgSrc;
  window['canv_'+num].renderAll();
  
  text1 = new fabric.Text(label1,{
    id: 'obj_'+n,
    top:124,
    left:cSize/2,
    originX: 'center',
    originY: 'center',
    fontFamily: "'Arial',sans-serif",
    fontSize: '22',
    fontWeight: 'bold',
    fill: '#274472',
    textAlign: 'center'
  });
  n++;
  line = new fabric.Rect({
    top: 140,
    left:cSize/2,
    originX: 'center',
    originY: 'center',
    fill: '#c7ac29',
    width: 198,
    height: 2
  });
  jQuery('#lineColor .currentColor').val(line.fill);
  jQuery('#lineColor .currentColor+.colorBox').css('backgroundColor',line.fill);
  n++;
  text2 = new fabric.Text(label2,{
    id: 'obj_'+n,
    top:170,
    left:cSize/2,
    originX: 'center',
    originY: 'center',
    fontFamily: "'Arial',sans-serif",
    fontSize: '22',
    fontWeight: 'bold',
    fill: '#274472',
    textAlign: 'center'
  });
  n++;
  text3 = new fabric.Text(label3,{
    id: 'obj_'+n,
    top:200,
    left:cSize/2,
    originX: 'center',
    originY: 'center',
    fontFamily: "'Arial',sans-serif",
    fontSize: '20',
    fontWeight: 'bold',
    fill: '#274472',
    textAlign: 'center'
  });
  n++;
  setTimeout(function(){
    window['canv_'+num].add(text1);
    window['canv_'+num].add(line);
    window['canv_'+num].add(text2);
    window['canv_'+num].add(text3);
  },40);
  setTimeout(function(){
    window['canv_'+num].sendToBack(obj);
    loadedTemp(num);
    jQuery('input[name="pro_color"]#blue').prop('checked',true).change();
    window['universal'+num] = ['type: bckgrnd'+num+', type: path-group, ring-0'];
    jQuery('#undo').prop('disabled', true);
  },160);
}

function pgaB(num){
  noRings(num);
  jQuery('.workPlace').addClass('loadedTemp');
  jQuery('.product-single').addClass('pradeTemp');
  
  var obj;
  imgSrc = jQuery('#frnt-img').attr('src');
  
  window['newImg_'+num] = new Image();
  window['newImg_'+num].onload = function(){
    obj = new fabric.Image(window['newImg_'+num],{
      id: 'obj_'+n,
      top: cSize/2,
      left: cSize/2,
      originX: 'center',
      originY: 'center',
      scaleX: 1,
      scaleY: 1
    });
    obj.scaleToWidth(cSize/1.6);
    window['canv_'+num].add(obj);
    n++;
    window['canv_'+num].renderAll();
  };
  window['newImg_'+num].src = imgSrc;
  window['canv_'+num].renderAll();
  setTimeout(function(){
    window['canv_'+num].renderAll();
    loadedTemp(num);
    window['universal'+num] = ['type: bckgrnd'+num+', type: path-group, ring-0'];
    jQuery('#undo').prop('disabled', true);
  },160);
}

function sammyOchF(num){
  loadFrontImg();
  noBackgrounds(num);
  noRings(num);
  jQuery('.workPlace').addClass('loadedTemp');
  jQuery('.product-single').addClass('pradeTemp');
  var obj,text1,text2,
      label1 = 'Sammy Ocha #9',
      label2 = 'Las Vegas Lights';
  imgSrc = jQuery('#frnt-img').attr('src');
  
  window['newImg_'+num] = new Image();
  window['newImg_'+num].onload = function(){
    obj = new fabric.Image(window['newImg_'+num],{
      id: 'obj_'+n,
      left: cSize/2,
      top: cSize/2,
      originX: 'center',
      originY: 'center',
      scaleX: 1,
      scaleY: 1
    });
    obj.scaleToWidth(cSize/1.18);
    window['canv_'+num].add(obj);
    n++;
    window['canv_'+num].renderAll();
  };
  window['newImg_'+num].src = imgSrc;
  window['canv_'+num].renderAll();
  
  text1 = new fabric.CurvedText(label1,{
    id: 'obj_'+n,
    top:120,
    left: cSize - 78,
    originX: 'center',
    originY: 'center',
    fontFamily: 'abilyaregular',
    fontSize: '24',
    fontWeight: 'bold',
    fill: '#fff',
    stroke: '#000',
    strokeWidth: 3,
    textAlign: 'center',
    effect: 'curved',
    radius: 120,
    spacing:5,
    angle: 70
  });
  n++;
  text2 = new fabric.CurvedText(label2,{
    id: 'obj_'+n,
    top:194,
    left: 72,
    originX: 'center',
    originY: 'center',
    fontFamily: 'abilyaregular',
    fontSize: '20',
    fontWeight: 'bold',
    fill: '#fff',
    stroke: '#000',
    strokeWidth: 3,
    textAlign: 'center',
    radius: 110,
    spacing:0,
    reverse: true,
    angle: 60
  });
  n++;
  setTimeout(function(){
    window['canv_'+num].add(text1);
    window['canv_'+num].add(text2);
  },40);
  setTimeout(function(){
    window['canv_'+num].sendToBack(obj);
    loadedTemp(num);
    jQuery('input[name="pro_color"]#blue').prop('checked',true).change();
    window['universal'+num] = ['type: bckgrnd'+num+', type: path-group, ring-0'];
    jQuery('#undo').prop('disabled', true);
  },160);
}

function sammyOchB(num){
  jQuery('.canvas_'+num).addClass('doQRB');
  var obj,text1,text2,
      label1 = 'SAMMY OCHOA',
      label2 = 'PLAYER STATS';
  window['canv_'+num].backgroundColor = '#604973';
  imgSrc = jQuery('#back-img').attr('src');
  window['newImg_'+num] = new Image();
  window['newImg_'+num].onload = function(){
    obj = new fabric.Image(window['newImg_'+num],{
      id: 'qrb_'+n,
      left: cSize/2,
      top: cSize/2,
      originX: 'center',
      originY: 'center',
      scaleX: 1,
      scaleY: 1
    });
    obj.scaleToWidth(cSize/2.75);
    window['canv_'+num].add(obj);
    n++;
    window['canv_'+num].renderAll();
  };
  window['newImg_'+num].src = imgSrc;
  window['canv_'+num].renderAll();
  
  text1 = new fabric.Text(label1,{
    id: 'obj_'+n,
    top:81,
    left:cSize/2,
    originX: 'center',
    originY: 'center',
    fontFamily: "'Arial',sans-serif",
    fontSize: '14',
    fill: '#ffffff',
    textAlign: 'center'
  });
  n++;
  text2 = new fabric.Text(label2,{
    id: 'obj_'+n,
    top:220,
    left:cSize/2,
    originX: 'center',
    originY: 'center',
    fontFamily: "'Arial',sans-serif",
    fontSize: '14',
    fill: '#ffffff',
    textAlign: 'center'
  });
  n++;
  text1.lockMovementX = true;
  text2.lockMovementX = true;
  setTimeout(function(){
    window['canv_'+num].add(text1);
    window['canv_'+num].add(text2);
  },40);
  setTimeout(function(){
    window['canv_'+num].sendToBack(obj);
    window['canv_'+num].renderAll();
    loadedTemp(num);
    window['universal'+num] = ['type: bckgrnd'+num+', type: path-group, ring-0'];
    jQuery('#undo').prop('disabled', true);
  },160);
}

function remaxChipF(num){
  loadFrontImg();
  noRings(num);
  jQuery('.workPlace').addClass('loadedTemp');
  jQuery('.product-single').addClass('pradeTemp');
  var obj,text1,text2,
      label1 = 'BENCHMARK REALTY',
      label2 = '702.688.6300 • 3900 S. Hualapai Las Vegas, NV 89147';
  imgSrc = jQuery('#frnt-img').attr('src');
  
  window['newImg_'+num] = new Image();
  window['newImg_'+num].onload = function(){
    obj = new fabric.Image(window['newImg_'+num],{
      id: 'obj_'+n,
      left: cSize/2,
      top: cSize/2,
      originX: 'center',
      originY: 'center',
      scaleX: 1,
      scaleY: 1
    });
    obj.scaleToWidth(cSize/1.18);
    window['canv_'+num].add(obj);
    n++;
    window['canv_'+num].renderAll();
  };
  window['newImg_'+num].src = imgSrc;
  window['canv_'+num].renderAll();
  
  text1 = new fabric.CurvedText(label1,{
    id: 'obj_'+n,
    top:78,
    left: cSize/2,
    originX: 'center',
    originY: 'center',
    fontFamily:"'Arial',sans-serif",
    fontSize: '24',
    fontWeight: 'bold',
    fill: '#0054a5',
    textAlign: 'center',
    effect: 'curved',
    radius: 114,
    spacing:2
  });
  n++;
  text2 = new fabric.CurvedText(label2,{
    id: 'obj_'+n,
    top:204,
    left: cSize/2,
    originX: 'center',
    originY: 'center',
    fontFamily: "'Arial',sans-serif",
    fontSize: '14',
    fill: '#0054a5',
    textAlign: 'center',
    radius: 100,
    spacing:0,
    reverse: true
  });
  n++;
  setTimeout(function(){
    window['canv_'+num].add(text1);
    window['canv_'+num].add(text2);
  },40);
  setTimeout(function(){
    window['canv_'+num].sendToBack(obj);
    loadedTemp(num);
    jQuery('input[name="pro_color"]#blue').prop('checked',true).change();
    window['universal'+num] = ['type: bckgrnd'+num+', type: path-group, ring-0'];
    jQuery('#undo').prop('disabled', true);
  },160);
}

function remaxChipB(num){
  var obj,text1,text2,text3,text4,
      label1 = 'STEVE ANDERSON',
      label2 = 'Broker, ABR,CBR,CDPE,SFR',
      label3 = '800-862-8958',
      label4 = 'Steve@OneLasVegas.com\nwww.LVBenchmark.com';
  imgSrc = jQuery('#back-img').attr('src');
  window['newImg_'+num] = new Image();
  window['newImg_'+num].onload = function(){
    obj = new fabric.Image(window['newImg_'+num],{
      id: 'qrb_'+n,
      left: cSize/2,
      top: (cSize/2) + 80,
      originX: 'center',
      originY: 'center',
      scaleX: 1,
      scaleY: 1
    });
    obj.scaleToWidth(cSize/2.75);
    window['canv_'+num].add(obj);
    n++;
    window['canv_'+num].renderAll();
  };
  window['newImg_'+num].src = imgSrc;
  window['canv_'+num].renderAll();
  
  text1 = new fabric.Text(label1,{
    id: 'obj_'+n,
    top:102,
    left:cSize/2,
    originX: 'center',
    originY: 'center',
    fontFamily: "'Arial',sans-serif",
    fontSize: '18',
    fontWeight: 'bold',
    fill: '#0054a5',
    textAlign: 'center'
  });
  n++;
  text2 = new fabric.Text(label2,{
    id: 'obj_'+n,
    top:130,
    left:cSize/2,
    originX: 'center',
    originY: 'center',
    fontFamily: "'Arial',sans-serif",
    fontSize: '16',
    fill: '#0054a5',
    textAlign: 'center'
  });
  n++;
  text3 = new fabric.Text(label3,{
    id: 'obj_'+n,
    top:158,
    left:cSize/2,
    originX: 'center',
    originY: 'center',
    fontFamily: "'Arial',sans-serif",
    fontSize: '18',
    fontWeight: 'bold',
    fill: '#e30405',
    textAlign: 'center'
  });
  n++;
  text4 = new fabric.Text(label4,{
    id: 'obj_'+n,
    top:194,
    left:cSize/2,
    originX: 'center',
    originY: 'center',
    fontFamily: "'Arial',sans-serif",
    fontSize: '16',
    lineHeight: .95,
    fill: '#0054a5',
    textAlign: 'center'
  });
  n++;
  text1.lockMovementX = true;
  text2.lockMovementX = true;
  text3.lockMovementX = true;
  text4.lockMovementX = true;
  setTimeout(function(){
    window['canv_'+num].add(text1);
    window['canv_'+num].add(text2);
    window['canv_'+num].add(text3);
    window['canv_'+num].add(text4);
  },40);
  setTimeout(function(){
    window['canv_'+num].sendToBack(obj);
    window['canv_'+num].renderAll();
    loadedTemp(num);
    window['universal'+num] = ['type: bckgrnd'+num+', type: path-group, ring-0'];
    jQuery('#undo').prop('disabled', true);
  },160);
}

function dreamsChipF(num){
  loadFrontImg();
  noRings(num);
  jQuery('#spot_12').prop('checked',true).change();
  jQuery('.workPlace').addClass('loadedTemp');
  jQuery('.product-single').addClass('pradeTemp');
  var obj,text1,text2,
      label1 = 'Life is Precious...',
      label2 = 'Mortuaries Cemeteries Crematories';
  imgSrc = jQuery('#frnt-img').attr('src');
  
  window['newImg_'+num] = new Image();
  window['newImg_'+num].onload = function(){
    obj = new fabric.Image(window['newImg_'+num],{
      id: 'obj_'+n,
      left: cSize/2,
      top: cSize/2,
      originX: 'center',
      originY: 'center',
      scaleX: 1,
      scaleY: 1
    });
    obj.scaleToWidth(cSize/1.18);
    window['canv_'+num].add(obj);
    n++;
    window['canv_'+num].renderAll();
  };
  window['newImg_'+num].src = imgSrc;
  window['canv_'+num].renderAll();
  
  text1 = new fabric.CurvedText(label1,{
    id: 'obj_'+n,
    top:60,
    left: cSize/2,
    originX: 'center',
    originY: 'center',
    fontFamily:'Athelas',
    fontSize: '24',
    fill: '#003a78',
    textAlign: 'center',
    effect: 'curved',
    radius: 124,
    spacing:2
  });
  n++;
  text2 = new fabric.CurvedText(label2,{
    id: 'obj_'+n,
    top:212,
    left: cSize/2,
    originX: 'center',
    originY: 'center',
    fontFamily: 'Athelas',
    fontSize: '20',
    fill: '#003a78',
    textAlign: 'center',
    radius: 96,
    spacing:0,
    reverse: true
  });
  n++;
  setTimeout(function(){
    window['canv_'+num].add(text1);
    window['canv_'+num].add(text2);
  },40);
  setTimeout(function(){
    window['canv_'+num].sendToBack(obj);
    loadedTemp(num);
    jQuery('input[name="pro_color"]#blue').prop('checked',true).change();
    window['universal'+num] = ['type: bckgrnd'+num+', type: path-group, ring-0'];
    jQuery('#undo').prop('disabled', true);
  },160);
}

function dreamsChipB(num){
  var text1,text2,text3,
      label1 = 'Jim Anderson',
      label2 = '702-755-5922',
      label3 = 'Don’t Gamble\nWith Your\nSUCCESS';
  
  text1 = new fabric.CurvedText(label1,{
    id: 'obj_'+n,
    top:58,
    left:cSize/2,
    originX: 'center',
    originY: 'center',
    fontFamily:'Athelas',
    fontSize: '28',
    fill: '#003a78',
    textAlign: 'center',
    effect: 'curved',
    radius: 120,
    spacing:2
  });
  n++;
  text2 = new fabric.CurvedText(label2,{
    id: 'obj_'+n,
    top:240,
    left:cSize/2,
    originX: 'center',
    originY: 'center',
    fontFamily:'Athelas',
    fontSize: '28',
    fill: '#003a78',
    textAlign: 'center',
    radius: 96,
    spacing:0,
    reverse: true
  });
  n++;
  text3 = new fabric.Text(label3,{
    id: 'obj_'+n,
    top:cSize/2,
    left:cSize/2,
    originX: 'center',
    originY: 'center',
    fontFamily:'Athelas',
    fontSize: '24',
    fill: '#003a78',
    textAlign: 'center'
  });
  n++;
  text1.lockMovementX = true;
  text2.lockMovementX = true;
  text3.lockMovementX = true;
  setTimeout(function(){
    window['canv_'+num].add(text1);
    window['canv_'+num].add(text2);
    window['canv_'+num].add(text3);
  },40);
  setTimeout(function(){
    loadedTemp(num);
    window['universal'+num] = ['type: bckgrnd'+num+', type: path-group, ring-0'];
    jQuery('#undo').prop('disabled', true);
  },160);
}

function setTexasHoldem(num){
  loadFrontImg();
  jQuery('#spot_12').prop('checked',true).change();
  jQuery('.workPlace').addClass('loadedTemp');
  jQuery('.product-single').addClass('pradeTemp');
  jQuery('input[name="rounders"]#ring_4').prop('checked',true);
  var obj,text1,text2,text3,
      label1 = 'TEXAS HOLDEM',
      label2 = '$5,000',
      label3 = 'NO CASH VALUE';
  imgSrc = jQuery('#frnt-img').attr('src');
  window['newImg_'+num] = new Image();
  window['newImg_'+num].onload = function(){
    obj = new fabric.Image(window['newImg_'+num],{
      id: 'obj_'+n,
      left: cSize/2,
      top: cSize/2,
      originX: 'center',
      originY: 'center',
      scaleX: 1,
      scaleY: 1,
      selectable: false,
      evented: false,
      hoverCursor: 'default'
    });
    obj.scaleToWidth(cSize/1.18);
    window['canv_'+num].add(obj);
    n++;
    window['canv_'+num].renderAll();
  };
  window['newImg_'+num].src = imgSrc;
  window['canv_'+num].renderAll();
  
  newRounder = jQuery('input[name="rounders"]:checked').val();
  ringURL = jQuery('input[name="rounders"]:checked+label>span').html();
  ringColor = '#e30405';
  addRing(num,ringColor);
  
  text1 = new fabric.CurvedText(label1,{
    id: 'obj_'+n,
    top:84,
    left:cSize/2,
    originX: 'center',
    originY: 'center',
    fontFamily: 'Rockwell',
    fontSize: '24',
    fontWeight: 'bold',
    fill: '#fff',
    textAlign: 'center',
    effect: 'curved',
    radius: 106,
    spacing:6/*,
    selectable: false,
    evented: false,
    hoverCursor: 'default'*/
  });
  n++;
  
  text2 = new fabric.Text(label2,{
    id: 'obj_'+n,
    top:(cSize/2),
    left:cSize/2,
    originX: 'center',
    originY: 'center',
    fontFamily: "Bookman",
    fontSize: '30',
    charSpacing: -100,
    fill: '#aa1e22',
    stroke: '#e9ba7b',
    strokeWidth: 2,
    textAlign: 'center',
    selectable: false,
    evented: false,
    hoverCursor: 'default'
  });
  n++;
  
  text3 = new fabric.CurvedText(label3,{
    id: 'obj_'+n,
    top:218,
    left:cSize/2,
    originX: 'center',
    originY: 'center',
    fontFamily: 'Rockwell',
    fontSize: '22',
    fontWeight: 'bold',
    fill: '#fff',
    textAlign: 'center',
    effect: 'curved',
    radius: 78,
    spacing: 1,
    reverse: true/*,
    selectable: false,
    evented: false,
    hoverCursor: 'default'*/
  });
  n++;
  text1.lockMovementX = true;
  text2.lockMovementX = true;
  text3.lockMovementX = true;
  setTimeout(function(){
    window['canv_'+num].add(text1);
    window['canv_'+num].add(text2);
    window['canv_'+num].add(text3);
  },40);
  setTimeout(function(){
    window['canv_'+num].sendToBack(obj);
    window['canv_'+num].sendToBack(window['ring_'+num]);
    window['canv_'+num].renderAll();
    loadedTemp(num);
    jQuery('input[name="pro_color"]#red').prop('checked',true).change();
    window['universal'+num] = ['type: bckgrnd'+num+', type: path-group, ring-1'];
    jQuery('#undo').prop('disabled', true);
  },160);
}

function loadFrontImg(){
  var frontImg = jQuery('#chip-img').attr('src'),
      img = 'image';
  jQuery('.radio_chip>.theContent>label .loadedInBack').each(function(){
    jQuery(this).attr('xlink:href',frontImg);
  });
}

function noBackgrounds(num){
  jQuery('.canvas_'+num).addClass('hideBackG');
}

function noRings(num){
  jQuery('.canvas_'+num).addClass('hideRingS');
}

function showLine(num){
  jQuery('.canvas_'+num).addClass('showLineC');
}

//ToolTip
//---------------
function tooltip(){
  var tipContent;
  jQuery('.toolTip').each(function(){
    tipContent = jQuery(this).attr('tooltip');
    jQuery(this).after('<div class="tooltipLabel">'+tipContent+'</div>');
  });
}


//Quantity
//--------------
jQuery(document).on('click','.selectionBase',function(){
  jQuery('.selectionBOX').toggleClass('opened');
});

jQuery(document).on('click','.quantity_price .increment',function(){
  var currentVal = jQuery('.quantity_price .number').val();
  currentVal = parseInt(currentVal) + parseInt(25);
  jQuery('.quantity_price .number').val(currentVal);
  jQuery('.product-form__input--quantity').val(currentVal);
  qpUpdate(currentVal);
});

jQuery(document).on('click','.quantity_price .decrement',function(){
  var currentVal = jQuery('.quantity_price .number').val();
  currentVal = parseInt(currentVal) - parseInt(25);
  if(currentVal > 99){
    jQuery('.quantity_price .number').val(currentVal);
    jQuery('.product-form__input--quantity').val(currentVal);
    qpUpdate(currentVal);
  }
});

jQuery(document).on('keyup','.quantity_price .number',function(){
  var currentVal = jQuery('.quantity_price .number').val();
  jQuery('.product-form__input--quantity').val(currentVal);
  qpUpdate(currentVal);
});

function clearQuSelection(){
  jQuery('#quantityMain li[selected]').each(function(){
    jQuery(this).removeAttr('selected');
  });
  jQuery('#nCquantityMain li[selected]').each(function(){
    jQuery(this).removeAttr('selected');
  });
  jQuery('#CquantityMain li[selected]').each(function(){
    jQuery(this).removeAttr('selected');
  });
}

function qpUpdate(currentVal){
  if(currentVal > 99){
    clearQuSelection();
    jQuery('#quantityMain').find('li[value="100"]').attr('selected','');
    jQuery('#nCquantityMain').find('li[value="100"]').attr('selected','');
  }
  if(currentVal > 299){
    clearQuSelection();
    jQuery('#quantityMain').find('li[value="300"]').attr('selected','');
    jQuery('#nCquantityMain').find('li[value="300"]').attr('selected','');
  }
  if(currentVal > 499){
    clearQuSelection();
    jQuery('#quantityMain').find('li[value="500"]').attr('selected','');
    jQuery('#nCquantityMain').find('li[value="500"]').attr('selected','');
  }
  if(currentVal > 999){
    clearQuSelection();
    jQuery('#quantityMain').find('li[value="1000"]').attr('selected','');
    jQuery('#nCquantityMain').find('li[value="1000"]').attr('selected','');
  }
  if(currentVal > 4999){
    clearQuSelection();
    jQuery('#quantityMain').find('li[value="5000"]').attr('selected','');
    jQuery('#nCquantityMain').find('li[value="5000"]').attr('selected','');
  }
  if(currentVal > 9999){
    clearQuSelection();
    jQuery('#quantityMain').find('li[value="10000"]').attr('selected','');
  }
  if(currentVal > 24999){
    clearQuSelection();
    jQuery('#quantityMain').find('li[value="25000"]').attr('selected','');
  }
  if(currentVal > 99999){
    clearQuSelection();
    jQuery('#quantityMain').find('li[value="100000"]').attr('selected','');
  }
  var que = jQuery('.quantity_price .number').val(),
      queT= jQuery('#quantityMain li[selected="selected"]').text(),
      queP= jQuery('#quantityMain li[selected="selected"]').attr('data-price');
  if(jQuery('#nCquantityMain').length>0){
      queT = jQuery('#nCquantityMain li[selected="selected"]').text();
      queP = jQuery('#nCquantityMain li[selected="selected"]').attr('data-price');
  }
  jQuery('.selectionBase>span.detailBOX').text(queT);
  jQuery('.accordians .price-item.price-item--regular').text(queP);
  jQuery('#color-1').val(jQuery.number(que)).change();
  jQuery('#color-1').attr('data-que',que);
  updatePopQue();
  jQuery('.quantityBlocks>tr').each(function(){
    jQuery(this).remove();
  });
}

function qpNcUpdate(currentVal){
  if(currentVal > 99){
    clearQuSelection();
    jQuery('#nCquantityMain').find('li[value="100"]').attr('selected','');
  }
  if(currentVal > 299){
    clearQuSelection();
    jQuery('#nCquantityMain').find('li[value="300"]').attr('selected','');
  }
  if(currentVal > 499){
    clearQuSelection();
    jQuery('#nCquantityMain').find('li[value="500"]').attr('selected','');
  }
  if(currentVal > 999){
    clearQuSelection();
    jQuery('#nCquantityMain').find('li[value="1000"]').attr('selected','');
  }
  if(currentVal > 4999){
    clearQuSelection();
    jQuery('#nCquantityMain').find('li[value="5000"]').attr('selected','');
  }
  var que = jQuery('.quantity_price .number').val(),
      queT = jQuery('#nCquantityMain li[selected="selected"]').text(),
      queP = jQuery('#nCquantityMain li[selected="selected"]').attr('data-price');
  jQuery('.selectionBase>span.detailBOX').text(queT);
  jQuery('.accordians .price-item.price-item--regular').text(queP);
  updatePopQue();
}

function qpcUpdate(currentVal){
  if(currentVal > 99){
    clearQuSelection();
    jQuery('#CquantityMain').find('li[value="100"]').attr('selected','');
  }
  if(currentVal > 299){
    clearQuSelection();
    jQuery('#CquantityMain').find('li[value="300"]').attr('selected','');
  }
  if(currentVal > 499){
    clearQuSelection();
    jQuery('#CquantityMain').find('li[value="500"]').attr('selected','');
  }
  if(currentVal > 999){
    clearQuSelection();
    jQuery('#CquantityMain').find('li[value="1000"]').attr('selected','');
  }
  if(currentVal > 4999){
    clearQuSelection();
    jQuery('#CquantityMain').find('li[value="5000"]').attr('selected','');
  }
  var que = jQuery('.quantity_price .number').val(),
      queT = jQuery('#CquantityMain li[selected="selected"]').text(),
      queP = jQuery('#CquantityMain li[selected="selected"]').attr('data-price');
  jQuery('.selectionBase>span.detailBOX').text(queT);
  jQuery('.accordians .price-item.price-item--regular').text(queP);
  updatePopQue();
}

function pricingMain(chipType){
  chipType = chipType.slice(0,4);
  jQuery('#quantityMain').html('');
  jQuery('#quantityMain').append('<li value="0" data-price="">Select Quantity</li>');
  
  jQuery('#nCquantityMain').html('');
  jQuery('#nCquantityMain').append('<li value="0" data-price="">Select Quantity</li>');
  
  jQuery('#CquantityMain').html('');
  jQuery('#CquantityMain').append('<li value="0" data-price="">Select Quantity</li>');
  
  jQuery('#SingleOptionSelector-0 option').each(function(){
    var needy = jQuery(this).attr('value'),
        price = jQuery(this).attr('data-prices'),
        numbr = needy.match(/\d+/),
        needed = needy.slice(0, 4);
    if(needed === chipType){
      jQuery('#quantityMain').append('<li value="'+numbr+'" data-price="'+price+'">'+jQuery.number(numbr)+' Chips @ ('+price+') / Chip</li>');
      jQuery('#nCquantityMain').append('<li value="'+numbr+'" data-price="'+price+'">'+jQuery.number(numbr)+' Chips @ ('+price+') / Chip</li>');
      jQuery('#CquantityMain').append('<li value="'+numbr+'" data-price="'+price+'">'+jQuery.number(numbr)+' Chips @ ('+price+') / Chip</li>');
    }
    jQuery('#quantityMain li:nth-child(2)').trigger('click');
    jQuery('#nCquantityMain li:nth-child(2)').trigger('click');
    jQuery('#CquantityMain li:nth-child(2)').trigger('click');
  });
  updatePopQue();
  var updatedPrice = jQuery('#quantityMain').find('li[selected]').attr('data-price');
  if(jQuery('#nCquantityMain').length>0){
    updatedPrice = jQuery('#nCquantityMain').find('li[selected]').attr('data-price');
  }
  if(jQuery('#CquantityMain').length>0){
    updatedPrice = jQuery('#CquantityMain').find('li[selected]').attr('data-price');
  }
  jQuery('.accordians .price-item.price-item--regular').text(updatedPrice);
  jQuery('.quantityBlocks>tr').each(function(){
    jQuery(this).remove();
  });
}

jQuery(document).on('click','#quantityMain li,#nCquantityMain li,#CquantityMain li',function(){
  var item = jQuery(this),
      updatedPrice = item.attr('data-price');
  item.parent().addClass('focused');
  jQuery('#quantityMain li[selected],#nCquantityMain li[selected],#CquantityMain li[selected]').each(function(){
    jQuery(this).removeAttr('selected');
  });
  item.attr('selected','');
  
  if(item.parent().hasClass('focused')){
    jQuery('.quantity_price .number').val(item.attr('value'));
  }
  var que = jQuery('.quantity_price .number').val();
  jQuery('.selectionBase>span.detailBOX').text(item.text());
  jQuery('.accordians .price-item.price-item--regular').text(updatedPrice);
  jQuery('#color-1').val(jQuery.number(que)).change();
  jQuery('#color-1').attr('data-que',que);
  updatePopQue();
  jQuery('.quantityBlocks>tr').each(function(){
    jQuery(this).remove();
  });
  item.parent().removeClass('focused');
});

jQuery(document).on('click','#quantityMain,#nCquantityMain,#CquantityMain',function(){
  jQuery(this).addClass('focused');
});

var quea,
    que  = 2,
    quan = 0,
    quwn = 0;

jQuery(document).on('click','.addMore',function(){
  jQuery('.quantityBlock.active').removeClass('active');
  var quantityRow = '<tr class="quantityBlock active" data-row="row-'+que+'"><td><div class="colorBox" id="colorSet_'+que+
      '" style="background-color:#000">&nbsp;</div><div class="quantityChipColor">'+colors_quantity+'</div></td>'+
      '<td><select class="QueBox" id="color-'+que+'" data-selected="25"></select></td>'+
      '<td align="center">'+//<a href="javascript:void(0);" class="btn btn--small addMore" title="Add new color">+</a>
      '<a href="javascript:void(0);" class="btn btn--small btn--secondary-accent removeThis" title="Remove color">-</a>'+
      '</td></tr>',
     cQuantityRow = '<tr class="quantityBlock active" data-row="row-'+que+'"><td><div class="colorBox" id="colorSet_'+que+
      '" style="background-color:#000">&nbsp;</div><div class="quantityChipColor">'+colors_quantity+'</div></td>'+
      '<td><select class="cDenomin" id="denomination-'+que+'"><option value="$1">$1</option><option value="$5">$5</option>'+
      '<option value="$25">$25</option><option value="$100">$100</option><option value="$500">$500</option>'+
      '<option value="$1,000">$1,000</option><option value="$5,000">$5000</option><option value="$10,000">$10,000</option>'+
      '<option value="$25,000">$25,000</option><option value="$50,000">$50,000</option><option value="$100,000">$100,000</option>'+
      '</select></td>'+
      '<td><select class="QueBox" id="color-'+que+'" data-selected="25"></select></td>'+
      '<td align="center">'+
      '<a href="javascript:void(0);" class="btn btn--small btn--secondary-accent removeThis" title="Remove color">-</a>'+
      '</td></tr>';
  quea = jQuery('#quantityMain').find("[selected]").attr('value');
  if(jQuery('#nCquantityMain').length>0){
    quea = jQuery('#nCquantityMain').find("[selected]").attr('value');
  }
  if(jQuery('#CquantityMain').length>0){
    quea = jQuery('#CquantityMain').find("[selected]").attr('value');
  }
  if(!jQuery('#nCquantityMain').length>0 && !jQuery('#CquantityMain').length>0){
    jQuery('#quantityPop .quantityBlocks').append(quantityRow);
    checkChipColor(chipName);
  }
  jQuery('#quantityPop .cQuantityBlocks').append(cQuantityRow);
  jQuery('#set_tags>span').each(function(){
    var colorTag = jQuery(this).attr('data-tag'),
        colorTag = colorTag.split(', ').pop(),
        colorName = colorTag.replace('color-','');
    jQuery('.cQuantityBlocks .color_BAX input[value="'+colorName+'"]').parent().css('display','inline-block');
  });
  jQuery('.quantityBlock[data-row="row-'+que+'"] .quantityChipColor>div').each(function(){
    var itsVar = jQuery(this).html(),
        oldQue = 1,
        newQue = que;
    itsVar = itsVar.replaceAll('or-'+oldQue+'_', 'or-'+newQue+'_');
    jQuery(this).html(itsVar);
  });
  for(var i = 25; i < quea; i = i+25){
    jQuery('#color-'+que).append('<option value="'+i+'">'+jQuery.number(i)+'</option>');
  }
  quea = parseInt(jQuery('#color-1').attr('data-que')) - 25;
  jQuery('#color-1').val(jQuery.number(quea));
  jQuery('#color-1').attr('data-que',quea);
  que++;
});

jQuery(document).on('change','.QueBox',function(){
  var itsCount = jQuery(this).find(':selected').val(),
      alreadyS = jQuery(this).attr('data-selected'),
      selectBox = jQuery(this).attr('id');
  updateQueInner(itsCount);
  setTimeout(function(){
    if(quea < 25){
      jQuery('#'+selectBox).val(alreadyS).change();
    }
    jQuery('#'+selectBox).attr('data-selected',itsCount);
    jQuery('#color-1').val(jQuery.number(quea));
    jQuery('#color-1').attr('data-que',quea);
  },50);
});

if(jQuery('#nCquantityMain').length>0){
  quea = 5025;
  jQuery('.product-single__thumbnail-image').each(function(){
    var imageURL = jQuery(this).attr('src'),
        colorTag = jQuery(this).attr('data-tag'),
        colorTag = colorTag.split(', ').pop(),
        colorName = colorTag.replace('color-',''),
        colorbg = jQuery('#'+colorName).attr('data-color'),
        quantityRow = '<tr class="quantityBlock" data-row="row-'+que+'"><td><div class="colorBox" id="colorSet_'+que+
        '" style="background-color:'+colorbg+'">&nbsp;</div></td>'+
        '<td><img src="'+imageURL+'" alt="'+colorTag+'"></td>'+
        '<td><select class="ncQueBox" id="color-'+que+'" data-selected="25"></select></td>'+
        '</tr>';
    jQuery('#quantityPop .ncQuantityBlocks').append(quantityRow);
    for(var i = 0; i < quea; i = i+25){
      jQuery('#color-'+que).append('<option value="'+i+'">'+jQuery.number(i)+'</option>');
    }
    que++;
  });
}

if(jQuery('#CquantityMain').length>0){
  quea = 5025;
  jQuery('.product-single__thumbnail-image').each(function(){
    var imageURL = jQuery(this).attr('src'),
        colorTag = jQuery(this).attr('data-tag'),
        colorTag = colorTag.split(', ').pop(),
        colorName = colorTag.replace('color-',''),
        colorbg = jQuery('#'+colorName).attr('data-color'),
        quantityRow = '<tr class="quantityBlock" data-row="row-'+que+'"><td><div class="colorBox" id="colorSet_'+que+
        '" style="background-color:'+colorbg+'">&nbsp;</div></td>'+
        '<td><select class="cDenomin" id="denomination-'+que+'"><option value="1">$1</option><option value="5">$5</option><option value="25">$25</option><option value="100">$100</option>'+
        '<option value="500">$500</option><option value="1000">$1000</option><option value="5000">$5000</option><option value="10000">$10,000</option><option value="25000">$25,000</option>'+
        '<option value="50000">$50,000</option><option value="100000">$100,000</option></select></td>'+
        '<td><select class="ncQueBox" id="color-'+que+'" data-selected="25"></select></td>'+
        '</tr>';
    jQuery('#quantityPop .cQuantityBlocks').append(quantityRow);
    for(var i = 0; i < quea; i = i+25){
      jQuery('#color-'+que).append('<option value="'+i+'">'+jQuery.number(i)+'</option>');
    }
    que++;
  });
}

jQuery(document).on('change','.ncQueBox',function(){
  var itsCount = jQuery(this).find(':selected').val(),
      alreadyS = jQuery(this).attr('data-selected'),
      selectBox = jQuery(this).attr('id');
  updateNcQueInner(itsCount);
  setTimeout(function(){
    if(quea < 25){
      jQuery('#'+selectBox).val(alreadyS).change();
    }
    jQuery('#'+selectBox).attr('data-selected',itsCount);
  },50);
});

jQuery(document).on('click','.removeThis',function(){
  var thisRow = jQuery(this).parent().parent(),
      quea = thisRow.find('.QueBox').find(':selected').val(),
      prvQ = jQuery('#color-1').attr('data-que'),
      quAA = parseInt(quea) + parseInt(prvQ);
  jQuery('#color-1').val(jQuery.number(quAA));
  jQuery('#color-1').attr('data-que',quAA);
  thisRow.remove();
});

function updatePopQue(){
  var variantId,
      queVal = 'Spot 100 Chips';
  quan = jQuery('.quantity_price .number').val();
  var humTum = jQuery.number(quan);
  jQuery('#totalQuanty').val(humTum);
  var nowPRice = jQuery('#quantityMain').find('li[selected="selected"]').attr('data-price');
  if(jQuery('#nCquantityMain').length>0){
    nowPRice = jQuery('#nCquantityMain').find('li[selected="selected"]').attr('data-price');
  }
  if(jQuery('#CquantityMain').length>0){
    nowPRice = jQuery('#CquantityMain').find('li[selected="selected"]').attr('data-price');
  }
  var noePRice = nowPRice.substring(1, nowPRice.length),
      subTotalSet = quan * noePRice,
      subTotalSet = subTotalSet.toFixed(2);
  jQuery('.subTotalEst').text(jQuery.number(subTotalSet)+'.00');
  jQuery('.product-form__input--quantity').val(quan).change();
  var checkChip = jQuery('input[name="chips"]:checked').attr('data-variant');
  if(quan > 99){
    queVal = checkChip + ' 100 Chips';
  }
  if(quan > 299){
    queVal = checkChip + ' 300 Chips';
  }
  if(quan > 499){
    queVal = checkChip + ' 500 Chips';
  }
  if(quan > 999){
    queVal = checkChip + ' 1000 Chips';
  }
  if(quan > 4999){
    queVal = checkChip + ' 5000 Chips';
  }
  if(quan > 9999){
    queVal = checkChip + ' 10000 Chips';
  }
  if(quan > 24999){
    queVal = checkChip + ' 25000 Chips';
  }
  if(quan > 99999){
    queVal = checkChip + ' 100000 Chips';
  }
  setTimeout(function(){
    variantId = jQuery('#SingleOptionSelector-0 option[value="'+queVal+'"]').attr('data-id');
    jQuery('.product-form__variants').val(variantId).trigger('change');
  },50);
}

function updateQueInner(itsCount){
  quwn = 0;
  quan = jQuery('.quantity_price .number').val();
  jQuery('.QueBox').each(function(){
    var its = jQuery(this),
        itsQu = its.find(':selected').val();
    quwn = parseInt(quwn) + parseInt(itsQu);
    quea = parseInt(quan) - parseInt(quwn);
  });
}

function updateNcQueInner(itsCount){
  quwn = 0;
  quan = jQuery('.quantity_price .number').val();
  jQuery('.ncQueBox').each(function(){
    var its = jQuery(this),
        itsQu = its.find(':selected').val();
    quwn = parseInt(quwn) + parseInt(itsQu);
  });
  setTimeout(function(){
    jQuery('.quantity_price .number').val(quwn);
    jQuery('.product-form__input--quantity').val(quwn);
    qpNcUpdate(quwn);
  },100);
}

jQuery(document).on('click','.quantityBlock .colorBox',function(){
  jQuery(this).parent().parent().addClass('active');
  jQuery(this).parent().addClass('active');
});

//QR Code Maker
jQuery(document).on('click','#qrMaker,#qrMakerB',function(){
  jQuery('.thePop').each(function(){
    jQuery(this).removeClass('active').hide();
  });
  canvas = jQuery('.background-canvas .active .lower-canvas').attr('id');
  num = canvas.replace('canvas_','');
  Objects = window['canv_'+num].getObjects();
  Objects.forEach(function(object){
    if(object.type === 'image'){
      var selectedId = object.id;
      if(selectedId.indexOf('qrc') === 0 || selectedId.indexOf('qrb') === 0){
        window['canv_'+num].setActiveObject(object);
      }
    }
  });
});

jQuery(document).on('keyup','#qrName,#qrNumber,#qrAddress,#qrDiscount',function(){
  var qrName	= jQuery('#qrName').val(),
      qrNumber	= jQuery('#qrNumber').val(),
      qrURL		= jQuery('#qrURL').val(),
      qrAddress	= jQuery('#qrAddress').val(),
      qrDiscount= jQuery('#qrDiscount').val(),
      newText	= 'Name:' + qrName +'|Number:'+ qrNumber +'|url:'+ qrURL +'|Address:'+ qrAddress +'|Discount:'+ qrDiscount,
      finalURL	= '//sincitychips.com/pages/your-information?user_info='+encodeURIComponent(newText);
  jQuery('#qrInput').val(finalURL);
});
jQuery(document).on('keyup','#qrURL',function(){
  jQuery('.url_error').hide();
  jQuery('.url_error').prev().removeClass('errorField');
  var qrName	= jQuery('#qrName').val(),
      qrNumber	= jQuery('#qrNumber').val(),
      qrURL		= jQuery('#qrURL').val(),
      qrAddress	= jQuery('#qrAddress').val(),
      qrDiscount= jQuery('#qrDiscount').val();
  if(!isUrlValid(qrURL)){
    jQuery('.url_error').show();
    jQuery('.url_error').prev().addClass('errorField');
  }
  var newText	= 'Name:' + qrName +'|Number:'+ qrNumber +'|url:'+ qrURL +'|Address:'+ qrAddress +'|Discount:'+ qrDiscount,
      finalURL	= '//sincitychips.com/pages/your-information?user_info='+encodeURIComponent(newText);
  jQuery('#qrInput').val(finalURL);
});

jQuery(document).on('click','#generatQRnow',function(){
  jQuery('#qrcode').empty();
  jQuery('#qrcode').qrcode({
    width: 400,
    height: 400,
    text: jQuery('#qrInput').val()
  });
  jQuery('#qrcode').find('canvas').attr('id','qrCanva');
  jQuery('#qrcode').show();
  jQuery('#updateQR').show();
});

jQuery(document).on('click','#updateQR',function(){
  var canvasQR = document.getElementById("qrCanva");
  imgSrc = canvasQR.toDataURL();
  canvas = jQuery('.background-canvas .active .lower-canvas').attr('id');
  num = canvas.replace('canvas_','');
  activeOb = window['canv_'+num].getActiveObject();
  if(activeOb){
    var left = activeOb.left,
        width = activeOb.width;
    activeOb.setSrc(imgSrc);
    activeOb.setLeft(5);
    activeOb.setCoords();
    window['canv_'+num].renderAll();
    setTimeout(function(){
      activeOb.setLeft(left);
      activeOb.setCoords();
      activeOb.setWidth(width);
      activeOb.setHeight(width);
      window['canv_'+num].renderAll();
      object = activeOb;
      onObjectModified(num,object);
      undoBtn.setAttribute('data-first','');
    },10);
    jQuery('.layerObject.active>div>img').attr('src',imgSrc);
  }
});

/*----------*/

jQuery(document).on('keyup','#qrNameB,#qrNumberB,#qrAddressB,#qrDiscountB',function(){
  var qrName	= jQuery('#qrNameB').val(),
      qrNumber	= jQuery('#qrNumberB').val(),
      qrURL		= jQuery('#qrURLB').val(),
      qrAddress	= jQuery('#qrAddressB').val(),
      qrDiscount= jQuery('#qrDiscountB').val(),
      newText	= 'Name:' + qrName +'|Number:'+ qrNumber +'|url:'+ qrURL +'|Address:'+ qrAddress +'|Discount:'+ qrDiscount,
      finalURL	= 'https://sincitychips.com/pages/your-informationb?user_info='+encodeURIComponent(newText);
  jQuery('#qrInputB').val(finalURL);
});
jQuery(document).on('keyup','#qrURLB',function(){
  jQuery('.url_error').hide();
  jQuery('.url_error').prev().removeClass('errorField');
  var qrName	= jQuery('#qrNameB').val(),
      qrNumber	= jQuery('#qrNumberB').val(),
      qrURL		= jQuery('#qrURLB').val(),
      qrAddress	= jQuery('#qrAddressB').val(),
      qrDiscount= jQuery('#qrDiscountB').val();
  if(!isUrlValid(qrURL)){
    jQuery('.url_error').show();
    jQuery('.url_error').prev().addClass('errorField');
  }
  var newText	= 'Name:' + qrName +'|Number:'+ qrNumber +'|url:'+ qrURL +'|Address:'+ qrAddress +'|Discount:'+ qrDiscount,
      finalURL	= 'https://sincitychips.com/pages/your-informationb?user_info='+encodeURIComponent(newText);
  jQuery('#qrInputB').val(finalURL);
});

jQuery(document).on('click','#generatQRnowB',function(){
  jQuery('#qrcodeB').empty();
  jQuery('#qrcodeB').qrcode({
    width: 400,
    height: 400,
    text: jQuery('#qrInputB').val()
  });
  jQuery('#qrcodeB').find('canvas').attr('id','qrCanvaB');
  jQuery('#qrcodeB').show();
  jQuery('#updateQRB').show();
});

jQuery(document).on('click','#updateQRB',function(){
  var canvasQR = document.getElementById("qrCanvaB");
  imgSrc = canvasQR.toDataURL();
  canvas = jQuery('.background-canvas .active .lower-canvas').attr('id');
  num = canvas.replace('canvas_','');
  activeOb = window['canv_'+num].getActiveObject();
  if(activeOb){
    var left = activeOb.left,
        width = activeOb.width;
    activeOb.setSrc(imgSrc);
    activeOb.setLeft(5);
    activeOb.setCoords();
    window['canv_'+num].renderAll();
    setTimeout(function(){
      activeOb.setLeft(left);
      activeOb.setCoords();
      activeOb.setWidth(width);
      activeOb.setHeight(width);
      window['canv_'+num].renderAll();
      object = activeOb;
      onObjectModified(num,object);
      undoBtn.setAttribute('data-first','');
    },10);
    jQuery('.layerObject.active>div>img').attr('src',imgSrc);
  }
});


// Save Template
//--------------
jQuery(document).on('click','.saveBtn',function(){
  jQuery('#saveConfirm').show();
  //saveTemplate();
});

jQuery(document).on('click','.saveTemplate',function(){
  saveTemplate();
});

var chipStyle,chipColor,canvaBG,imageSrc,objEvent,svv,tempName;
function saveTemplate(){
  jQuery('#savedHere').empty();
  jQuery('#savedHere').append('<div class="userID">'+userID+'</div><div class="productID">'+productID+'</div>');
  chipStyle = jQuery('input[name="chips"]:checked').val();
  chipColor = jQuery('input[name="pro_color"]:checked').val();
  jQuery('#savedHere').append('<div id="saveChipStyle">'+chipStyle+'</div><div id="saveChipColor">'+chipColor+'</div>');
  jQuery('.background-canvas .canvas-container').each(function(){
    canvas = jQuery(this).find('.lower-canvas').attr('id');
    num = canvas.replace('canvas_','');
    canvaBG = window['canv_'+num].backgroundColor;
    Objects = window['canv_'+num].getObjects();
    jQuery('#savedHere').append('<div class="save-'+canvas+'"><span class="saveChipBackground">'+canvaBG+'</span></div>');
    Objects.forEach(function(obj){
      type		= obj.type;
      objId		= obj.id;
      leftT		= obj.left;
      topT		= obj.top;
      scaleXt	= obj.scaleX;
      scaleYt	= obj.scaleY;
      angleT	= obj.angle;
      objEvent 	= obj.evented;
      jQuery('#savedHere .save-'+canvas).append('<div id="saved-'+objId+'"><span class="type">'+type+'</span></div>');
      jQuery('#savedHere .save-'+canvas+' #saved-'+objId).append('<span class="id">'+objId+'</span>');
      jQuery('#savedHere .save-'+canvas+' #saved-'+objId).append('<span class="left">'+leftT+'</span>');
      jQuery('#savedHere .save-'+canvas+' #saved-'+objId).append('<span class="top">'+topT+'</span>');
      jQuery('#savedHere .save-'+canvas+' #saved-'+objId).append('<span class="scaleX">'+scaleXt+'</span>');
      jQuery('#savedHere .save-'+canvas+' #saved-'+objId).append('<span class="scaleY">'+scaleYt+'</span>');
      jQuery('#savedHere .save-'+canvas+' #saved-'+objId).append('<span class="angle">'+angleT+'</span>');
      jQuery('#savedHere .save-'+canvas+' #saved-'+objId).append('<span class="event">'+objEvent+'</span>');
      if(type === 'image'){
        imageSrc = obj._originalElement.currentSrc;
        jQuery('#savedHere .save-'+canvas+' #saved-'+objId).append('<span class="imgSrc">'+imageSrc+'</span>');
      }
      if(type === 'text' || type === 'curvedText'){
          txt 	   = obj.text;
          base 	   = obj.fill;
          font 	   = obj.fontFamily;
          fontSize = obj.fontSize;
          bold 	   = obj.fontWeight;
          italic   = obj.fontStyle;
        jQuery('#savedHere .save-'+canvas+' #saved-'+objId).append('<span class="txt">'+txt+'</span>');
        jQuery('#savedHere .save-'+canvas+' #saved-'+objId).append('<span class="base">'+base+'</span>');
        jQuery('#savedHere .save-'+canvas+' #saved-'+objId).append('<span class="font">'+font+'</span>');
        jQuery('#savedHere .save-'+canvas+' #saved-'+objId).append('<span class="fontSize">'+fontSize+'</span>');
        jQuery('#savedHere .save-'+canvas+' #saved-'+objId).append('<span class="fontWeight">'+bold+'</span>');
        jQuery('#savedHere .save-'+canvas+' #saved-'+objId).append('<span class="fontStyle">'+italic+'</span>');
        if(type === 'text'){
          underline = obj.textDecoration;
          txtA 	  	= obj.textAlign;
          jQuery('#savedHere .save-'+canvas+' #saved-'+objId).append('<span class="textDecoration">'+underline+'</span>');
          jQuery('#savedHere .save-'+canvas+' #saved-'+objId).append('<span class="textAlign">'+txtA+'</span>');
        }
        if(type === 'curvedText'){
          effect   = obj.effect;
          radiusT  = obj.radius;
          spacingT = obj.spacing;
          reverseT = obj.reverse;
          jQuery('#savedHere .save-'+canvas+' #saved-'+objId).append('<span class="effect">'+effect+'</span>');
          jQuery('#savedHere .save-'+canvas+' #saved-'+objId).append('<span class="radius">'+radiusT+'</span>');
          jQuery('#savedHere .save-'+canvas+' #saved-'+objId).append('<span class="spacing">'+spacingT+'</span>');
          jQuery('#savedHere .save-'+canvas+' #saved-'+objId).append('<span class="reverse">'+reverseT+'</span>');
        }
      }
    });
  });
  svv = jQuery('#savedHere').html();
  tempName = jQuery('#tempName').val();
  $.ajax({
    url: "https://homefirst.pk/poker/index.php",
    type: "POST",
    data:{
      contents: svv,
      userID: userID,
      productID: productID,
      tempName: tempName
    },
    success: function(response){
      jQuery('#saveConfirm').hide();
    }
  });
}

function openSavedTem(){
  var des_ID = window.location.search,
      des_ID = des_ID.replace('?id=','');
  if(des_ID != ''){
    $.ajax({
      url: "https://homefirst.pk/poker/my-design.php",
      type: "POST",
      data:{
        userID: userID,
        designId: des_ID
      },
      success: function(response){
        jQuery('#pageLoader').show();
        jQuery('#loadTemp').html(response);
        setTimeout(function(){
          loadSavedTemplate();
          jQuery('#pageLoader').hide();
        },300);
      }
    });
  }
}

function loadSavedTemplate(){
  chipStyle = jQuery('#saveChipStyle').text();
  chipColor = jQuery('#saveChipColor').text();
  jQuery('#'+chipStyle).prop('checked',true).change();
  jQuery('input[name="pro_color"]#'+chipColor).prop('checked',true).change();
  num = 1;
  loadCanvas(num);
  num = 2;
  loadCanvas(num);
}

function loadCanvas(num){
  canvaBG = jQuery('.save-canvas_'+num+' .saveChipBackground').text();
  window['canv_'+num].backgroundColor = canvaBG;
  window['canv_'+num].renderAll();
  Objects = window['canv_'+num].getObjects();
  Objects.forEach(function(obj){
    objId	= obj.id;
    type	= obj.type;
    objEvent= jQuery('#saved-'+objId+' .event').text();
    console.log(objEvent);
    if(objEvent){
      leftT		= jQuery('.save-canvas_'+num+' #saved-'+objId+' .left').text();
      topT		= jQuery('.save-canvas_'+num+' #saved-'+objId+' .top').text();
      scaleXt	= jQuery('.save-canvas_'+num+' #saved-'+objId+' .scaleX').text();
      scaleYt	= jQuery('.save-canvas_'+num+' #saved-'+objId+' .scaleY').text();
      angleT	= jQuery('.save-canvas_'+num+' #saved-'+objId+' .angle').text();

      obj.setLeft(leftT);
      obj.setTop(topT);
      obj.setScaleY(scaleYt);
      obj.setAngle(angleT);

      if(type === 'image'){
        imageSrc = jQuery('#saved-'+objId+ ' .imgSrc').text();
        obj.setSrc(imageSrc);
      }

      if(type === 'text' || type === 'curvedText'){
        txt		= jQuery('.save-canvas_'+num+' #saved-'+objId+' .txt').text();
        base	= jQuery('.save-canvas_'+num+' #saved-'+objId+' .base').text();
        font	= jQuery('.save-canvas_'+num+' #saved-'+objId+' .font').text();
        fontSize= jQuery('.save-canvas_'+num+' #saved-'+objId+' .fontSize').text();
        bold	= jQuery('.save-canvas_'+num+' #saved-'+objId+' .fontWeight').text();
        italic	= jQuery('.save-canvas_'+num+' #saved-'+objId+' .fontStyle').text();
        
        obj.setText(txt);
        obj.setFill(base);
        obj.setFontFamily(font);
        obj.setFontWeight(bold);
        obj.setFontStyle(italic);
        
        if(type === 'text'){
          underline	= jQuery('.save-canvas_'+num+' #saved-'+objId+' .textDecoration').text();
          txtA		= jQuery('.save-canvas_'+num+' #saved-'+objId+' .textAlign').text();
          obj.setTextDecoration(underline);
          obj.setTextAlign(txtA);
        }
        if(type === 'curvedText'){
          effect   = jQuery('.save-canvas_'+num+' #saved-'+objId+' .effect').text();
          radiusT  = jQuery('.save-canvas_'+num+' #saved-'+objId+' .radius').text();
          spacingT = jQuery('.save-canvas_'+num+' #saved-'+objId+' .spacing').text();
          reverseT = jQuery('.save-canvas_'+num+' #saved-'+objId+' .reverse').text();
          //obj.setEffect(effect);
          obj.setRadius(radiusT)
          obj.setSpacing(spacingT);
          //obj.setReverse(reverseT);
        }
      }
      obj.setScaleX(0);
      window['canv_'+num].renderAll();
      obj.setScaleX(scaleXt);
      window['canv_'+num].renderAll();
    }
  });
}

//We Buy The Things, We Don't Need With The Money We Don't Have To Impress The People We Don't Like!

if(jQuery('.non-custom').length > 0){
  if(!jQuery('.custom-Set').length > 0){
    newImg  = new Image();
    newImg.onload = function(){
      var obj = new fabric.Image(newImg,{
        id: 'obj_'+n,
        left: cSize/2,
        top: cSize/2,
        originX: 'center',
        originY: 'center',
        scaleX: 1,
        scaleY: 1,
        selectable: false,
        evented: false,
        hoverCursor: 'default'
      });
      obj.scaleToWidth(cSize/1.1);
      window['canv_1'].add(obj);
      obj.setCoords();
      window['canv_1'].renderAll();
    };
    jQuery(document).on('click','.non-custom .product-single__thumbnail-image',function(){
      imgSrc = jQuery(this).attr('src');
      if(!jQuery('.custom-Set').length > 0){
        newImg.src = imgSrc;
        window['canv_1'].renderAll();
      }
      var colorTag = jQuery(this).attr('data-tag'),
          colorTag = colorTag.split(', ').pop(),
          colorName = colorTag.replace('color-','');
      jQuery('input[name="pro_color"]#'+colorName).prop('checked',true);
      base = jQuery('input[name="pro_color"]#'+colorName).attr('data-color');
      updateChipColor(base);
    });

    jQuery('.non-custom .product-single__thumbnails').slick({
      slidesToShow: 4,
      slidesToScroll: 1,
      vertical:true,
      prevArrow: '.non-custom .thumbnails-slider__prev',
      nextArrow: '.non-custom .thumbnails-slider__next',
      dots: false,
      focusOnSelect: true,
      verticalSwiping:true,
      responsive: [
        {
          breakpoint: 992,
          settings: {
            vertical: false,
          }
        },
        {
          breakpoint: 768,
          settings: {
            vertical: false,
          }
        },
        {
          breakpoint: 580,
          settings: {
            vertical: false,
            slidesToShow: 3,
          }
        },
        {
          breakpoint: 380,
          settings: {
            vertical: false,
            slidesToShow: 2,
          }
        }
      ]
    });
    jQuery(document).on('click','.non-custom .thumbnails-slider__btn',function(){
      setTimeout(function(){
        jQuery('.non-custom .slick-current .product-single__thumbnail img').trigger('click');
      },120);
    });
  }
}

function isUrlValid(url){
  return /^(https?|s?ftp):\/\/(((([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(%[\da-f]{2})|[!\$&'\(\)\*\+,;=]|:)*@)?(((\d|[1-9]\d|1\d\d|2[0-4]\d|25[0-5])\.(\d|[1-9]\d|1\d\d|2[0-4]\d|25[0-5])\.(\d|[1-9]\d|1\d\d|2[0-4]\d|25[0-5])\.(\d|[1-9]\d|1\d\d|2[0-4]\d|25[0-5]))|((([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])*([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])))\.)+(([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])*([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])))\.?)(:\d*)?)(\/((([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(%[\da-f]{2})|[!\$&'\(\)\*\+,;=]|:|@)+(\/(([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(%[\da-f]{2})|[!\$&'\(\)\*\+,;=]|:|@)*)*)?)?(\?((([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(%[\da-f]{2})|[!\$&'\(\)\*\+,;=]|:|@)|[\uE000-\uF8FF]|\/|\?)*)?(#((([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(%[\da-f]{2})|[!\$&'\(\)\*\+,;=]|:|@)|\/|\?)*)?$/i.test(url);
}